import { gql } from '@apollo/client';

// ==============> LOGIN <================
export const CLIENT_EMAIL_VERIFICATION = gql`
  query ClientEmail($email: String) {
    verifyClientEmail(email: $email)
  }
`;
export const USER_DETAILS = gql`
  query UserByEmail($email: String) {
    userByEmail(email: $email) {
      email
      avatarUrl
    }
  }
`;
export const LOGIN_USER = gql`
  query UserLogin($email: String, $password: String, $recaptcha: String) {
    users(email: $email, password: $password, recaptcha: $recaptcha) {
      id
      email
      role
      name
      type
      phoneNumber
      avatarUrl
      department
      description
      jobTitle
      token
      language {
        code
        name
        nativename
      }
      personalEmail
      address1
      address2
      city
      postcode
      dob
      country {
        code
        label
        phone
      }
    }
  }
`;

export const FORGOT_PASSWORD_LINGUIST = gql`
  query LinguistForgotPswrd($email: String) {
    forgotPassword(email: $email)
  }
`;

export const LOGIN_LINGUIST = gql`
  query LinguistUsers($email: String, $password: String, $recaptcha: String) {
    vendorLogin(email: $email, password: $password, recaptcha: $recaptcha) {
      id
      firstName
      lastName
      email
      type
      token
      avatarUrl
      profileCompletion
      completedSubSteps
      isOnBoardingCompleted
      isOnBoardingStepOneCompleted
      isOnBoardingStepTwoCompleted
    }
  }
`;
export const SEND_EMAIL_VERIFICATION_CODE = gql`
  query SendVerifyEmail($email: String) {
    sendUserVerificationCode(email: $email)
  }
`;
export const VERIFY_USER = gql`
  query VerifyUserEmail($email: String, $authCode: String) {
    verifyUserEmail(email: $email, authCode: $authCode) {
      id
      firstName
      lastName
      email
      profileStatus
      type
      token
      name
      avatarUrl
      image
    }
  }
`;

// ==============> CALENDAR <================

export const ALL_CALENDAR = gql`
  query AllCalendars {
    allCalendar {
      allDay
      end
      id
      projectId
      projectType
      start
      textColor
      title
    }
  }
`;
export const BARZANO_CALENDAR = gql`
  query BarzanoCalendar {
    barzanoCalendar {
      allDay
      end
      id
      projectId
      start
      textColor
      title
      totalPages
    }
  }
`;
export const FORMATTER_PROJECTS_CALENDAR = gql`
  query ProjectsCalender($formatterId: String) {
    projectsCalender(formatterID: $formatterId) {
      id
      title
      start
      textColor
    }
  }
`;
// ==============> TASKS <================
export const ALL__PROJECTS_LIST = gql`
  query GetAllGeneralOrders(
    $offset: Int
    $filterBrand: [String]
    $filterInvoice: [String]
    $filterDeliveryDate: [String]
    $filterStatus: [String]
    $filterCreationDate: [String]
    $filterOrderNo: String
    $filterInvoiceNo: String
    $filterQuoteNo: String
    $limit: Int
    $orderBy: String
    $order: String
    $filterAccountManager: String
    $filterProjectManager: String
    # The client's finance notes are a page of HTML per row and only the
    # billing queue reads them; the orders list asks for them to be left out.
    $includeFinance: Boolean
  ) {
    getAllGeneralOrders(
      offset: $offset
      filterBrand: $filterBrand
      filterInvoice: $filterInvoice
      filterDeliveryDate: $filterDeliveryDate
      filterStatus: $filterStatus
      filterCreationDate: $filterCreationDate
      filterOrderNo: $filterOrderNo
      filterInvoiceNo: $filterInvoiceNo
      filterQuoteNo: $filterQuoteNo
      limit: $limit
      orderBy: $orderBy
      order: $order
      filterAccountManager: $filterAccountManager
      filterProjectManager: $filterProjectManager
      includeFinance: $includeFinance
    )
  }
`;
// Live Stripe payment status for private-client orders on the Finance Billing
// page. Returns JSON: [{ linkId, isPaid, receiptUrl, amount, paidAt }].
export const GET_STRIPE_PAYMENT_STATUSES = gql`
  query GetStripePaymentStatuses($linkIds: [String]) {
    getStripePaymentStatuses(linkIds: $linkIds)
  }
`;
export const ALLTASKS_DETAILS = gql`
  query AllTasks(
    $type: String
    $department: String
    $filterStatus: [String]
    $filterCreationDate: String
    $filterDueDate: String
    $filterName: String
    $filterPerson: String
    $filterPriority: [String]
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
  ) {
    allTasks(
      type: $type
      department: $department
      filterStatus: $filterStatus
      filterCreationDate: $filterCreationDate
      filterDueDate: $filterDueDate
      filterName: $filterName
      filterPerson: $filterPerson
      filterPriority: $filterPriority
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
    ) {
      tasks {
        id
        taskNumber
        name
        summary
        priority
        department
        assignorName {
          name
          email
          avatarUrl
        }
        assigneeName {
          name
          email
          avatarUrl
        }
        additionalAssignee {
          name
          email
          avatarUrl
        }

        createdAtDate
        dueDate
        status
        attachment
      }
      tasksCount {
        filterCount
        totalCount
        doneCount
        pendingCount
        notStartedCount
      }
    }
  }
`;

export const TASK_DETAILS = gql`
  query TaskDetails($taskId: ID) {
    tasks(taskId: $taskId) {
      id
      name
      taskNumber
      summary
      priority
      assignorName {
        name
        email
      }
      assigneeName {
        name
        email
      }
      additionalAssignee {
        name
        email
      }
      createdAtDate
      dueDate
      level
      status
      attachment
    }
  }
`;

export const DELTASKS_DETAILS = gql`
  query DelTaskDetails($deleteTasksId: ID!) {
    deleteTasks(id: $deleteTasksId)
  }
`;

// ==============> COMPANY <================
export const COMPANY_CONTACTS_BOOKEDBY = gql`
  query CompanyContacts($companyId: ID) {
    CompanyContactsBookedBy(companyId: $companyId) {
      firstName
      lastName
      email
    }
  }
`;
// What the AI brochure's create dialog fills in for an existing client.
export const COMPANY_FOR_BROCHURE = gql`
  query CompanyForBrochure($companyId: ID!) {
    company(companyId: $companyId) {
      id
      name
      website
      firstSaleDate
      accountManager {
        name
      }
    }
  }
`;
export const COMPANY_NAMES_AND_IDS = gql`
  query CompanyNamesAndIds($name: String, $accountType: String) {
    companyNamesAndIds(name: $name, accountType: $accountType) {
      id
      name
      accountType
      paymentTerms
      address1
      address2
      city
      postcode
      VAT
      taxCode
    }
  }
`;
// Who an order's invoice is made out to, resolved once on the server
// (lingoserver util/billingParty.js): the account for a business or an
// individual, the contact the order names for the legacy "Private Client"
// pool. The same shape getCompaniesInfo has always handed the invoice form.
export const ORDER_BILLING_PARTY = gql`
  query OrderBillingParty($kind: String!, $orderId: ID!) {
    orderBillingParty(kind: $kind, orderId: $orderId) {
      source
      accountType
      accountId
      contactId
      name
      VAT
      taxCode
      brand
      generalEmail
      pecEmail
      email
      phone
      address
      address1
      address2
      city
      postcode
      country {
        code
        label
        phone
      }
      state {
        code
        province
        region
      }
      SDIcode
      paymentTerms
      stage
    }
  }
`;
export const COMPANY_TOTAL_SALES = gql`
  query CompanyTotalSalesFilter($id: String, $year: String) {
    companyTotalSalesFilter(id: $id, year: $year)
  }
`;
export const COMPANY_MONTHLY_SALES = gql`
  query CompanySalesPerMonth($id: String, $year: String) {
    companySalesPerMonth(id: $id, year: $year)
  }
`;
export const COMPANY_QUOTES_COUNT = gql`
  query CompanyOrders($id: String) {
    companyOrders(id: $id) {
      sentToPM
      quoteOpen
      quoteClosed
    }
  }
`;
// Lightweight read of a client's finance notes, used by the "Send to PM" flow
// so the account manager can append a note to the client's finance record.
export const COMPANY_FINANCE_NOTES = gql`
  query CompanyFinanceNotes($companyId: ID!) {
    company(companyId: $companyId) {
      id
      financeNotes
    }
  }
`;
export const COMPANY_DETAILS = gql`
  query Companies($companyId: ID!) {
    company(companyId: $companyId) {
      name
      id
      accountType
      firstName
      lastName
      primaryContactId
      legacyPrivateClientPool
      legacyPrivateClientPoolClosedAt
      industry {
        code
        name
      }
      website
      VAT
      taxCode
      SDIcode
      generalEmail
      brand
      pecEmail
      turnover
      currentCreditScore
      previousCreditScore
      accountManager {
        name
        email
      }
      businessDeveloper {
        name
        email
      }
      generalPhone
      stage
      address1
      address2
      city
      postcode
      country {
        code
        label
        phone
      }
      state {
        code
        province
        region
      }
      createdAtDate
      estimatedBudget
      segment

      paymentTerms
      # What this client pays per hour of mediation: the CI-MC consuntivo
      # multiplies it by the mediators' validated hours.
      mediationHourlyRate
      marketingChannel {
        source
        sourceDetails {
          utm
          ppcSource
          cpn
          gad_source
          adgroup
          kwid
          campaignGclid
          keywords
        }
      }
      companyNumber
      notes
      pmNotes
      linguistNotes
      financeNotes
      followUp
      testimonial
      kpi
      currentYearSales
      previousYearSales
      lastOrderDate
      qualityCasesCount
      qualityScore
      tier
      serviceLevel
      leadSource
      totalSales
      allTimeTotalProjects
      clientHistory
      conversionRate
      firstSaleDate
      healthScore
      lastQuoteDate
    }
  }
`;

export const CUSTOMER_LIST = gql`
  query AllCustomerList(
    $filterLeadSource: String
    $filterStage: [String]
    $filterBrand: [String]
    $filterName: String
    $filterCreationDate: [String]
    $filterFollowUpDate: [String]
    $filterLevel: String
    $segment: String
    $filterCountry: String
    $industry: String
    $filterAccountManager: String
    $filterClientHistory: String
    $filterBusinessDeveloper: String
    $filterAccountType: String
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
  ) {
    customerList(
      filterLeadSource: $filterLeadSource
      filterStage: $filterStage
      filterBrand: $filterBrand
      filterName: $filterName
      filterCreationDate: $filterCreationDate
      filterFollowUpDate: $filterFollowUpDate
      filterLevel: $filterLevel
      segment: $segment
      filterCountry: $filterCountry
      filterAccountManager: $filterAccountManager
      filterBusinessDeveloper: $filterBusinessDeveloper
      industry: $industry
      filterClientHistory: $filterClientHistory
      filterAccountType: $filterAccountType
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
    ) {
      id
      companyNumber
      accountType
      firstName
      lastName
      generalEmail
      legacyPrivateClientPool
      totalSales
      name
      followUp
      brand
      turnover
      website
      segment
      accountManager {
        name
        email
      }
      businessDeveloper {
        name
        email
      }
      stage
      createdAtDate
      industry {
        code
        name
      }
      serviceLevel
      address1
      city
      postcode
      firstSaleDate
      state {
        code
        province
        region
      }
      country {
        label
      }
      currentYearSales
      previousYearSales
      lastOrderDate
      lastQuoteDate
      clientHistory
      conversionRate
      qualityScore
      allTimeTotalProjects
      qualityCasesCount
      healthScore
      kpi
    }
    customerListStats(
      filterLeadSource: $filterLeadSource
      filterStage: $filterStage
      filterBrand: $filterBrand
      filterName: $filterName
      filterCreationDate: $filterCreationDate
      filterFollowUpDate: $filterFollowUpDate
      filterLevel: $filterLevel
      segment: $segment
      filterCountry: $filterCountry
      filterAccountManager: $filterAccountManager
      filterBusinessDeveloper: $filterBusinessDeveloper
      industry: $industry
      filterClientHistory: $filterClientHistory
      filterAccountType: $filterAccountType
    ) {
      atRiskClientsCount
      filterCount
      businessCount
      individualCount
      belowKpiTargetCount
      noContactThirtyDaysCount
      healthyClientsCount
    }
  }
`;

export const PROSPECTS_LIST = gql`
  query AllProspects(
    $filterLeadSource: String
    $filterStage: [String]
    $filterBrand: [String]
    $filterName: String
    $filterCreationDate: [String]
    $filterFollowUpDate: [String]
    $filterLevel: String
    $tier: String
    $filterCountry: String
    $industry: String
    $filterAccountManager: String
    $filterBusinessDeveloper: String
    $filterAccountType: String
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
  ) {
    prospectList(
      filterLeadSource: $filterLeadSource
      filterStage: $filterStage
      filterBrand: $filterBrand
      filterName: $filterName
      filterCreationDate: $filterCreationDate
      filterFollowUpDate: $filterFollowUpDate
      filterLevel: $filterLevel
      tier: $tier
      filterCountry: $filterCountry
      filterAccountManager: $filterAccountManager
      filterBusinessDeveloper: $filterBusinessDeveloper
      industry: $industry
      filterAccountType: $filterAccountType
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
    ) {
      companies {
        id
        companyNumber
        accountType
        firstName
        lastName
        generalEmail
        legacyPrivateClientPool
        totalSales
        name
        followUp
        brand
        turnover
        website
        tier
        accountManager {
          name
          email
        }
        businessDeveloper {
          name
          email
        }
        stage
        createdAtDate
        industry {
          code
          name
        }
        address1
        city
        postcode

        state {
          code
          province
          region
        }
        country {
          label
        }
        currentYearSales
        previousYearSales
        lastOrderDate
        conversionRate
        qualityScore
        kpi
      }
      companiesCount {
        filterCount
        totalCount
        businessCount
        individualCount
        leadCount
        prospectCount
        customerCount
        overdueFollowUpsCount
        atRiskClientsCount
        noRevenueIn90DaysCount
      }
    }
  }
`;

export const AM_PORTFOLIO = gql`
  query AllCompanies(
    $filterLeadSource: String
    $filterStage: [String]
    $filterBrand: [String]
    $filterName: String
    $filterCreationDate: [String]
    $filterFollowUpDate: [String]
    $filterLevel: String
    $filterCountry: String
    $industry: String
    $filterAccountManager: String
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
  ) {
    AMPortfolio(
      filterLeadSource: $filterLeadSource
      filterStage: $filterStage
      filterBrand: $filterBrand
      filterName: $filterName
      filterCreationDate: $filterCreationDate
      filterFollowUpDate: $filterFollowUpDate
      filterLevel: $filterLevel
      filterCountry: $filterCountry
      filterAccountManager: $filterAccountManager
      industry: $industry
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
    ) {
      companies {
        id
        companyNumber
        totalSales
        name
        followUp
        brand
        turnover
        website

        accountManager {
          name
          email
        }
        stage
        createdAtDate
        industry {
          code
          name
        }
        serviceLevel
        address1
        city
        postcode
        firstSaleDate
        firstOrderDate
        state {
          code
          province
          region
        }
        country {
          label
        }
        currentYearSales
        previousYearSales
        lastOrderDate
      }
      companiesCount {
        filterCount
        totalCount
        leadCount
        prospectCount
        customerCount
        overdueFollowUpsCount
        atRiskClientsCount
        noRevenueIn90DaysCount
      }
    }
  }
`;
export const DEL_COMPANIES = gql`
  query DelCompany($deleteCompaniesId: ID!) {
    deleteCompanies(id: $deleteCompaniesId)
  }
`;

// ==============> COMPANY CONTACTS <================
export const VERIFY_COMPANY_CONTACT = gql`
  query VerifyCompanyContact($email: String) {
    verifyCompanyContact(email: $email)
  }
`;

export const ALL_COMPANY_CONTACTS = gql`
  query AllCompanyContacts {
    allCompanyContacts {
      address1
      address2
      city
      companyId
      country {
        code
        label
        phone
      }
      createdAtDate
      email
      firstName
      gender
      id
      lastName
      phone
      postcode
      role
      status
    }
  }
`;
export const DELETE_COMPANY_CONTACT = gql`
  query deleteContact($deleteCompanyContactId: String) {
    deleteCompanyContacts(id: $deleteCompanyContactId)
  }
`;
export const COMPANY_CONTACTS = gql`
  query CompanyContacts(
    $companyId: ID
    $excludeContactId: ID
    $contact: String
    $offset: Int
    $limit: Int
  ) {
    CompanyContacts(
      companyId: $companyId
      excludeContactId: $excludeContactId
      contact: $contact
      limit: $limit
      offset: $offset
    ) {
      allContactsCount
      companyContacts {
        address1
        address2
        city
        companyId
        state {
          code
          province
          region
        }
        country {
          code
          label
          phone
        }
        createdAtDate
        email
        firstName
        gender
        id
        lastName
        phone
        postCode
        role
        status
        jobTitle
        taxCode
        isAccountRegistered
      }
    }
  }
`;

// ==============> EXPENSE ALLOCATION <================

export const ALL_EXPENSE_ALLOCATIONS = gql`
  query AllExpenseAllocations($projectId: ID) {
    ExpenseAllocations(projectId: $projectId) {
      id
      price
      projectId
      quantity
      service
      total
      title
      type
      endDateTime
      file
      technician {
        id
        firstName
        lastName
        email
      }
      formatter {
        id
        firstName
        lastName
        email
      }
      technicianNotes
      notes
      status
      locationContact {
        fullName
        email
        phone
      }
      serviceProvided
      startDateTime
      endDateTime
      expectedReturnAt
      sentBackCount
      prepFileName
      prepFileNames
      completionDate
    }
  }
`;

// Word templates for file preparation (step 2, route "template").
export const WORD_TEMPLATES = gql`
  query WordTemplates($documentType: String, $sourceLanguage: String) {
    wordTemplates(
      documentType: $documentType
      sourceLanguage: $sourceLanguage
    ) {
      id
      name
      documentType
      fileName
      size
      sourceLanguage
      targetLanguages
      notes
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`;

export const LIST_EXPENSE_ALLOCATIONS = gql`
  query AllExpenseAllocations($projectId: [String]) {
    allExpenseAllocations(projectId: $projectId) {
      id
      price
      projectId
      quantity
      service
      total
      title
      type
    }
  }
`;

// ==============> LINGUIST ALLOCATION <================

export const ALL_LINGUIST_ALLOCATIONS = gql`
  query LinguistAllocations($projectId: ID!) {
    LinguistAllocations(projectId: $projectId) {
      id
      total
      creationDate
      deliveryDateTime
      email
      tradosEmail
      status
      item_id
      firstName
      lastName
      gender
      phone
      ratePerWord
      notes
      ratePerHour
      ratePerAdditionalHour
      # AG-01: il compenso del servizio e il rimborso spese, separati.
      serviceTotal
      expenseReimbursement
      expenseNote
      startDateTime
      endDateTime
      sourceLanguage
      targetLanguage
      contactMethod
      dob
      mainLanguage
      otherLanguage
      newWords
      country
      city
      linguistId
      iban
      resume
      projectId
      atlasUserId
      negotiatedDeliveryDateTime
      acceptedDateTime
      allocatedDateTime
      negotiatedRatePerWord
      negotiatedTotal
      negotiatedRatePerAdditionalHour
      negotiatedRatePerHour
      negotiatedExpenseReimbursement
      linguistDeliveryDate
      checkInAt
      checkOutAt
      refusalReason
      clientHoursReview {
        status
        confirmedStart
        confirmedEnd
        note
        reviewedBy
        reviewedAt
      }
      hoursValidation {
        validatedStart
        validatedEnd
        billableHours
        plannedHours
        extraHours
        additionalRate
        validatedBy
        validatedAt
        note
      }
      # The validations the current one replaced, oldest first (CI-MC hours,
      # RF-AL-12): the validation dialog lists them.
      hoursValidationHistory {
        revision
        validatedStart
        validatedEnd
        billableHours
        validatedBy
        validatedAt
        supersededBy
        supersededAt
        supersededReason
      }
      # The service was called off after this person was confirmed: what is
      # still owed, and on what notice (CI-MC).
      cancellation {
        at
        noticeDays
        pct
        proposedPct
        base
        amount
        reason
        by
      }
      pmFeedback {
        deliveryCompliance
        communicationAndAvailability
        layoutAndFormating
      }
      prFeedback {
        accuracyTranslation
        grammerSpelling
        technicalTerminology
      }
      categories
      acceptedDateTime
    }
  }
`;
export const LIST_LINGUIST_ALLOCATIONS = gql`
  query AllLinguistAllocations($projectId: [String]) {
    allLinguistAllocations(projectId: $projectId) {
      id
      total
      linguistId
      projectId
    }
  }
`;

export const DELETE_ALLOCATION = gql`
  query DelAllocation(
    $deleteAllocationId: ID!
    $allocationEmail: allocationEmail
  ) {
    deleteAllocation(id: $deleteAllocationId, allocationEmail: $allocationEmail)
  }
`;
export const DELETE_EXPENSE = gql`
  query DeleteExpenseAllocations($deleteExpenseAllocationsId: ID!) {
    deleteExpenseAllocations(id: $deleteExpenseAllocationsId)
  }
`;

export const LINGUIST_RESPONSE = gql`
  query singleAllocation($singleAllocationId: ID!) {
    singleAllocation(id: $singleAllocationId) {
      firstName
      lastName
      ratePerWord
      linguistId
      ratePerHour
      status
      deliveryDateTime
      sourceLanguage
      targetLanguage
      startDateTime
      endDateTime
      ratePerAdditionalHour
      # AG-01: il compenso del servizio e il rimborso spese, separati.
      serviceTotal
      expenseReimbursement
      expenseNote
      orderNumber
      projectManager
      email
      notes
      projectId
      id
      total
      projectType
      newWords
      categories
      prFeedback {
        accuracyTranslation
        grammerSpelling
        technicalTerminology
      }
      pmFeedback {
        communicationAndAvailability
        deliveryCompliance
        layoutAndFormating
      }
    }
  }
`;
export const LINGUIST_ALLOCATION_BY_ID = gql`
  query linguistAllocationById($singleAllocationId: ID!, $email: String!) {
    singleAllocation(id: $singleAllocationId) {
      firstName
      lastName
      ratePerWord
      linguistId
      ratePerHour
      status
      deliveryDateTime
      sourceLanguage
      targetLanguage
      startDateTime
      endDateTime
      ratePerAdditionalHour
      # AG-01: il compenso del servizio e il rimborso spese, separati.
      serviceTotal
      expenseReimbursement
      expenseNote
      orderNumber
      projectManager
      email
      notes
      projectId
      id
      total
      projectType
      newWords
      phone
      otherLanguage
      negotiatedTotal
      negotiatedRatePerWord
      negotiatedRatePerHour
      negotiatedRatePerAdditionalHour
      negotiatedExpenseReimbursement
      negotiatedDeliveryDateTime
      mainLanguage
      linguistDeliveryDate
      gender
      dob
      creationDate
      completionDate
      country
      city
      prFeedback {
        accuracyTranslation
        grammerSpelling
        technicalTerminology
      }
      pmFeedback {
        communicationAndAvailability
        deliveryCompliance
        layoutAndFormating
      }
      feedbackBZ {
        deliveryCompliance
        communicationAndAvailability
        layoutAndFormating
        translationAccuracy
        tmManagement
      }
      feedbackCI {
        quality
        ethicalStandards
        costEffective
        communication
        timeliness
      }
    }
    getUserData(email: $email) {
      firstName
      lastName
      image
      email
      resume
      dob
      phone
      mainLanguage
      otherLanguage
      country
      address1
      city
      postal
      country
    }
  }
`;
export const PR_RESPONSE = gql`
  query singlePRAllocation($singleAllocationId: ID!) {
    singlePRAllocation(id: $singleAllocationId) {
      firstName
      lastName
      ratePerWord
      linguistId
      ratePerHour
      status
      deliveryDateTime
      sourceLanguage
      targetLanguage
      startDateTime
      endDateTime
      ratePerAdditionalHour
      orderNumber
      projectManager
      email
      notes
      projectId
      id
      total
      projectType
      newWords
    }
  }
`;
// ==============> USERS <================
export const MANAGERS_LIST = gql`
  query ManagersList($department: String) {
    managersList(department: $department) {
      id
      email
      name
      jobTitle
      phoneNumber
      avatarUrl
      language {
        code
        name
        nativename
      }
    }
  }
`;
export const ALL_TECHNICIANS = gql`
  query allTechnicians {
    allTechnicians {
      firstName
      lastName
    }
  }
`;
export const ALL_USERS_DETAILS = gql`
  query allUsers {
    allUsers {
      id
      email
      name
      jobTitle
      phoneNumber
      avatarUrl
      language {
        code
        name
        nativename
      }
    }
  }
`;
export const PROJECT_MANAGERS_LIST = gql`
  query allUsers {
    allUsers {
      name
    }
  }
`;

export const ALL_CARDS_DETAILS = gql`
  query allUsers {
    allUsers {
      id
      email
      role
      name
      phoneNumber
      avatarUrl
      department
      description
      jobTitle
      status
    }
  }
`;

// ==============> INTERPRETATION PROJECT <================
export const INTERPRETATION_SERVICE = gql`
  query ServiceInterpretation {
    serviceInterpretation {
      serviceItems {
        Code
        InvCode
        Description {
          italian
          english
        }
        Service {
          italian
          english
        }
      }
      addService {
        Code
        InvCode
        Description {
          italian
          english
        }
        Service {
          italian
          english
        }
      }
    }
  }
`;
export const INTERPRETATION_PROJECT_DETAILS = gql`
  query InterpretationOrder($interpretationOrderId: ID!) {
    interpretationOrder(interpretationOrderId: $interpretationOrderId) {
      id
      orderNumber
      taxes
      totalDiscount
      grandTotal
      netTotal
      quoteNumber
      isBillingCompleted
      businessDeveloper
      quoteId
      industry {
        code
        name
      }
      companyNameAndId {
          accountType
        id
        name
        id
        name
        paymentTerms
        address1
        address2
        city
        postcode
        VAT
      }
      projectManager {
        name
        email
        avatarUrl
      }
      accountManager {
        name
        email
        avatarUrl
      }
      address1
      interpretationItem {
        discount
        item_id
        isPreBookingSent
        isBookingSent
        remainingBookingSlots
        # How many interpreters the booth needs when that is not the figure
        # sold (report 05/10/2026, §7); null means "the sold quantity".
        interpretersWanted
        # The consuntivo of the row, written from the validated allocations
        # (specifica PM AG-02): what was actually served, beside the request
        # above, which stays the client's and is never written from it.
        validatedPersonHours
        validatedCount
        validatedExpected
        validatedState
        validatedWindowsDiffer
        validatedStart
        validatedEnd
        sourceLanguage {
          code
          name
          nativename
        }
        targetLanguage {
          code
          name
          nativename
        }
        service {
          Code
          InvCode
          Description {
            italian
            english
          }
          Service {
            italian
            english
          }
        }
        title
        quantity
        price
        total
        timezone
        type
        startDateTime
        endDateTime
      }
      subtotal
      subject
      address2
      postCode
      city
      country {
        code
        label
        phone
      }
      bookedBy {
        firstName
        lastName
        email
      }
      status
      stage
      completionDate
      margin
      addOns {
        remoteEventAddress
      }
      counterpart {
        id
        stage
        orderNumber
        status
      }
      financialsSealedAt
      financialsSealedBy {
        name
      }
      sealedMargin
      sealedSnapshot
      briefingSentAt
      briefingSentBy {
        id
        name
      }
      clientFeedbackSentAt
      clientFeedbackSentBy {
        id
        name
      }
      sealHistory
      is_urgent
      supportMaterialLink
      createdAtDate
      startDate
      endDate
      notes
      pmNotes
      serviceSubtotal
      additionalService {
        title
        startDateTime
        endDateTime
        price
        discount

        quantity
        service {
          Code
          InvCode
          Description {
            italian
            english
          }
          Service {
            italian
            english
          }
        }
        serviceTotal
      }
    }
  }
`;

export const TECHNICIAN_SHEET = gql`
  query TechnicianExpenseById($expenseId: ID) {
    technicianExpenseById(expenseId: $expenseId) {
      expenseDetail {
        id
        title
        status
        service
        total
        technicianNotes
        startDateTime
        endDateTime
        locationContact {
          fullName
          phone
          email
        }
        serviceProvided
      }
      project {
        id
        projectManager {
          name
        }
        orderNumber
        bookedBy {
          firstName
          lastName
        }
        companyNameAndId {
          accountType
          name
        }
        address1
        address2
        city
        country {
          label
        }

        interpretationItem {
          startDateTime
          endDateTime
          title
        }
      }
      linguists {
        firstName
        lastName
        mainLanguage
        otherLanguage
        phone
        email
        sourceLanguage
        targetLanguage
      }
    }
  }
`;

//==================> BROCHURE =============================>
export const BROCHURE_DETAILS = gql`
  query brochure($brochureId: ID!) {
    brochure(brochureId: $brochureId) {
      id
      brochureNumber
      companyLogo
      clients {
        name
        logo
      }
      industry {
        code
        name
      }
      companyNameAndId {
          accountType
        id
        name
        paymentTerms
        address1
        address2
        city
        postcode
        VAT
      }
      accountManager {
        name
        email
        phoneNumber
        jobTitle
        avatarUrl
        language {
          code
          name
          nativename
        }
      }
      address1

      bookedBy {
        firstName
        lastName
        email
      }
      quote
      createdAtDate
      # joined live from the company, so the record can say whether the
      # brochure is going to a client or to a prospect
      companyStage
    }
  }
`;
// A client's brochures, newest first: the composer on the client's page
// gives a business-development template the link of the brochure of its
// own family (emailVariables.js, brochureForTemplate).
export const BROCHURES_OF_COMPANY = gql`
  query BrochuresOfCompany($companyId: ID!) {
    brochuresOfCompany(companyId: $companyId) {
      id
      brochureNumber
      quote
      createdAtDate
    }
  }
`;
export const ALL_BROCHURE_DETAILS = gql`
  query AllBrochures(
    $filterStatus: [String]
    $filterNumber: String
    $filterCreationDate: [String]
    $filterAccountManager: String
    $filterIndustry: [String]
    $limit: Int
    $offset: Int
    $order: String
    $orderBy: String
  ) {
    allBrochures(
      filterStatus: $filterStatus
      filterNumber: $filterNumber
      filterCreationDate: $filterCreationDate
      filterAccountManager: $filterAccountManager
      filterIndustry: $filterIndustry
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
    ) {
      brochures {
        id
        brochureNumber
        companyNameAndId {
          accountType
          id
          name
        }
        accountManager {
          name
          email
        }
        bookedBy {
          firstName
          lastName
        }
        quote
        createdAtDate
        address1
        # Set on all 5 120 records and never shown until the 07/09 pass: it is
        # what the template personalises its cover and its letter with.
        industry {
          name
        }
        # How many logos the template will print (nine at most).
        clients {
          name
        }
      }
      brochuresCount {
        filterCount
        # The size of the catalogue, under none of the filters, and the count
        # per family under every filter BUT the family one — so each option of
        # that filter stays a switch and the header's sentence does not move
        # as the page is filtered.
        totalCount
        familyCounts {
          key
          count
        }
      }
    }
  }
`;
export const GET_INTERPRETATION_BY_ID = gql`
  query InterpretationOrder($interpretationOrderId: ID!) {
    interpretationOrder(interpretationOrderId: $interpretationOrderId) {
      id
      orderNumber
      address1
      subject
      address2
      businessDeveloper
      postCode
      city
      country {
        code
        label
        phone
      }
      notes
    }
  }
`;

// Vendor-side mirror of GET_INTERPRETATION_BY_ID for CI-MC (mediation is the
// interpretation clone — same fields, mediationorders collection).
export const GET_MEDIATION_ORDER_BY_ID = gql`
  query MediationOrderForVendor($mediationOrderId: ID!) {
    mediationOrder(mediationOrderId: $mediationOrderId) {
      id
      orderNumber
      address1
      subject
      address2
      businessDeveloper
      postCode
      city
      country {
        code
        label
        phone
      }
      notes
    }
  }
`;

export const ALL_INTERPRETATION_PROJECT_DETAILS = gql`
  query AllInterpretationOrders(
    $filterStatus: [String]
    $filterNumber: String
    $filterCreationDate: [String]
    $filterStartDate: [String]
    $filterProjectManager: String
    $openSlots: Boolean
    $limit: Int
    $offset: Int
    $order: String
    $orderBy: String
  ) {
    allInterpretationOrders(
      filterStatus: $filterStatus
      filterNumber: $filterNumber
      filterCreationDate: $filterCreationDate
      filterStartDate: $filterStartDate
      filterProjectManager: $filterProjectManager
      openSlots: $openSlots
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
    ) {
      interpretationOrders {
        id
        netTotal
        orderNumber
        margin
        companyNameAndId {
          accountType
          id
          name
        }
        projectManager {
          name
          email
        }
        bookedBy {
          firstName
          lastName
        }
        interpretationItem {
          sourceLanguage {
            code
            name
            nativename
          }
          quantity
          targetLanguage {
            code
            name
            nativename
          }
        }
        status
        createdAtDate
        startDate
        address1
        address2
        subtotal
        postCode
        country {
          code
          label
          phone
        }
        additionalService {
          price
          title
          quantity
          discount
        }
        stage
        is_urgent
        quoteNumber
        isBillingCompleted
        completionDate
        # The quote this project came from, and where that quote still thinks it
        # is. The two drift: 57 quotes read "Quote-Won" over a delivered
        # project, 4 read "Quote-Open" over work already claimed.
        counterpart {
          id
          stage
          orderNumber
          status
          createdAtDateTime
        }
      }
      interpretationOrderCount {
        totalCount
        filterCount
        deliveredCount
        allocatedCount
        claimedCount
      }
    }
  }
`;

export const DEL_INTERPRETATION_PROJECT_DETAILS = gql`
  query DelInterpretProject($deleteInterpretationOrdersId: ID!) {
    deleteInterpretationOrders(id: $deleteInterpretationOrdersId)
  }
`;
export const INTERPRETATION_QUOTE_DETAILS = gql`
  query InterpretationOrder($interpretationOrderId: ID!) {
    interpretationOrder(interpretationOrderId: $interpretationOrderId) {
      id
      orderNumber
      language
      optionsTitles
      businessDeveloper
      upSellingServices
      marketingChannel {
        type
        details {
          source
          sourceDetails {
            utm
            campaignGclid
            ppcSource
            cpn
            gad_source
            adgroup
            kwid
            keywords
          }
        }
      }
      companyLogo
      totalDiscount
      quoteSignature
      reasonForClosure
      # What became of this quote: the project it was handed over as, and where
      # that project's own work stands.
      counterpart {
        id
        stage
        orderNumber
        status
        createdAtDateTime
      }
      grandTotal
      netTotal
      optionSelected
      taxesOptions
      totalDiscountOptions
      netTotalOptions
      grandTotalOptions
      subtotalOptions
      industry {
        code
        name
      }
      companyNameAndId {
          accountType
        id
        name
        paymentTerms
        address1
        address2
        city
        postcode
        VAT
      }
      accountManager {
        name
        email
        phoneNumber
        jobTitle
        avatarUrl
        language {
          code
          name
          nativename
        }
      }
      address1
      taxes
      itemTitles {
        title
        before_item_id
        type
        after_item_id
        position
      }
      itemTitles2 {
        title
        before_item_id
        type
        after_item_id
        position
      }
      interpretationItem {
        sourceLanguage {
          code
          name
          nativename
        }
        targetLanguage {
          code
          name
          nativename
        }
        service {
          Code
          InvCode
          Description {
            italian
            english
          }
          Service {
            italian
            english
          }
        }
        discount
        title
        quantity
        price
        total
        timezone
        type
        startDateTime
        endDateTime
      }
      interpretationItem2 {
        sourceLanguage {
          code
          name
          nativename
        }
        targetLanguage {
          code
          name
          nativename
        }
        service {
          Code
          InvCode
          Description {
            italian
            english
          }
          Service {
            italian
            english
          }
        }
        discount
        title
        quantity
        price
        total
        timezone
        type
        startDateTime
        endDateTime
      }
      subtotal
      subject
      address2
      postCode
      city
      country {
        code
        label
        phone
      }
      bookedBy {
        firstName
        lastName
        email
      }
      status
      supportMaterialLink
      createdAtDate
      startDate
      endDate
      # Derived from the communication history: the record itself stores no send
      # date, so this is the only way to tell "sent and waiting" from "never
      # actually sent".
      lastSentAt
      sentCount
      sentLanguages
      notes
      notesOptions
      pmNotes
      eventInformation
      quoteDeadline
      followUpDate
      serviceSubtotal
      additionalService {
        title
        price
        quantity
        startDateTime
        endDateTime
        discount
        service {
          Code
          InvCode
          Description {
            italian
            english
          }
          Service {
            italian
            english
          }
        }
        serviceTotal
      }
      additionalService2 {
        title
        price
        quantity
        startDateTime
        endDateTime
        discount
        service {
          Code
          InvCode
          Description {
            italian
            english
          }
          Service {
            italian
            english
          }
        }
        serviceTotal
      }
      addOns {
        cover
        quoteInfo
        packages
        upSellingServices
        companyInfo
        noOfEvents
        handleEvent
        hostessService
        location
        friendly
        sector
        remoteEventAddress
        aiPackage
        interpreterPackage
        contents
        innovation
        services
        interpreter
        hardware
        interpreterAndEquipPackage
      }
      defaultPkgName
      brand {
        rafiky
        interpretation
      }
      defaultPkg
      clients {
        name
        logo
      }
      businessDeveloper
      pkgsPriceVar {
        basicDiscount
        economyDiscount
        professionalDiscount
        premiumDiscount
      }
    }
  }
`;
export const ALL_QUOTES_MARKETING_REPORTS = gql`
  query QuotesMarketingReports($creationDate: [String], $filterBrand: String) {
    quotesMarketingReports(
      filterBrand: $filterBrand
      creationDate: $creationDate
    ) {
      status
      marketingChannel
    }
  }
`;
export const ALL_QUOTES_DETAILS = gql`
  query AllQuoteOrders(
    $filterStatus: [String]
    $filterCreationDate: [String]
    $filterQuoteSource: [String]
    $filterBrand: [String]
    $filterAccountManager: String
    $limit: Int
    $offset: Int
    $order: String
    $orderBy: String
  ) {
    allQuoteOrders(
      filterStatus: $filterStatus
      filterCreationDate: $filterCreationDate
      filterQuoteSource: $filterQuoteSource
      filterBrand: $filterBrand
      filterAccountManager: $filterAccountManager
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
    ) {
      orders {
        id
        orderNumber
        marketingChannel
        companyName
        companyAccountType
        bookedBy
        createdAtDate
        createdAtDateTime
        orderType
        netTotal
        status
        accountManagerName
      }
      ordersCount
      filteredTotals {
        totalQuotes
        convertedQuotes
        filteredNetTotal
        filteredConvertedTotal
      }
    }
  }
`;
// Who the quote list can be filtered by, taken from the quotes themselves.
// Five of the eleven account managers on file have left the company and
// between them own more than half the archive, so the employee roster is the
// wrong source: a picker fed by it cannot reach their work at all.
export const INTERPRETATION_QUOTE_OWNERS = gql`
  query InterpretationQuoteOwners {
    interpretationQuoteOwners {
      accountManagers {
        name
        count
        live
      }
      businessDevelopers {
        name
        count
        live
      }
    }
  }
`;
// THE INTERPRETING QUOTE LIST.
//
// Every filter of the view is sent in full on every request, so the server
// never falls back to a default of its own and the URL is the single source of
// truth for what the reader is looking at. See the server resolver for what the
// unfamiliar ones mean: filterMode is a set of service Codes, filterDelivery is
// on-site vs remote, filterSent is measured against the communication history.
export const ALL_INTERPRETATION_QUOTE_DETAILS = gql`
  query AllInterpretationQuoteOrders(
    $filterStatus: [String]
    $filterNumber: String
    $filterCreationDate: [String]
    $filterStartDate: [String]
    $filterFollowUpDate: [String]
    $filterAccountManager: String
    $businessDeveloper: String
    $filterMode: [String]
    $filterDelivery: String
    $filterSourceLanguage: [String]
    $filterTargetLanguage: [String]
    $filterBrand: [String]
    $filterValueMin: Float
    $filterValueMax: Float
    $filterSent: String
    $filterLastSentDate: [String]
    $filterCompany: String
    $needsAttention: Boolean
    $followUpDue: Boolean
    $highValueQuote: Boolean
    $deadlinePassed: Boolean
    $limit: Int
    $offset: Int
    $order: String
    $orderBy: String
  ) {
    allInterpretationQuoteOrders(
      filterStatus: $filterStatus
      filterNumber: $filterNumber
      filterCreationDate: $filterCreationDate
      filterStartDate: $filterStartDate
      filterFollowUpDate: $filterFollowUpDate
      filterAccountManager: $filterAccountManager
      businessDeveloper: $businessDeveloper
      filterMode: $filterMode
      filterDelivery: $filterDelivery
      filterSourceLanguage: $filterSourceLanguage
      filterTargetLanguage: $filterTargetLanguage
      filterBrand: $filterBrand
      filterValueMin: $filterValueMin
      filterValueMax: $filterValueMax
      filterSent: $filterSent
      filterLastSentDate: $filterLastSentDate
      filterCompany: $filterCompany
      needsAttention: $needsAttention
      followUpDue: $followUpDue
      highValueQuote: $highValueQuote
      deadlinePassed: $deadlinePassed
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
    ) {
      interpretationOrders {
        id
        orderNumber
        netTotal
        grandTotal
        status
        subject
        createdAtDate
        createdAtDateTime
        startDate
        endDate
        followUpDate
        quoteDeadline
        lastSentAt
        sentCount
        needsAttention
        pmNotes
        notes
        utm
        campaignGclid
        reasonForClosure
        source
        address1
        address2
        city
        postCode
        stage
        subtotal
        # What became of the quote. Shown as a subordinate trail under the
        # state, never as a state: a project's vocabulary must not appear among
        # the quote states in the column, the filter or the tiles.
        counterpart {
          id
          stage
          orderNumber
          status
          createdAtDateTime
        }
        companyNameAndId {
          accountType
          id
          name
        }
        accountManager {
          name
          email
        }
        businessDeveloper
        bookedBy {
          firstName
          lastName
          email
        }
        brand {
          interpretation
          rafiky
        }
        addOns {
          remoteEventAddress
        }
        country {
          code
          label
          phone
        }
        interpretationItem {
          type
          quantity
          startDateTime
          endDateTime
          service {
            Code
          }
          sourceLanguage {
            code
            name
          }
          targetLanguage {
            code
            name
          }
        }
      }
      interpretationOrderCount {
        filterCount
        TBSCount
        openCount
        closedCount
        totalCount
        awardedCount
        wonCount
        sentToPMCount
        filteredValue
        attentionCount
        # One row per status over every filter but the status one: the
        # count and the net value under each cell of the pipeline strip.
        statusCounts {
          status
          count
          value
        }
      }
    }
  }
`;
export const INTERPRETATION_QUOTE_EMAIL = gql`
  query quoteInterpretationEmail(
    $language: String
    $subject: String
    $email: String
    $body: String
    $quoteEmailId: ID
    $managerName: String
    $jobTitle: String
    $phoneNumber: String
    $description: String
  ) {
    quoteInterpretationEmail(
      language: $language
      subject: $subject
      email: $email
      body: $body
      id: $quoteEmailId
      managerName: $managerName
      jobTitle: $jobTitle
      phoneNumber: $phoneNumber
      description: $description
    ) {
      id
      orderNumber
      quoteDeadline
      totalDiscount
      netTotal
      grandTotal
      industry {
        code
        name
      }
      companyNameAndId {
          accountType
        id
        name
      }
      accountManager {
        name
        email
        avatarUrl
        phoneNumber
        jobTitle
      }
      address1
      taxes
      interpretationItem {
        sourceLanguage {
          code
          name
          nativename
        }
        targetLanguage {
          code
          name
          nativename
        }
        service {
          Code
          Description {
            italian
            english
          }
          Service {
            italian
            english
          }
        }
        title
        quantity
        price
        total
        timezone
        type
        startDateTime
        endDateTime
      }
      subtotal
      subject
      address2
      postCode
      city
      country {
        code
        label
        phone
      }
      bookedBy {
        firstName
        lastName
        email
      }
      status
      supportMaterialLink
      createdAtDate
      startDate
      notes
      serviceSubtotal
      additionalService {
        title
        price
        discount
        quantity
        service {
          Code
          Description {
            italian
            english
          }
          Service {
            italian
            english
          }
        }
        serviceTotal
      }
      addOns {
        cover
        handleEvent
        hostessService
        location
        packages
        upSellingServices
        quoteInfo
        companyInfo
        noOfEvents
      }
    }
  }
`;
// ==============> VIDEO CONFERENCE PROJECT <================

export const VIDEO_CONFERENCE_PROJECT_DETAILS = gql`
  query VideoConferenceOrder($videoConferenceOrderId: ID!) {
    videoConferenceOrder(videoConferenceOrderId: $videoConferenceOrderId) {
      id
      orderNumber
      sourceLanguage {
        code
        name
        nativename
      }
      targetLanguage {
        code
        name
        nativename
      }
      industry {
        code
        name
      }
      companyNameAndId {
          accountType
        id
        name
      }
      projectManager {
        name
        email
      }
      accountManager {
        name
        email
      }
      videoConferenceItem {
        subject
        type
        startDateTime
        endDateTime
        interpreterNumber
        timezone
      }
      subtotal
      bookedBy
      status
      supportMaterialLink
      createdAtDate
      startDate
      notes
      additionalService {
        description
        price
        quantity
        service
        serviceTotal
      }
      serviceSubtotal
    }
  }
`;

export const ALL_VIDEO_CONFERENCE_PROJECT_DETAILS = gql`
  query AllVideoConferenceOrders(
    $filterStatus: String
    $filterNumber: Int
    $filterCreationDate: String
    $filterStartDate: String
  ) {
    allVideoConferenceOrders(
      filterStatus: $filterStatus
      filterNumber: $filterNumber
      filterCreationDate: $filterCreationDate
      filterStartDate: $filterStartDate
    ) {
      videoConferenceOrders {
        id
        orderNumber
        companyNameAndId {
          accountType
          id
          name
        }
        projectManager {
          name
          email
        }
        bookedBy
        status
        createdAtDate
        startDate
      }
      videoConferenceOrderCount {
        totalCount
        deliveredCount
        allocatedCount
        claimedCount
      }
    }
  }
`;

export const DEL_VIDEO_CONFERENCE_PROJECT_DETAILS = gql`
  query Query($deleteVideoConferenceOrdersId: ID!) {
    deleteVideoConferenceOrders(id: $deleteVideoConferenceOrdersId)
  }
`;

// ==============> TRANSLATION PROJECT <================
export const TRANSLATION_SERVICE = gql`
  query ServiceTranslation {
    serviceTranslation {
      serviceItems {
        Item {
          italian
          english
        }
        Code
        InvCode
        Description {
          italian
          english
        }
      }
      addService {
        Code
        InvCode
        Item {
          italian
          english
        }
        Description {
          italian
          english
        }
      }
    }
  }
`;
export const ALL_INTERPRETATION_PROJECTS_SALES = gql`
  query GetInterpretationProjectsTotal($year: String) {
    getInterpretationProjectsTotal(year: $year) {
      subtotal
      netTotal
      orderNumber
      interpretationItem {
        total
        quantity
        price
        discount
        service {
          InvCode
        }
      }
      additionalService {
        serviceTotal
        quantity
        price
        discount
        service {
          InvCode
        }
      }
    }
  }
`;
export const ALL_BARZANO_PROJECTS_SALES = gql`
  query GetBarzanoProjectsTotal($year: String) {
    getBarzanoProjectsTotal(year: $year) {
      subtotal
      orderNumber
      netTotal
      barzanoItem {
        total
        totalWords
        pricePerWord
        discount
        service {
          InvCode
        }
      }
      additionalService {
        serviceTotal
        quantity
        discount
        price
        service {
          InvCode
        }
      }
    }
  }
`;
export const ALL_TRANSLATION_PROJECTS_SALES = gql`
  query GetTranslationProjectsTotal($year: String) {
    getTranslationProjectsTotal(year: $year) {
      subtotal
      orderNumber
      netTotal
      translationItem {
        total
        totalWords
        pricePerWord
        discount
        service {
          InvCode
        }
      }
      additionalService {
        serviceTotal
        quantity
        discount
        price
        service {
          InvCode
        }
      }
    }
  }
`;
// THE REVENUE FLOW (/dashboard/reports/revenueAnalysis, DESIGN.md §21): the
// four answers above as ONE document a year, aliased by the kind of order,
// with the day each order was created and its status (projected since
// 11/10/2026; an API from before answers null for both, and the page reads
// that as "no comparison, nothing cancelled to tell apart").
export const GET_REVENUE_FLOW = gql`
  query RevenueFlow($year: String) {
    translation: getTranslationProjectsTotal(year: $year) {
      netTotal
      orderNumber
      createdAtDate
      status
      translationItem {
        total
        totalWords
        pricePerWord
        discount
        service {
          InvCode
        }
      }
      additionalService {
        serviceTotal
        quantity
        price
        discount
        service {
          InvCode
        }
      }
    }
    barzano: getBarzanoProjectsTotal(year: $year) {
      netTotal
      orderNumber
      createdAtDate
      status
      barzanoItem {
        total
        totalWords
        pricePerWord
        discount
        service {
          InvCode
        }
      }
      additionalService {
        serviceTotal
        quantity
        price
        discount
        service {
          InvCode
        }
      }
    }
    bugnion: getBugnionProjectsTotal(year: $year) {
      netTotal
      orderNumber
      createdAtDate
      status
      bugnionItem {
        total
        totalWords
        pricePerWord
        discount
        service {
          InvCode
        }
      }
      additionalService {
        serviceTotal
        quantity
        price
        discount
        service {
          InvCode
        }
      }
    }
    interpretation: getInterpretationProjectsTotal(year: $year) {
      netTotal
      orderNumber
      createdAtDate
      status
      interpretationItem {
        total
        quantity
        price
        discount
        service {
          InvCode
        }
      }
      additionalService {
        serviceTotal
        quantity
        price
        discount
        service {
          InvCode
        }
      }
    }
  }
`;
export const GET_BUGNION_PROJECTS_TOTAL = gql`
  query GetBugnionProjectsTotal($year: String) {
    getBugnionProjectsTotal(year: $year) {
      subtotal
      orderNumber
      netTotal
      bugnionItem {
        total
        totalWords
        pricePerWord
        discount
        service {
          InvCode
        }
      }
      additionalService {
        serviceTotal
        quantity
        discount
        price
        service {
          InvCode
        }
      }
    }
  }
`;
export const ALL_TRANSLATION_PROJECT_DETAILS = gql`
  query AllTranslationProjects(
    $filterAccountType: String
    $filterProjectManager: String
    $filterCertified: Boolean
    $filterShipping: Boolean
    $filterStatus: [String]
    $filterNumber: String
    $filterCreationDate: [String]
    $filterDeliveryDate: [String]
    $limit: Int
    $offset: Int
    $order: String
    $orderBy: String
  ) {
    allTranslationOrders(
      filterAccountType: $filterAccountType
      filterProjectManager: $filterProjectManager
      filterCertified: $filterCertified
      filterShipping: $filterShipping
      filterStatus: $filterStatus
      filterNumber: $filterNumber
      filterCreationDate: $filterCreationDate
      filterDeliveryDateTime: $filterDeliveryDate
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
    ) {
      translationOrders {
        id
        orderNumber
        linguistSubtotal
        subtotal
        margin
        sumTotalWords
        netTotal
        atlasProjectId
        atlasProjects {
          atlasProjectId
        }
        financialsSealedAt
        sealedMargin
        addOns {
          urgency
        }
        additionalService {
          price
          title
          quantity
          discount
          service {
            Code
            InvCode
          }
        }
        companyNameAndId {
          accountType
          id
          name
        }
        projectManager {
          name
          email
        }
        accountManager {
          name
        }
        bookedBy {
          firstName
          lastName
        }
        translationItem {
          totalWords
          discount
          sourceLanguage {
            code
            name
            nativename
          }
          targetLanguage {
            code
            name
            nativename
          }
          pricePerWord
        }
        status
        createdAtDate
        deliveryDateTime
      }
      translationOrderCount {
        filterCount
        totalCount
        deliveredCount
        allocatedCount
        claimedCount
        statusCounts {
          status
          count
          words
          inAtlas
        }
      }
    }
  }
`;

export const PM_WORKLOAD = gql`
  query PMWorkload($month: String) {
    projectManagerWorkload(month: $month) {
      name
      count
      value
      words
      lightWords
      sessions
      equipmentCount
      overdueCount
      dueSoonCount
      overdueOrders
      typeMix {
        type
        count
        value
        overdueCount
        dueSoonCount
      }
      serviceMix {
        service
        count
        bucket
      }
      serviceBuckets {
        bucket
        count
      }
    }
  }
`;

// THE TRANSLATION QUOTE LIST.
//
// Every filter of the view is sent in full on every request, so the server
// never falls back to a default of its own and the URL is the single source of
// truth for what the reader is looking at. See the server resolver for what the
// unfamiliar ones mean: filterService is a set of service groups read off the
// line items and the extras, filterClient splits the one "Private Client"
// record from real companies, filterSent is measured against the communication
// history.
export const TRANSLATION_QUOTE_OWNERS = gql`
  query TranslationQuoteOwners {
    translationQuoteOwners {
      accountManagers {
        name
        count
        live
      }
      businessDevelopers {
        name
        count
        live
      }
    }
  }
`;
export const ALL_TRANSLATION_QUOTE_DETAILS = gql`
  query AllTranslationQuotes(
    $filterStatus: [String]
    $filterNumber: String
    $filterCreationDate: [String]
    $filterDeliveryDate: [String]
    $filterFollowUpDate: [String]
    $filterAccountManager: String
    $businessDeveloper: String
    $filterService: [String]
    $filterClient: String
    $filterSourceLanguage: [String]
    $filterTargetLanguage: [String]
    $filterBrand: [String]
    $filterValueMin: Float
    $filterValueMax: Float
    $filterSent: String
    $filterLastSentDate: [String]
    $filterCompany: String
    $needsAttention: Boolean
    $followUpDue: Boolean
    $highValueQuote: Boolean
    $deadlinePassed: Boolean
    $limit: Int
    $offset: Int
    $order: String
    $orderBy: String
  ) {
    allTranslationQuoteOrders(
      filterStatus: $filterStatus
      filterNumber: $filterNumber
      filterCreationDate: $filterCreationDate
      filterDeliveryDateTime: $filterDeliveryDate
      filterFollowUpDate: $filterFollowUpDate
      filterAccountManager: $filterAccountManager
      businessDeveloper: $businessDeveloper
      filterService: $filterService
      filterClient: $filterClient
      filterSourceLanguage: $filterSourceLanguage
      filterTargetLanguage: $filterTargetLanguage
      filterBrand: $filterBrand
      filterValueMin: $filterValueMin
      filterValueMax: $filterValueMax
      filterSent: $filterSent
      filterLastSentDate: $filterLastSentDate
      filterCompany: $filterCompany
      needsAttention: $needsAttention
      followUpDue: $followUpDue
      highValueQuote: $highValueQuote
      deadlinePassed: $deadlinePassed
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
    ) {
      translationOrders {
        id
        orderNumber
        netTotal
        grandTotal
        subtotal
        sumTotalWords
        status
        stage
        language
        createdAtDate
        createdAtDateTime
        deliveryDateTime
        followUpDate
        quoteDeadline
        workingDaysToDeadline
        deliveryAddress
        lastSentAt
        sentCount
        needsAttention
        pmNotes
        notes
        utm
        campaignGclid
        source
        reasonForClosure
        # What became of the quote. Shown as a subordinate trail under the
        # state, never as a state: a project's vocabulary must not appear among
        # the quote states in the column, the filter or the tiles.
        counterpart {
          id
          stage
          orderNumber
          status
          createdAtDateTime
        }
        companyNameAndId {
          accountType
          id
          name
        }
        accountManager {
          name
          email
        }
        businessDeveloper
        bookedBy {
          firstName
          lastName
          email
        }
        brand {
          lingoyou
          academy
        }
        addOns {
          packages
          urgency
        }
        translationItem {
          fileName
          title
          totalWords
          newWords
          pricePerWord
          discount
          service {
            Code
            Item {
              italian
              english
            }
          }
          sourceLanguage {
            code
            name
          }
          targetLanguage {
            code
            name
          }
        }
        additionalService {
          title
          quantity
          price
          swornDeliveryDateTime
          service {
            Code
            Item {
              italian
              english
            }
          }
        }
      }
      translationOrderCount {
        filterCount
        TBSCount
        openCount
        closedCount
        totalCount
        awardedCount
        wonCount
        sentToPMCount
        filteredValue
        attentionCount
        # One row per status over every filter but the status one: the
        # count and the net value under each cell of the pipeline strip.
        statusCounts {
          status
          count
          value
        }
      }
    }
  }
`;
export const TRANSLATION_PROJECT_STATUS = gql`
  query GetTranslationOrderClientData($translationOrderId: String!) {
    getTranslationOrderClientData(id: $translationOrderId)
  }
`;
export const TRANSLATION_PROJECT_DETAILS = gql`
  query TranslationOrder($translationOrderId: ID!) {
    translationOrder(translationOrderId: $translationOrderId) {
      id
      orderNumber
      taxes
      netTotal
      quoteNumber
      quoteId
      totalDiscount
      grandTotal
      isBillingCompleted
      businessDeveloper
      deliveryAddress
      addOns {
        urgency
      }
      industry {
        code
        name
      }
      companyNameAndId {
          accountType
        id
        name
        id
        name
        paymentTerms
        address1
        address2
        city
        postcode
        VAT
      }
      projectManager {
        name
        email
        avatarUrl
      }
      accountManager {
        name
        email
        avatarUrl
      }
      atlasProjectId
      atlasProjects {
        atlasProjectId
        name
        sourceLanguage {
          code
          name
        }
        targetLanguages {
          code
          name
        }
        itemIds
        atlasSourceLocale
        atlasTargetLocales
        linkedHow
      }
      deliveryChecklist {
        key
        label
        checkedAt
        checkedBy {
          name
          email
        }
      }
      financialsSealedAt
      financialsSealedBy {
        id
        name
      }
      sealedMargin
      sealedSnapshot
      sealHistory
      # An Academy order sells lessons and course places on the per-word item
      # shape: the flag is what turns "words" into "units" on the page, as it
      # already does on the quote and the proposal.
      brand {
        lingoyou
        academy
      }
      translationItem {
        fileName
        title
        categoriesDiscountAmount
        newWords
        repetitionDiscount
        categories {
          perfectMatch
          contextMatch
          crossFileRepetitions
          hundred
          ninetyFiveToninetyNine
          eightyFiveToninetyFour
          seventyFiveToEightyFour
          fiftyToseventyFour
          perfectMatchDiscount
          contextMatchDiscount
          crossFileRepetitionsDiscount
          hundredMatchDiscount
          ninetyFiveToninetyNineDiscount
          eightyFiveToninetyFourDiscount
          seventyFiveToEightyFourDiscount
          fiftyToseventyFourDiscount
        }
        isPreBookingSent
        isBookingSent
        item_id
        sourceLanguage {
          code
          name
          nativename
        }
        targetLanguage {
          code
          name
          nativename
        }
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
        newWords
        repetitionWords
        totalWords
        pricePerWord
        total
        discount
      }
      deliveryDateTime
      subtotal
      linguistSubtotal
      bookedBy {
        firstName
        lastName
        email
      }
      status
      originalLink
      createdAtDate
      notes
      pmNotes
      additionalService {
        price
        title
        quantity
        discount
        swornDeliveryDateTime
        service {
          Item {
            italian
            english
          }
          Code
          InvCode
          Description {
            italian
            english
          }
        }
        serviceTotal
      }
    }
  }
`;
export const TRANSLATION_QUOTE_DETAILS = gql`
  query TranslationOrder($translationOrderId: ID!) {
    translationOrder(translationOrderId: $translationOrderId) {
      id
      orderNumber
      notesOptions
      deliveryAddress
      businessDeveloper
      optionSelected
      utm
      campaignGclid
      source
      marketingChannel {
        type
        details {
          source
          sourceDetails {
            utm
            campaignGclid
            ppcSource
            cpn
            gad_source
            kwid
            adgroup
            keywords
          }
        }
      }
      language
      companyLogo
      taxes
      paymentLink {
        receipt_url
        url
        # Permanent /pay URL — safe to hand to clients, unlike the Stripe url
        # which is replaced whenever the amount changes.
        permanentUrl
        isPaid
        amount
      }
      quoteSignature
      totalDiscount
      grandTotal
      netTotal
      taxesOptions
      totalDiscountOptions
      netTotalOptions
      grandTotalOptions
      subtotalOptions
      workingDaysToDeadline
      reasonForClosure
      # The day the client said yes. Written by the server whenever a quote is
      # moved to Won or handed over; the record's state sheet reads it under
      # the "Decided" step, which said only "Done" while nothing asked for it.
      quoteAcceptanceDate
      # What became of this quote: the project it was handed over as, and where
      # that project's own work stands.
      counterpart {
        id
        stage
        orderNumber
        status
        createdAtDateTime
      }
      # When the client was last written to, from the communication history.
      lastSentAt
      sentCount
      sentLanguages
      industry {
        code
        name
      }
      companyNameAndId {
          accountType
        id
        name
        address1
        address2
        city
        postcode
        paymentTerms
        VAT
      }
      accountManager {
        name
        email
        avatarUrl
        jobTitle
        phoneNumber
        language {
          code
          name
          nativename
        }
      }
      translationItem {
        fileName
        title
        sourceLanguage {
          code
          name
          nativename
        }
        targetLanguage {
          code
          name
          nativename
        }
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
        newWords
        repetitionWords
        totalWords
        pricePerWord
        total
        discount
      }
      itemTitles {
        title
        before_item_id
        type
        after_item_id
        position
      }
      itemTitles2 {
        title
        before_item_id
        type
        after_item_id
        position
      }
      translationItem2 {
        fileName
        title
        sourceLanguage {
          code
          name
          nativename
        }
        targetLanguage {
          code
          name
          nativename
        }
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
        newWords
        repetitionWords
        totalWords
        pricePerWord
        total
        discount
      }
      deliveryDateTime
      quoteDeadline
      followUpDate
      subtotal
      linguistSubtotal
      bookedBy {
        firstName
        lastName
        email
      }
      status
      originalLink
      createdAtDate
      notes
      pmNotes
      eventInformation
      additionalService {
        price
        title
        discount
        swornDeliveryDateTime
        quantity
        service {
          Item {
            italian
            english
          }
          Code
          InvCode
          Description {
            italian
            english
          }
        }
        serviceTotal
      }
      additionalService2 {
        price
        title
        discount
        swornDeliveryDateTime
        quantity
        service {
          Item {
            italian
            english
          }
          Code
          InvCode
          Description {
            italian
            english
          }
        }
        serviceTotal
      }
      addOns {
        seo
        cover
        website
        quoteInfo
        companyInfo
        privateHighlights
        packages
        urgency
        friendly
        sector
        services
        contents
      }
      brand {
        lingoyou
        academy
      }
      clients {
        name
        logo
      }
      businessDeveloper
      optionsTitles
      discountCode {
        code
        value
        expiryDate
      }
      discountCodeOptions {
        code
        value
        expiryDate
      }
      pkgsPriceVar {
        economyDiscount
        professionalDiscount
        premiumDiscount
      }
      pkgsDueDates
    }
  }
`;
export const DEL_TRANSLATION_PROJECT_DETAILS = gql`
  query DelTranslationProject($deleteTranslationOrdersId: ID!) {
    deleteTranslationOrders(id: $deleteTranslationOrdersId)
  }
`;
export const DEL_TRANSLATION_QUOTE_DETAILS = gql`
  query DelTranslationQuote($deleteTranslationOrdersId: ID!) {
    deleteTranslationOrders(id: $deleteTranslationOrdersId)
  }
`;
export const TRANSLATION_QUOTE_EMAIL = gql`
  query QuoteTranslationEmail(
    $language: String
    $subject: String
    $email: String
    $body: String
    $quoteTranslationEmailId: ID
    $managerName: String
    $jobTitle: String
    $phoneNumber: String
    $description: String
  ) {
    quoteTranslationEmail(
      language: $language
      subject: $subject
      email: $email
      body: $body
      id: $quoteTranslationEmailId
      managerName: $managerName
      jobTitle: $jobTitle
      phoneNumber: $phoneNumber
      description: $description
    ) {
      id
      orderNumber
      taxes
      netTotal
      industry {
        code
        name
      }
      companyNameAndId {
          accountType
        id
        name
        paymentTerms
      }

      accountManager {
        name
        email
        avatarUrl
        phoneNumber
        jobTitle
      }
      stage
      deliveryDateTime
      quoteDeadline
      followUpDate
      translationItem {
        fileName
        title
        discount
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
        newWords
        repetitionWords
        totalWords
        pricePerWord
        total
        sourceLanguage {
          code
          name
          nativename
        }
        targetLanguage {
          code
          name
          nativename
        }
      }
      subtotal
      linguistSubtotal
      bookedBy {
        firstName
        lastName
        email
      }
      status
      originalLink
      createdAtDate
      notes
      additionalService {
        title
        quantity
        price
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
        serviceTotal
      }
      serviceSubtotal
    }
  }
`;
// ==============> BARZANO PROJECT <================

export const ALL_BARZANO_DELIVERY_PROJECTS = gql`
  query AllBarzanoDeliveryOrders(
    $filterStatus: [String]
    $filterDeliveryDateTime: String
  ) {
    allBarzanoDeliveryOrders(
      filterStatus: $filterStatus
      filterDeliveryDateTime: $filterDeliveryDateTime
    ) {
      id
      orderNumber
      caseNumber
      formattingDifficulty
      patentNumber
      bookedBy
      warningRequirements
      margin
      netTotal
      sumTotalWords
      sourceLanguage {
        code
        name
        nativename
      }
      targetLanguage {
        code
        name
        nativename
      }
      subtotal
      linguistSubtotal
      serviceSubtotal
      barzanoItem {
        totalWords
        pricePerWord
        total
        sourceLanguage {
          code
          name
          nativename
        }
        targetLanguage {
          code
          name
          nativename
        }
      }
      companyNameAndId {
          accountType
        id
        name
      }
      projectManager {
        name
        email
      }
      bookedBy
      status
      createdAtDate
      deliveryDateTime
    }
  }
`;
export const ALL_BUGNION_DELIVERY_PROJECTS = ALL_BARZANO_DELIVERY_PROJECTS;
export const ALL_BARZANO_PROJECT_DETAILS = gql`
  query AllBarzanoOrders(
    $filterStatus: [String]
    $filterNumber: String
    $filterCreationDate: [String]
    $filterProjectManager: String
    $filterDeliveryDateTime: [String]
    $filterCaseType: String
    $filterAiWorkflow: Boolean
    $limit: Int
    $offset: Int
    $order: String
    $orderBy: String
  ) {
    allBarzanoOrders(
      filterStatus: $filterStatus
      filterNumber: $filterNumber
      filterCaseType: $filterCaseType
      filterCreationDate: $filterCreationDate
      filterDeliveryDateTime: $filterDeliveryDateTime
      filterProjectManager: $filterProjectManager
      filterAiWorkflow: $filterAiWorkflow
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
    ) {
      barzanoOrders {
        id
        orderNumber
        caseNumber
        formattingDifficulty
        patentNumber
        bookedBy
        warningRequirements
        margin
        netTotal
        sumTotalWords

        subtotal
        linguistSubtotal
        serviceSubtotal
        applicationType
        barzanoItem {
          totalWords
          pricePerWord
          total
          repetitionWords
          sourceLanguage {
            code
            name
            nativename
          }
          targetLanguage {
            code
            name
            nativename
          }
        }
        companyNameAndId {
          accountType
          id
          name
        }
        projectManager {
          name
          email
        }
        bookedBy
        status
        createdAtDate
        deliveryDateTime
        additionalService {
          description
          price
          quantity
          serviceTotal
        }
      }
      barzanoOrderCount {
        filterCount
        totalCount
        deliveredCount
        allocatedCount
        claimedCount
        # one row per status over the other filters: the pipeline strip
        statusCounts {
          status
          count
          words
        }
      }
    }
  }
`;
export const ALL_BUGNION_PROJECT_DETAILS = gql`
  query AllBugnionOrders(
    $filterStatus: [String]
    $filterNumber: String
    $filterCreationDate: [String]
    $filterProjectManager: String
    $filterDeliveryDateTime: [String]
    $filterAiWorkflow: Boolean
    $limit: Int
    $offset: Int
    $order: String
    $orderBy: String
  ) {
    allBugnionOrders(
      filterStatus: $filterStatus
      filterNumber: $filterNumber
      filterCreationDate: $filterCreationDate
      filterDeliveryDateTime: $filterDeliveryDateTime
      filterProjectManager: $filterProjectManager
      filterAiWorkflow: $filterAiWorkflow
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
    ) {
      bugnionOrders {
        id
        orderNumber
        caseNumber
        formattingDifficulty
        patentNumber
        bookedBy
        warningRequirements
        margin
        netTotal
        sumTotalWords

        subtotal
        linguistSubtotal
        serviceSubtotal
        applicationType
        bugnionItem {
          totalWords
          pricePerWord
          total
          repetitionWords
          sourceLanguage {
            code
            name
            nativename
          }
          targetLanguage {
            code
            name
            nativename
          }
        }
        companyNameAndId {
          accountType
          id
          name
        }
        projectManager {
          name
          email
        }
        bookedBy
        status
        createdAtDate
        deliveryDateTime
        additionalService {
          description
          price
          quantity
          serviceTotal
        }
      }
      bugnionOrderCount {
        filterCount
        totalCount
        deliveredCount
        allocatedCount
        claimedCount
        # one row per status over the other filters: the pipeline strip
        statusCounts {
          status
          count
          words
        }
      }
    }
  }
`;

export const DEL_BARZANO_PROJECT_DETAILS = gql`
  query DelBarzanoProject($deleteBarzanoOrdersId: ID!) {
    deleteBarzanoOrders(id: $deleteBarzanoOrdersId)
  }
`;

export const GET_BARZANO_PROJECT_DETAILS = gql`
  query BarzanoOrder($barzanoOrderId: ID!) {
    barzanoOrder(barzanoOrderId: $barzanoOrderId) {
      id
      orderNumber
      formattingDifficulty
      notes
    }
  }
`;
export const BARZANO_PROJECT_DETAILS = gql`
  query BarzanoOrder($barzanoOrderId: ID!) {
    barzanoOrder(barzanoOrderId: $barzanoOrderId) {
      id
      orderNumber
      caseNumber
      caseType
      taxes
      warningRequirements
      totalDiscount
      grandTotal
      netTotal
      formattingDifficulty
      patentNumber
      applicationType
      isBillingCompleted
      completionDate
      margin
      sumTotalWords
      billingNotes
      invoiceNo
      linguisticReviewPolicy
      workflow

      industry {
        code
        name
      }
      companyNameAndId {
          accountType
        id
        name
      }
      projectManager {
        name
        email
      }
      accountManager {
        name
        email
      }
      atlasProjectId
      atlasProjects {
        atlasProjectId
        name
        sourceLanguage {
          code
          name
        }
        targetLanguages {
          code
          name
        }
        itemIds
        atlasSourceLocale
        atlasTargetLocales
        linkedHow
      }
      barzanoItem {
        categoriesDiscountAmount
        newWords
        repetitionDiscount
        categories {
          perfectMatch
          contextMatch
          crossFileRepetitions
          hundred
          ninetyFiveToninetyNine
          eightyFiveToninetyFour
          seventyFiveToEightyFour
          fiftyToseventyFour
          perfectMatchDiscount
          contextMatchDiscount
          crossFileRepetitionsDiscount
          hundredMatchDiscount
          ninetyFiveToninetyNineDiscount
          eightyFiveToninetyFourDiscount
          seventyFiveToEightyFourDiscount
          fiftyToseventyFourDiscount
        }
        total
        item_id
        isPreBookingSent
        isBookingSent
        pricePerWord
        totalWords
        repetitionWords
        patentTitle
        repetitionsPricePerWord
        repetitionDiscount
        fileName
        discount
        sourceLanguage {
          code
          name
          nativename
        }
        targetLanguage {
          code
          name
          nativename
        }
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
      }
      subtotal
      bookedBy
      bookedByAddress
      status
      originalLink
      createdAtDate
      deliveryDateTime
      notes
      pmNotes
      additionalService {
        description
        price
        quantity
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
        discount
        serviceTotal
      }
      serviceSubtotal
    }
  }
`;
export const BUGNION_PROJECT_DETAILS = gql`
  query BugnionOrder($bugnionOrderId: ID!) {
    bugnionOrder(bugnionOrderId: $bugnionOrderId) {
      id
      orderNumber
      caseNumber

      taxes
      warningRequirements
      totalDiscount
      grandTotal
      netTotal
      formattingDifficulty
      patentNumber
      applicationType
      isBillingCompleted
      invoiceStatus
      invoiceID
      numeration
      invoice_id
      team
      industry {
        code
        name
      }
      companyNameAndId {
          accountType
        id
        name
      }
      projectManager {
        name
        email
      }
      accountManager {
        name
        email
      }
      atlasProjectId
      atlasProjects {
        atlasProjectId
        name
        sourceLanguage {
          code
          name
        }
        targetLanguages {
          code
          name
        }
        itemIds
        atlasSourceLocale
        atlasTargetLocales
        linkedHow
      }
      bugnionItem {
        categoriesDiscountAmount
        newWords
        repetitionDiscount
        categories {
          perfectMatch
          contextMatch
          crossFileRepetitions
          hundred
          ninetyFiveToninetyNine
          eightyFiveToninetyFour
          seventyFiveToEightyFour
          fiftyToseventyFour
          perfectMatchDiscount
          contextMatchDiscount
          crossFileRepetitionsDiscount
          hundredMatchDiscount
          ninetyFiveToninetyNineDiscount
          eightyFiveToninetyFourDiscount
          seventyFiveToEightyFourDiscount
          fiftyToseventyFourDiscount
        }
        total
        item_id
        isPreBookingSent
        isBookingSent
        pricePerWord
        totalWords
        repetitionWords
        patentTitle
        repetitionsPricePerWord
        repetitionDiscount
        fileName
        discount
        sourceLanguage {
          code
          name
          nativename
        }
        targetLanguage {
          code
          name
          nativename
        }
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
      }
      subtotal
      bookedBy
      bookedByAddress
      status
      originalLink
      createdAtDate
      deliveryDateTime
      notes
      pmNotes
      additionalService {
        description
        price
        quantity
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
        discount
        serviceTotal
      }
      serviceSubtotal
    }
  }
`;
// ==============> LINGUIST <================
export const ALL_LINGUIST_PROJECTS = gql`
  query AllLinguistProjects(
    $filterNumber: String
    $linguistId: String
    $filterStatus: String
    $filterCreationDate: String
    $filterDeliveryDateTime: String
    $filterProjectManager: String
    $projectType: String!
    $offset: Int
    $limit: Int
    $orderBy: String
    $order: String
  ) {
    allLinguistProjects(
      filterNumber: $filterNumber
      linguistId: $linguistId
      filterStatus: $filterStatus
      filterCreationDate: $filterCreationDate
      filterDeliveryDateTime: $filterDeliveryDateTime
      filterProjectManager: $filterProjectManager
      projectType: $projectType
      offset: $offset
      limit: $limit
      orderBy: $orderBy
      order: $order
    ) {
      linguistProjects {
        id
        linguistId
        projectType
        projectManager
        orderNumber
        status
        deliveryDateTime
        targetLanguage
        sourceLanguage
        total
        creationDate
        projectId
        startDateTime
        endDateTime
        type
      }
      linguistProjectCount {
        allocationCount
        completedCount
        acceptedCount
        totalCount
        pendingCount
        filterCount
      }
    }
  }
`;
export const LINGUIST_PROJECTS = gql`
  query AllLinguistProjects(
    $filterNumber: String
    $linguistId: String
    $filterStatus: String
    $filterCreationDate: String
    $filterDeliveryDateTime: String
    $filterProjectManager: String
    $projectType: String!
    $offset: Int
    $limit: Int
    $orderBy: String
    $order: String
  ) {
    linguistProjects(
      filterNumber: $filterNumber
      linguistId: $linguistId
      filterStatus: $filterStatus
      filterCreationDate: $filterCreationDate
      filterDeliveryDateTime: $filterDeliveryDateTime
      filterProjectManager: $filterProjectManager
      projectType: $projectType
      offset: $offset
      limit: $limit
      orderBy: $orderBy
      order: $order
    ) {
      linguistProjects {
        id
        linguistId
        projectType
        projectManager
        orderNumber
        status
        deliveryDateTime
        targetLanguage
        sourceLanguage
        total
        creationDate
        projectId
        startDateTime
        endDateTime
        type
        completionDate
      }
      linguistProjectCount {
        allocationCount
        completedCount
        acceptedCount
        totalCount
        pendingCount
        filterCount
      }
    }
  }
`;
export const ALL_PR_PROJECTS = gql`
  query allPRProjects(
    $filterNumber: String
    $linguistId: String
    $filterStatus: String
    $filterCreationDate: String
    $filterDeliveryDateTime: String
    $filterProjectManager: String
    $offset: Int
    $limit: Int
    $orderBy: String
    $order: String
  ) {
    allPRProjects(
      filterNumber: $filterNumber
      linguistId: $linguistId
      filterStatus: $filterStatus
      filterCreationDate: $filterCreationDate
      filterDeliveryDateTime: $filterDeliveryDateTime
      filterProjectManager: $filterProjectManager
      offset: $offset
      limit: $limit
      orderBy: $orderBy
      order: $order
    ) {
      prProjects {
        id
        linguistId
        projectType
        projectManager
        orderNumber
        status
        deliveryDateTime
        targetLanguage
        sourceLanguage
        total
        creationDate
        projectId
      }
      prProjectCount {
        allocationCount
        completedCount
        acceptedCount
        totalCount
        pendingCount
        filterCount
      }
    }
  }
`;
export const LINGUIST_LANGUAGE_DETAILS = gql`
  query GetUserDataById($getUserDataById: ID!) {
    getUserDataById(id: $getUserDataById) {
      id
      mainLanguage
      otherLanguage
      Rate {
        activity
        languageSource
        languageTarget
        rateType
      }
      mTPeERates {
        activity
        languageSource
        languageTarget
        rateType
      }
      editingRates {
        activity
        languageSource
        languageTarget
        rateType
      }
      onSiteDocumentReviewRates {
        activity
        languageSource
        languageTarget
        rateType
      }
      travelExpensesperday
      cancellationTermsdays
      InterpreterService {
        Backediting {
          dayRate
          experience
          fullDayRate
          hourRate
          minuteRate
          sourceLanguage
          targetLanguage
        }
        Notarized {
          dayRate
          experience
          fullDayRate
          hourRate
          minuteRate
          sourceLanguage
          targetLanguage
        }
        Patents {
          assignmentTime
          isChecked
        }
        Reconciliations {
          hourRate
          fullDayRate
          experience
          dayRate
          minuteRate
          sourceLanguage
          targetLanguage
        }
        Revisions {
          dayRate
          experience
          hourRate
          fullDayRate
          minuteRate
          sourceLanguage
          targetLanguage
        }
        Sworn {
          dayRate
          experience
          fullDayRate
          hourRate
          minuteRate
          sourceLanguage
          targetLanguage
        }
      }
    }
  }
`;
export const LINGUIST_DETAILS = gql`
  query GetUserDataById($getUserDataById: ID!) {
    getUserDataById(id: $getUserDataById) {
      id
      firstName
      lastName
      gender
      about
      dob
      nickname
      email
      phone
      skype
      contactMethod
      image
      mainLanguage
      otherLanguage
      liveOtherCountry
      yearOtherCountry
      address1
      address2
      city
      country
      livesin
      postal
      timezone
      college
      startDate
      endDate
      degree
      areaOfStudy
      aboutQualification
      website
      workingFor
      businessType
      sizeClassification
      numberEmployee
      resume
      mainService
      profileTitle
      iban
      bic
      bankname
      taxid
      profileCompletion
      imageForm
      personalForm
      contactForm
      educationForm
      workForm
      businessForm
      paymentForm
      freelanceExperience
      freelancerType
      isBlacklisted
      translation {
        isActive
        values {
          experience
          sourceLanguage
          targetLanguage
          title
        }
      }
      notarisedTranslation {
        isActive
        values {
          experience
          sourceLanguage
          targetLanguage
          title
        }
      }
      swornTranslation {
        isActive
        values {
          experience
          sourceLanguage
          targetLanguage
          title
        }
      }
      backTranslation {
        isActive
        values {
          experience
          sourceLanguage
          targetLanguage
          title
        }
      }
      proofreadingEditing {
        isActive
        values {
          experience
          sourceLanguage
          targetLanguage
          title
        }
      }
      qualityCheck {
        isActive
        values {
          experience
          sourceLanguage
          targetLanguage
          title
        }
      }
      revision {
        isActive
        values {
          experience
          sourceLanguage
          targetLanguage
          title
        }
      }
      reconciliation {
        isActive
        values {
          experience
          sourceLanguage
          targetLanguage
          title
        }
      }
      backeEditing {
        isActive
        values {
          experience
          sourceLanguage
          targetLanguage
          title
        }
      }
      onSiteDocumentReview {
        isActive
        values {
          experience
          sourceLanguage
          targetLanguage
          title
        }
      }
      postDTPProofreading {
        isActive
        values {
          experience
          sourceLanguage
          targetLanguage
          title
        }
      }
      ligthMTPostEditing {
        isActive
        values {
          experience
          sourceLanguage
          targetLanguage
          title
        }
      }
      fullMTPostEditing {
        isActive
        values {
          experience
          sourceLanguage
          targetLanguage
          title
        }
      }

      selectedFields
      communication {
        corporateCommunication {
          isActive
          experience
          estimate
        }
        journalismPublications {
          isActive
          experience
          estimate
        }
        pressRelease {
          isActive
          experience
          estimate
        }
        publishing {
          isActive
          experience
          estimate
        }
      }
      marketing {
        adCopy {
          isActive
          experience
          estimate
        }
        generalMarketing {
          isActive
          experience
          estimate
        }
        hotel {
          isActive
          experience
          estimate
        }
        leisure {
          isActive
          experience
          estimate
        }
        printAdvertising {
          isActive
          experience
          estimate
        }
        sportsAndFitness {
          isActive
          experience
          estimate
        }
        tourismTravel {
          isActive
          experience
          estimate
        }
        cruises {
          isActive
          experience
          estimate
        }
        transports {
          isActive
          experience
          estimate
        }
      }
      education {
        parent {
          isActive
          experience
          estimate
        }
        teacher {
          isActive
          experience
          estimate
        }
      }
      foodAndBeverage {
        generalFoodandBeverage {
          isActive
          experience
          estimate
        }
        menu {
          isActive
          experience
          estimate
        }
        workPercentage {
          experience
        }
      }
      retail {
        apparel {
          isActive
          experience
          estimate
        }
        beauty {
          isActive
          experience
          estimate
        }
        consumerProducts {
          isActive
          experience
          estimate
        }
        durables {
          isActive
          experience
          estimate
        }
        toysandCrafts {
          isActive
          experience
          estimate
        }
      }
      insurance {
        forms {
          isActive
          experience
          estimate
        }
        healthInsuranceForm {
          isActive
          experience
          estimate
        }
        policy {
          isActive
          experience
          estimate
        }
      }
      financial {
        accounting {
          isActive
          experience
          estimate
        }
        generalFinance {
          isActive
          experience
          estimate
        }
        lettertoEmployees {
          isActive
          experience
          estimate
        }
        annualReports {
          isActive
          experience
          estimate
        }
        assetManagement {
          isActive
          experience
          estimate
        }
        basicBanking {
          isActive
          experience
          estimate
        }
        benefitsInformation {
          isActive
          experience
          estimate
        }
        businessCards {
          isActive
          experience
          estimate
        }
        financialInstruments {
          isActive
          experience
          estimate
        }
        generalInvestment {
          isActive
          experience
          estimate
        }
        hedgingRiskManagement {
          isActive
          experience
          estimate
        }
        investmentAnalyses {
          isActive
          experience
          estimate
        }
        marketCommentary {
          isActive
          experience
          estimate
        }
        prospectus {
          isActive
          experience
          estimate
        }
        securitizations {
          isActive
          experience
          estimate
        }
      }
      humanResources {
        handbooksAndManuals {
          isActive
          experience
          estimate
        }
        newsletters {
          isActive
          experience
          estimate
        }
        policy {
          isActive
          experience
          estimate
        }
      }
      learningandDevelopment {
        businessandSoftSkills {
          isActive
          experience
          estimate
        }
        educationK12 {
          isActive
          experience
          estimate
        }
        ethicsandCompliance {
          isActive
          experience
          estimate
        }
        financialSAPOracle {
          isActive
          experience
          estimate
        }
        healthandSafety {
          isActive
          experience
          estimate
        }
        managementDevelopment {
          isActive
          experience
          estimate
        }
        salesTraining {
          isActive
          experience
          estimate
        }
        technical {
          isActive
          experience
          estimate
        }
      }
      legal {
        contracts {
          isActive
          experience
          estimate
        }
        depositionNotice {
          isActive
          experience
          estimate
        }
        employeeCorrespondence {
          isActive
          experience
          estimate
        }
        federalCourt {
          isActive
          experience
          estimate
        }
        financial {
          isActive
          experience
          estimate
        }
        governmentNGO {
          isActive
          experience
          estimate
        }
        insurance {
          isActive
          experience
          estimate
        }
        leaseAgreement {
          isActive
          experience
          estimate
        }
        mergersandAcquisitions {
          isActive
          experience
          estimate
        }
        personalDocuments {
          isActive
          experience
          estimate
        }
        stateCourt {
          isActive
          experience
          estimate
        }
        termsandConditions {
          isActive
          experience
          estimate
        }
        courtPapers {
          isActive
          experience
          estimate
        }
      }
      patents {
        automotivePatents {
          isActive
          experience
          estimate
        }
        chemicalPatents {
          isActive
          experience
          estimate
        }
        engineeringPatents {
          isActive
          experience
          estimate
        }
        generalPatents {
          isActive
          experience
          estimate
        }
        pharmaOrMedicalPatents {
          isActive
          experience
          estimate
        }
        semiconductorPatents {
          isActive
          experience
          estimate
        }
        technicalPatents {
          isActive
          experience
          estimate
        }
      }
      technical {
        aeronauticsAerosapace {
          isActive
          experience
          estimate
        }
        automation {
          isActive
          experience
          estimate
        }
        automotive {
          isActive
          experience
          estimate
        }
        construction {
          isActive
          experience
          estimate
        }
        electronics {
          isActive
          experience
          estimate
        }
        engineeringChemical {
          isActive
          experience
          estimate
        }
        engineeringCivil {
          isActive
          experience
          estimate
        }
        engineeringGeneral {
          isActive
          experience
          estimate
        }
        engineeringMechanical {
          isActive
          experience
          estimate
        }
        environmental {
          isActive
          experience
          estimate
        }
        iTDocandHelpUA {
          isActive
          experience
          estimate
        }
        iTERPOrCRM {
          isActive
          experience
          estimate
        }
        iTGames {
          isActive
          experience
          estimate
        }
        iTGeneral {
          isActive
          experience
          estimate
        }
        iTGraphicsSoftware {
          isActive
          experience
          estimate
        }
        iTHardware {
          isActive
          experience
          estimate
        }
        iTSoftwareUI {
          isActive
          experience
          estimate
        }
        iTMarketing {
          isActive
          experience
          estimate
        }
        iTSoftwareUIIVRS {
          isActive
          experience
          estimate
        }
        iTSoftwareUISoftwareMarketing {
          isActive
          experience
          estimate
        }
        iTSoftwareUISoftwareTraining {
          isActive
          experience
          estimate
        }
        iTTechincalMarketing {
          isActive
          experience
          estimate
        }
        machinery {
          isActive
          experience
          estimate
        }
      }
      lifeScience {
        batchRecords
        biochemistryDrugComposition
        justificationLetter
        changeforProtocolSummary
        clinicalStudyReport
        clinicalReportedOutcome
        clinicalReportedProtocol
        cRFCaseReviewForm
        cROClinicianReportedOutcome
        clinicalTrialAgreement
        cVCurriculumVitae
        dischargeSummary
        doctorPatientTranscript
        druglabel
        dLearning
        dthicsCommitteeLetter
        financialDisclosure
        generalLifeSciences
        dlobalCommunications
        handwrittenPatientNotes
        healthQuestionnaireNonClinical
        healthcareMarketingClinical
        healthcareMarketingNonClinical
        investigatorBrochure
        informedConsentForm
        impd
        indemnificationLetter
        investigatorMeeting
        investigatorSiteBinderDocs
        iVRSScripts
        labManualFlowchart
        localECSubmissionDocuments
        mAAeCTDNDA
        manufacturerAuthorization
        medicalLicenses
        neuropsychologicalAssessment
        normalLabRanges
        observerReportedOutcome
        packageInsert
        plainLanguageSummary
        patientMedicalReport
        patientBrochure
        patientCard
        patientDiary
        patientInformationLeaflet
        patientRecruitmentMaterial
        productMonograph
        powerofAttorney
        patientReportedOutcomes
        productCharacteristicsSummary
        publicHealthInformation
        qualifiedPersonCertificate
        rASubmissionLetter
        regulatorySubmissionLetter
        sap
        scientificJournalsArticles
        seriousAdverseEventsForm
        siteContract
        standardOperatingProcedures
        studyBudget
        training
      }
      medicalAreas {
        anesthetics
        animalHealth
        cardiology
        dental
        dermatology
        elderlyMedicine
        emergencyMedicine
        endocrinology
        formsProcedures
        gastroenterology
        generalMedicine
        generalPractice
        gynecology
        healthNutrition
        hematology
        hepatology
        hereditaryDisordersGenetics
        immunology
        infectiousDisease
        medicalMarketing
        neurology
        nurses
        obstetrics
        oncology
        ophthalmology
        otolaryngologyENT
        pediatrics
        pharmacists
        physicalMedicalRehabilitation
        psychiatry
        radiology
        resipirotaryPumonology
        rheumatology
        surgery
        thoracicMedicine
        urology
        vaccines
        allergy
      }
      medicalDevices {
        consumerDevices
        dental
        iFUDFU
        hospitalEquipment
        imagingRadiotherapy
        inVitroDiagnostics
        orthopedics
        shonin
        softwareManuals
        stentsGraftsCatheters
        surgicalInstruments
        vascularInterventions
        labelling
        marketing
      }
      medicalMaterials {
        medicalEducation
        medicalManuals
        medicalProcedures
        medicalReference
        medicalResearch
        medicalReviews
        medicalWeb
      }
      digitalMarketing {
        searchEngineOptimization
        searchEngineMarketing
        payPerClick
      }
      socialMedia {
        communityManagement
      }
      other {
        isActive
        experience
        estimate
      }
      Rate {
        activity
        languageSource
        languageTarget
        rateType
      }
      mTPeERates {
        activity
        languageSource
        languageTarget
        rateType
      }
      editingRates {
        activity
        languageSource
        languageTarget
        rateType
      }
      onSiteDocumentReviewRates {
        activity
        languageSource
        languageTarget
        rateType
      }
      travelExpensesperday
      cancellationTermsdays
      InterpreterService {
        Backediting {
          dayRate
          experience
          fullDayRate
          hourRate
          minuteRate
          sourceLanguage
          targetLanguage
        }
        Notarized {
          dayRate
          experience
          fullDayRate
          hourRate
          minuteRate
          sourceLanguage
          targetLanguage
        }
        Patents {
          assignmentTime
          isChecked
        }
        Reconciliations {
          hourRate
          fullDayRate
          experience
          dayRate
          minuteRate
          sourceLanguage
          targetLanguage
        }
        Revisions {
          dayRate
          experience
          hourRate
          fullDayRate
          minuteRate
          sourceLanguage
          targetLanguage
        }
        Sworn {
          dayRate
          experience
          fullDayRate
          hourRate
          minuteRate
          sourceLanguage
          targetLanguage
        }
        advisoryBoards {
          assignmentTime
          isChecked
        }
        agribusiness {
          assignmentTime
          isChecked
        }
        asylum {
          assignmentTime
          isChecked
        }
        attorney {
          assignmentTime
          isChecked
        }
        audit {
          assignmentTime
          isChecked
        }
        automotive {
          assignmentTime
          isChecked
        }
        aviation {
          assignmentTime
          isChecked
        }
        backTranlation {
          dayRate
          experience
          fullDayRate
          hourRate
          minuteRate
          sourceLanguage
          targetLanguage
        }
        businessMeet {
          assignmentTime
          isChecked
        }
        camera
        cancelationTerm
        computerHardware {
          assignmentTime
          isChecked
        }
        culturalConsultant {
          assignmentTime
          isChecked
        }
        cultureArts {
          assignmentTime
          isChecked
        }
        currency
        freelanceExperience
        freelancerType
        hardware {
          headphones
          microphone
          printer
        }
        deposition {
          assignmentTime
          isChecked
        }
        diplomacy {
          assignmentTime
          isChecked
        }
        disasterRecovery {
          assignmentTime
          isChecked
        }
        disciplinaryMeet {
          assignmentTime
          isChecked
        }
        energy {
          assignmentTime
          isChecked
        }
        engineering {
          assignmentTime
          isChecked
        }
        euParliament {
          assignmentTime
          isChecked
        }
        fcpa {
          assignmentTime
          isChecked
        }
        finance {
          assignmentTime
          isChecked
        }
        foodBeverage {
          assignmentTime
          isChecked
        }
        healthcareOffice {
          assignmentTime
          isChecked
        }
        workerCompensation {
          isChecked
          assignmentTime
        }

        unitedNations {
          isChecked
          assignmentTime
        }
        trial {
          isChecked
          assignmentTime
        }
        travelExpense
        tourGuide {
          isChecked
          assignmentTime
        }
        studentEvaluations {
          isChecked
          assignmentTime
        }
        stateDepartment {
          isChecked
          assignmentTime
        }
        sports {
          isChecked
          assignmentTime
        }
        speedConnection
        specialEducation {
          isChecked
          assignmentTime
        }
        socialServices {
          isChecked
          assignmentTime
        }
        shareholderMeet {
          isChecked
          assignmentTime
        }
        retail {
          isChecked
          assignmentTime
        }
        redundancy {
          isChecked
          assignmentTime
        }
        railroads {
          isChecked
          assignmentTime
        }
        qualityChecks {
          sourceLanguage
          targetLanguage
          experience
          minuteRate
          hourRate
          dayRate
          fullDayRate
        }
        publicHealth {
          isChecked
          assignmentTime
        }
        proofReading {
          sourceLanguage
          targetLanguage
          experience
          minuteRate
          hourRate
          dayRate
          fullDayRate
        }
        preferredBrowser
        phoneInterpretation {
          sourceLanguage
          targetLanguage
          experience
          minuteRate
          hourRate
          dayRate
          fullDayRate
        }
        personalAssistant {
          isChecked
          assignmentTime
        }
        parentMeet {
          isChecked
          assignmentTime
        }
        overPhoneAvailable
        newRequestTime
        mentalHealth {
          isChecked
          assignmentTime
        }
        medicalExam {
          isChecked
          assignmentTime
        }
        medicalDevice {
          isChecked
          assignmentTime
        }
        mediaPress {
          isChecked
          assignmentTime
        }
        marketing {
          isChecked
          assignmentTime
        }
        maritime {
          isChecked
          assignmentTime
        }
        machine
        listClient
        landLines
        isSwornShow
        isRevisionsshow
        isPhoneInterpretation
        isNotarizedshow
        isBackshow
        investigatorsMeeting {
          isChecked
          assignmentTime
        }
        hospitalExam {
          isChecked
          assignmentTime
        }
        insurance {
          isChecked
          assignmentTime
        }
        intellectual {
          isChecked
          assignmentTime
        }
        humanResources {
          isChecked
          assignmentTime
        }
        iepMeet {
          isChecked
          assignmentTime
        }
        internationalDevelopment {
          isChecked
          assignmentTime
        }
      }
    }
  }
`;

export const ALL_LINGUISTS = gql`
  query AllLinguists(
    $filterStatus: String
    $filterName: String
    $filterSourceLanguage: String
    $filterTargetLanguage: String
    $filterCity: String
    $filterService: [String]
    $filterRegion: String
    $startDate: String
    $endDate: String
    $offset: Int
    $limit: Int
    $clientId: String
    $projectType: String
    $filterServices: [String]
    $bidirectionalSearch: Boolean
    $includeInterpreters: Boolean
  ) {
    allLinguists(
      filterStatus: $filterStatus
      filterName: $filterName
      filterSourceLanguage: $filterSourceLanguage
      filterTargetLanguage: $filterTargetLanguage
      City: $filterCity
      Region: $filterRegion
      mainService: $filterService
      startDate: $startDate
      endDate: $endDate
      offset: $offset
      limit: $limit
      clientId: $clientId
      projectType: $projectType
      bidirectionalSearch: $bidirectionalSearch
      filterServices: $filterServices
      includeInterpreters: $includeInterpreters
    ) {
      linguists {
        mediationQualified
        id
        firstName
        lastName
        email
        gender
        phone
        areaOfStudy
        contactMethod
        profileCompletion
        type
        dob
        city
        state
        address
        otherLanguage
        mainLanguage
        country
        iban
        resume
        image
        mainService
        feedbackScore
        pmFeedback
        prFeedback
        totalProjectsLinguistCount
        projectsForThisClientCount
        feedbackCI
        feedbackBZ
        sourceLanguages
        targetLanguages
        status
      }
      linguistsCount {
        totalCount
        completedCount
        mostlyCompletedCount
        missingInfromationCount
        blockedLinguist
      }
    }
  }
`;
export const LINGUISTS_LIST_FOR_PRE_BOOKING = gql`
  query PreBookingLinguists(
    $filterStatus: String
    $filterName: String
    $filterSourceLanguage: String
    $filterTargetLanguage: String
    $filterCity: String
    $filterService: [String]
    $filterRegion: String
    $startDate: String
    $endDate: String
    $clientId: String
    $projectType: String
    $filterServices: [String]
    $bidirectionalSearch: Boolean
  ) {
    preBookingLinguists(
      filterStatus: $filterStatus
      filterName: $filterName
      filterSourceLanguage: $filterSourceLanguage
      filterTargetLanguage: $filterTargetLanguage
      City: $filterCity
      Region: $filterRegion
      mainService: $filterService
      startDate: $startDate
      endDate: $endDate
      clientId: $clientId
      projectType: $projectType
      filterServices: $filterServices
      bidirectionalSearch: $bidirectionalSearch
    ) {
      id
      firstName
      lastName
      email
      image
      city
      country
      status
      sourceLanguages
      targetLanguages
      totalProjectsLinguistCount
      projectsForThisClientCount
      overallAvgCIRating
    }
  }
`;

export const TRANSLATION_LINGUISTS = gql`
  query TranslationLinguists(
    $filterStatus: String
    $filterName: String
    $filterSourceLanguage: String
    $filterTargetLanguage: String
    $filterCity: String
    $filterService: [String]
    $filterRegion: String
    $deliveryDate: String
    $filterServices: [String]
    $offset: Int
    $limit: Int
    $clientId: String
    $projectType: String
    $bidirectionalSearch: Boolean
  ) {
    translationLinguists(
      filterStatus: $filterStatus
      filterName: $filterName
      filterSourceLanguage: $filterSourceLanguage
      filterTargetLanguage: $filterTargetLanguage
      City: $filterCity
      Region: $filterRegion
      mainService: $filterService
      filterServices: $filterServices
      deliveryDate: $deliveryDate
      offset: $offset
      limit: $limit
      clientId: $clientId
      projectType: $projectType
      bidirectionalSearch: $bidirectionalSearch
    ) {
      linguists {
        id
        firstName
        lastName
        email
        gender
        phone
        areaOfStudy
        contactMethod
        profileCompletion
        type
        dob
        city
        address
        otherLanguage
        mainLanguage
        country
        iban
        resume
        image
        mainService
        feedbackScore
        pmFeedback
        prFeedback
        totalProjectsLinguistCount
        projectsForThisClientCount
        feedbackCI
        feedbackBZ
        sourceLanguages
        targetLanguages
        status
        tradosEmail
      }
      linguistsCount {
        totalCount
        completedCount
        mostlyCompletedCount
        missingInfromationCount
        blockedLinguist
      }
    }
  }
`;
export const BARZANO_PRE_BOOKING_LINGUISTS = gql`
  query TranslationBookingLinguists(
    $filterStatus: String
    $filterName: String
    $filterSourceLanguage: String
    $filterTargetLanguage: String
    $filterService: [String]
    $deliveryDate: String
    $filterServices: [String]
    $clientId: String
    $projectType: String
    $bidirectionalSearch: Boolean
  ) {
    translationPreBookingLinguists(
      filterStatus: $filterStatus
      filterName: $filterName
      filterSourceLanguage: $filterSourceLanguage
      filterTargetLanguage: $filterTargetLanguage
      mainService: $filterService
      filterServices: $filterServices
      deliveryDate: $deliveryDate
      clientId: $clientId
      projectType: $projectType
      bidirectionalSearch: $bidirectionalSearch
    ) {
      id
      firstName
      lastName
      email
      image
      city
      country
      status

      name

      image
      resume
      phone
      dob
      mainLanguage
      otherLanguage

      country
      sourceLanguages
      targetLanguages
      totalProjectsLinguistCount
      projectsForThisClientCount
      overallAvgPMRating
      overallAvgPRRating
      overallAvgCIRating
      overallAvgBZRating
    }
  }
`;
export const ALL_LINGUISTS_FEEDBACK = gql`
  query AllLinguistFeedbacks($linguistsIds: [String], $clientId: String) {
    allLinguistFeedbacks(linguistsIds: $linguistsIds, clientId: $clientId) {
      feedbackScore
      id
      totalProjectsLinguistCount
      projectsForThisClientCount
    }
  }
`;

// The translators list asks for what that page shows and exports, and
// nothing else — the shared LIST_LINGUISTS below carries a dozen more
// fields (ratings for other brands, mediation status, banking) that this
// table never reads.
export const INTERPRETER_LIST = gql`
  query InterpreterList(
    $filterName: String
    $filterSourceLanguage: String
    $filterTargetLanguage: String
    $filterCity: String
    $mainService: [String]
    $offset: Int
    $limit: Int
    $projectType: String
    $order: String
    $orderBy: String
    $bidirectionalSearch: Boolean
    $filterSectors: [String]
    $filterModes: [String]
    $maxHourRate: Float
    $maxDayRate: Float
    $diaryFrom: String
    $diaryDays: Int
    $filterIds: [String]
    $onlyFree: Boolean
    $eventFrom: String
    $eventTo: String
    $clientId: String
    $withHistory: Boolean
    $nearCity: String
    $nearCountry: String
    $includeInterpreters: Boolean
  ) {
    Linguistdetails(
      filterName: $filterName
      filterSourceLanguage: $filterSourceLanguage
      filterTargetLanguage: $filterTargetLanguage
      City: $filterCity
      mainService: $mainService
      offset: $offset
      limit: $limit
      projectType: $projectType
      order: $order
      orderBy: $orderBy
      bidirectionalSearch: $bidirectionalSearch
      filterSectors: $filterSectors
      filterModes: $filterModes
      maxHourRate: $maxHourRate
      maxDayRate: $maxDayRate
      diaryFrom: $diaryFrom
      diaryDays: $diaryDays
      filterIds: $filterIds
      onlyFree: $onlyFree
      eventFrom: $eventFrom
      eventTo: $eventTo
      clientId: $clientId
      withHistory: $withHistory
      nearCity: $nearCity
      nearCountry: $nearCountry
      includeInterpreters: $includeInterpreters
    ) {
      linguists {
        id
        firstName
        lastName
        email
        phone
        city
        country
        image
        resume
        interpretationPairs {
          source
          target
          hourRate
          dayRate
          minuteRate
          experienceYears
        }
        interpretationModes
        # A MEDIATOR declares no interpreting pair and no mode: what they
        # have is the language they work in (with its variety) and where
        # they move from. The server fills these only for projectType
        # "Mediation" — null on an interpreting event.
        mediationLanguages {
          language
          dialect
          level
          isNative
          hourRate
          dayRate
          experienceYears
        }
        mobility {
          city
          province
          willingToTravel
          ownVehicle
        }
        # false when the row is only there because the search was widened to
        # the interpreters: the language is right, the mediation branch is not.
        mediationQualified
        expertiseSectors
        bookings {
          projectType
          itemId
          source
          timezone
          restricted
          start
          end
          kind
          status
          orderNumber
          projectId
          city
          client
          clientId
          modeCode
        }
        totalProjectsLinguistCount
        projectsForThisClientCount
        totalProjectsAllCount
        projectsByType {
          type
          count
        }
        distanceKm
        availabilityStatus
        availabilityReason
        unavailabilityStartDate
        unavailabilityEndDate
        weeklyAvailability {
          kind
          weekday
          startTime
          endTime
          note
        }
        history {
          total
          completed
          lastEventAt
          byMode {
            code
            count
          }
          cities {
            city
            count
          }
        }
        pmFeedback
        prFeedback
        feedbackCI
      }
      linguistsCount {
        filterCount
        totalCount
        completedCount
        blockedLinguist
        freeCount
      }
    }
  }
`;

// The allocation shortlist of the v2 project page (step 6): the translators
// for one pair with what the ranking reads — pair rate, past work for the
// client, feedback, words in hand — and what an allocation needs of them.
export const ALLOCATION_SHORTLIST = gql`
  query AllocationShortlist(
    $filterSourceLanguage: String
    $filterTargetLanguage: String
    $mainService: [String]
    $projectType: String
    $clientId: String
    $limit: Int
    $offset: Int
    $filterName: String
    $filterCity: String
    $filterSectors: [String]
    $filterServices: [String]
    $bidirectionalSearch: Boolean
    $withHistory: Boolean
    $orderBy: String
    $order: String
  ) {
    Linguistdetails(
      filterSourceLanguage: $filterSourceLanguage
      filterTargetLanguage: $filterTargetLanguage
      mainService: $mainService
      projectType: $projectType
      clientId: $clientId
      limit: $limit
      offset: $offset
      filterName: $filterName
      City: $filterCity
      filterSectors: $filterSectors
      filterServices: $filterServices
      bidirectionalSearch: $bidirectionalSearch
      withHistory: $withHistory
      orderBy: $orderBy
      order: $order
    ) {
      linguists {
        id
        firstName
        lastName
        email
        phone
        city
        country
        gender
        dob
        image
        resume
        mainLanguage
        otherLanguage
        languagePairs {
          source
          target
          ratePerWord
          experienceYears
        }
        expertiseSectors
        outputPerDay
        liveJobs
        liveWords
        unsizedJobs
        liveProjects {
          orderNumber
          status
          deliveryDateTime
        }
        onTimeJobs
        measuredJobs
        pmFeedback
        prFeedback
        totalProjectsLinguistCount
        projectsForThisClientCount
        totalProjectsAllCount
        projectsByType {
          type
          count
        }
      }
      linguistsCount {
        filterCount
      }
    }
  }
`;
export const TRANSLATOR_LIST = gql`
  query TranslatorList(
    $filterName: String
    $filterSourceLanguage: String
    $filterTargetLanguage: String
    $filterCity: String
    $mainService: [String]
    $filterServices: [String]
    $offset: Int
    $limit: Int
    $projectType: String
    $order: String
    $orderBy: String
    $bidirectionalSearch: Boolean
    $filterSectors: [String]
    $filterCatTools: [String]
    $maxRatePerWord: Float
    $filterIds: [String]
    $onlyFree: Boolean
  ) {
    Linguistdetails(
      filterName: $filterName
      filterSourceLanguage: $filterSourceLanguage
      filterTargetLanguage: $filterTargetLanguage
      City: $filterCity
      mainService: $mainService
      filterServices: $filterServices
      offset: $offset
      limit: $limit
      projectType: $projectType
      order: $order
      orderBy: $orderBy
      bidirectionalSearch: $bidirectionalSearch
      filterSectors: $filterSectors
      filterCatTools: $filterCatTools
      maxRatePerWord: $maxRatePerWord
      filterIds: $filterIds
      onlyFree: $onlyFree
    ) {
      linguists {
        id
        firstName
        lastName
        email
        phone
        city
        country
        gender
        dob
        image
        areaOfStudy
        otherLanguage
        mainLanguage
        resume
        languagePairs {
          source
          target
          ratePerWord
          experienceYears
        }
        expertiseSectors
        catTools
        outputPerDay
        jobType
        liveJobs
        staleJobs
        liveWords
        unsizedJobs
        liveProjects {
          orderNumber
          status
          deliveryDateTime
          sourceLanguage
          targetLanguage
        }
        onTimeJobs
        measuredJobs
        yearsExperience
        worksWhen
        totalProjectsLinguistCount
        pmFeedback
        prFeedback
        feedbackCI
      }
      linguistsCount {
        filterCount
        totalCount
        completedCount
        blockedLinguist
        freeCount
      }
    }
  }
`;

// The intercultural mediators list. It shares the Linguistdetails resolver
// with the other two vendor lists and asks it for a different set of
// fields, because a mediator is chosen on different grounds: the language
// AND THE VARIETY of it, the setting they work in, the town they set off
// from, and the appointments already in their diary.
export const MEDIATOR_LIST = gql`
  query MediatorList(
    $filterName: String
    $filterTargetLanguage: String
    $filterCity: String
    $mainService: [String]
    $offset: Int
    $limit: Int
    $projectType: String
    $order: String
    $orderBy: String
    $filterSectors: [String]
    $filterProvince: String
    $maxHourRate: Float
    $accountState: String
    $diaryFrom: String
    $diaryDays: Int
    $filterIds: [String]
    $onlyFree: Boolean
  ) {
    Linguistdetails(
      filterName: $filterName
      filterTargetLanguage: $filterTargetLanguage
      City: $filterCity
      mainService: $mainService
      offset: $offset
      limit: $limit
      projectType: $projectType
      order: $order
      orderBy: $orderBy
      filterSectors: $filterSectors
      filterProvince: $filterProvince
      maxHourRate: $maxHourRate
      accountState: $accountState
      diaryFrom: $diaryFrom
      diaryDays: $diaryDays
      filterIds: $filterIds
      onlyFree: $onlyFree
    ) {
      linguists {
        id
        firstName
        lastName
        email
        phone
        city
        country
        image
        resume
        mediationLanguages {
          language
          dialect
          level
          isNative
          hourRate
          dayRate
          experienceYears
        }
        expertiseSectors
        mobility {
          city
          province
          willingToTravel
          ownVehicle
        }
        weeklyAvailability {
          kind
          weekday
          startTime
          endTime
          note
        }
        documents {
          total
          valid
          rejected
          expiring
          nextExpiry
        }
        hoursWithUs
        bookings {
          start
          end
          kind
          status
          orderNumber
        }
        totalProjectsLinguistCount
        profileStatus
        mediationStatus
        # WHAT STATE THE ACCOUNT IS IN, derived from these three together
        # with profileStatus/mediationStatus by accountStateFromVendor
        # (src/utils/mediatorAccount.js, the mirror of the server's own
        # rules): the list's status column and the strip above it read the
        # same state the mediator's record shows.
        isBlacklisted
        blacklistMediation
        isOnBoardingCompleted
        pmFeedback
        feedbackCI
      }
      linguistsCount {
        filterCount
        totalCount
        completedCount
        blockedLinguist
        freeCount
        unconfirmedCount
      }
    }
  }
`;

export const LIST_LINGUISTS = gql`
  query Linguistdetails(
    $filterStatus: String
    $filterName: String
    $filterSourceLanguage: String
    $filterTargetLanguage: String
    $filterCity: String
    $mainService: [String]
    $filterRegion: String
    $filterServices: [String]
    $offset: Int
    $limit: Int
    $clientId: String
    $projectType: String
    $order: String
    $orderBy: String
    $bidirectionalSearch: Boolean
    $accountState: String
  ) {
    Linguistdetails(
      filterStatus: $filterStatus
      filterName: $filterName
      filterSourceLanguage: $filterSourceLanguage
      filterTargetLanguage: $filterTargetLanguage
      City: $filterCity
      Region: $filterRegion
      mainService: $mainService
      filterServices: $filterServices
      offset: $offset
      limit: $limit
      clientId: $clientId
      projectType: $projectType
      order: $order
      orderBy: $orderBy
      bidirectionalSearch: $bidirectionalSearch
      accountState: $accountState
    ) {
      linguists {
        id
        firstName
        lastName
        email
        gender
        phone
        areaOfStudy
        contactMethod
        profileCompletion
        type
        dob
        city
        address
        otherLanguage
        mainLanguage
        country
        iban
        resume
        image
        mainService
        feedbackScore
        pmFeedback
        prFeedback
        totalProjectsLinguistCount
        projectsForThisClientCount
        feedbackCI
        feedbackBZ
        sourceLanguages
        targetLanguages
        profileStatus
        mediationStatus
        blacklistMediation
        isOnBoardingCompleted
      }
      linguistsCount {
        filterCount
        totalCount
        completedCount
        mostlyCompletedCount
        missingInfromationCount
        blockedLinguist
        unconfirmedCount
        onboardingCount
        activeCount
        inactiveCount
      }
    }
  }
`;
export const BLACKLIST_LINGUISTS = gql`
  query getBlacklistLinguist(
    $filterStatus: String
    $filterName: String
    $filterScope: String
    $filterReason: String
    $filterWorked: Boolean
    $filterLogin: String
    $offset: Int
    $limit: Int
    $projectType: String
    $order: String
    $orderBy: String
  ) {
    getBlacklistLinguist(
      filterStatus: $filterStatus
      filterName: $filterName
      filterScope: $filterScope
      filterReason: $filterReason
      filterWorked: $filterWorked
      filterLogin: $filterLogin
      offset: $offset
      limit: $limit
      projectType: $projectType
      order: $order
      orderBy: $orderBy
    ) {
      linguists {
        id
        firstName
        lastName
        email
        phone
        city
        mainLanguage
        otherLanguage
        resume
        blacklistTranslation
        blacklistInterpretation
        blacklistMediation
        blacklistHostess
        blacklistReason
        blacklistUpdatedAt
        blacklistedBy {
          id
          name
        }
        isBlacklisted
        status
        statusReason
        registeredAt
        canSignIn
        jobsDone
        lastJobAt
      }
      linguistsCount {
        filterCount
        totalCount
        bannedEverything
        bannedTranslationOnly
        bannedInterpretationOnly
        bannedMediationOnly
        bannedHostessOnly
        bannedSeveral
        bannedNoScope
        withReason
        noReason
        stillSignIn
        everWorked
      }
    }
  }
`;
export const GET_FORMATTING_DETAILS = gql`
  query FormatterDetails($allocationId: String) {
    expenseAllocationId(allocationId: $allocationId) {
      id
      prepFileName
      prepFileNames
      totalWords
      projectManager
      title
      status
      orderNo
      projectId
      type
      notes
      endDateTime
      order_details
      formatter {
        id
        firstName
        lastName
        email
      }
    }
  }
`;
// THE BOOTHS OF THE EVENT, FOR THE INTERPRETER ON IT (report 05/10/2026,
// §5). The languages, the mode and the hours of every booth — and names only
// inside the caller's own booth. The server refuses it to anybody but the
// allocation's own linguist and intranet staff.
export const EVENT_BOOTHS = gql`
  query EventBooths($allocationId: String!) {
    eventBooths(allocationId: $allocationId) {
      boothCount
      booths {
        itemId
        pair
        mode
        when
        interpretersWanted
        confirmed
        mine
        colleagues
      }
    }
  }
`;
export const GET_SINGLE_ALLOCATION = gql`
  query AllocationById($allocationId: String) {
    allocationById(allocationId: $allocationId) {
      id
      linguistId
      clientId
      projectType
      projectManager
      orderNumber
      status
      deliveryDateTime
      targetLanguage
      sourceLanguage
      total
      creationDate
      projectId
      reviewReasons
      ratePerWord
      ratePerHour
      ratePerAdditionalHour
      # AG-01: il compenso del servizio e il rimborso spese, separati.
      serviceTotal
      expenseReimbursement
      expenseNote
      startDateTime
      endDateTime
      notes
      newWords
      ratePerWord
      pmFeedback
      feedbackCI
      feedbackBZ
      firstName
      lastName
      urgency
      completionDate
      categories
    }
  }
`;
// Is this allocation worked in Atlas, and how far did its delivery get there?
// Answered by the server from Atlas for the allocation's own linguist.
export const ATLAS_DELIVERY_STATUS = gql`
  query AtlasDeliveryStatus($allocationId: String!) {
    atlasDeliveryStatus(allocationId: $allocationId) {
      inAtlas
      atlasProjectId
      submittedCount
      totalCount
      allSubmitted
      error
      files {
        documentId
        fileName
        taskId
        taskType
        taskStatus
        submitted
      }
    }
  }
`;
// What the allocation's linguist still owes in Atlas: files whose task is not
// completed and that nobody approved (server-side read, intranet staff only).
// The PM's acceptance and the reopen dialog ask it (LY/6016, 15/10/2026).
export const ATLAS_OPEN_WORK = gql`
  query AtlasOpenWork($allocationId: String!) {
    atlasOpenWork(allocationId: $allocationId) {
      known
      inAtlas
      atlasProjectId
      openCount
      openFiles
      error
    }
  }
`;
// Step 7 of the v2 project page: Atlas's own progress per project of the
// order and who holds which task (server-side read, intranet staff only).
export const ATLAS_ORDER_PROGRESS = gql`
  query AtlasOrderProgress($orderId: ID!) {
    atlasOrderProgress(orderId: $orderId) {
      projects {
        atlasProjectId
        name
        completion
        taskCompletion
        basis
        totalDocuments
        error
        tasks {
          taskId
          taskType
          status
          assigneeUserId
          assigneeEmail
          assigneeName
          fileCount
          fileNames
        }
        documents {
          documentId
          fileName
          sourceLanguage
          targetLanguage
          completion
          words
          segments
          status
          stage
          assignees
        }
        languages {
          sourceLanguage
          targetLanguage
          completion
          basis
          documents
          unread
          words
          segments
        }
      }
    }
  }
`;
export const GET_SINGLE_PR_ALLOCATION = gql`
  query PRAllocationById($allocationId: ID!) {
    prallocationById(id: $allocationId) {
      id
      linguistId
      projectType
      projectManager
      orderNumber
      status
      deliveryDateTime
      targetLanguage
      sourceLanguage
      total
      creationDate
      projectId
      reviewReasons
      ratePerWord
      ratePerHour
      ratePerAdditionalHour
      startDateTime
      endDateTime
      notes
      newWords
      ratePerWord
      linguistallocations
    }
  }
`;
export const PR_ALLOCATION_BY_ID = gql`
  query PRAllocationById($allocationId: ID!, $email: String!) {
    prallocationById(id: $allocationId) {
      id
      linguistId
      projectType
      projectManager
      orderNumber
      status
      deliveryDateTime
      targetLanguage
      sourceLanguage
      total
      creationDate
      projectId
      reviewReasons
      ratePerWord
      ratePerHour
      ratePerAdditionalHour
      startDateTime
      endDateTime
      notes
      newWords
      ratePerWord
      linguistallocations
    }
    getUserData(email: $email) {
      firstName
      lastName
      image
      resume
      email
      dob
      phone
      mainLanguage
      otherLanguage
      country
      gender
    }
  }
`;
export const GET_PR_ALLOCATION = gql`
  query PRAllocationById($allocationId: ID!) {
    prallocationById(id: $allocationId) {
      id
      linguistId
      projectType
      orderNumber
      status
      projectId
      linguistallocations
    }
  }
`;

// ==============> COUNT <================

export const ALL_COUNTS = gql`
  query AllCounts(
    $filterStatus: [String]
    $filterLinguistStatus: String
    $filterCreationDate: [String]
    $filterStartDate: [String]
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
  ) {
    allInterpretationOrders(
      filterStatus: $filterStatus
      filterCreationDate: $filterCreationDate
      filterStartDate: $filterStartDate
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
    ) {
      interpretationOrderCount {
        totalCount
        deliveredCount
        allocatedCount
        claimedCount
      }
    }
    allTranslationOrders(
      filterStatus: $filterStatus
      filterCreationDate: $filterCreationDate
      filterDeliveryDateTime: $filterStartDate
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
    ) {
      translationOrderCount {
        totalCount
        deliveredCount
        allocatedCount
        claimedCount
      }
    }
    allBarzanoOrders(
      filterStatus: $filterStatus
      filterCreationDate: $filterCreationDate
      filterDeliveryDateTime: $filterStartDate
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
    ) {
      barzanoOrderCount {
        totalCount
        deliveredCount
        allocatedCount
        claimedCount
      }
    }
    allVideoConferenceOrders(filterStatus: $filterLinguistStatus) {
      videoConferenceOrderCount {
        totalCount
        deliveredCount
        allocatedCount
        claimedCount
      }
    }
    allLinguists(filterStatus: $filterLinguistStatus) {
      linguistsCount {
        totalCount
      }
    }
  }
`;

export const ALL_QUOTE_COUNTS = gql`
  query AllQuoteCounts {
    allInterpretationQuoteCount {
      interpretationOrderCount {
        TBSCount
        closedCount
        totalCount
        openCount
        awardedCount
        claimedCount
      }
    }
    allTranslationQuoteCount {
      translationOrderCount {
        TBSCount
        closedCount
        totalCount
        openCount
        awardedCount
        claimedCount
      }
    }
  }
`;

export const FILTER_QUOTE_AND_PROJECT_COUNT = gql`
  query FilterQuoteAndProject($date: String) {
    quotesOrdersCount(date: $date) {
      filterQuoteCount
      filterProjectCount
    }
  }
`;
export const FILTER_AWARDED_QUOTE_AND_PROJECT_TOTAL = gql`
  query FilterAwardedQuoteAndProject($date: String) {
    awardedQuoteTotal(date: $date) {
      filterAwarderQuoteCount
    }
  }
`;
export const AWARDED_QUOTE_AND_PROJECT_TODAL = gql`
  query FilterAwardedQuoteAndProject($year: String) {
    translationProjectTotal(year: $year) {
      filterAwarderQuoteCount
    }
    InterpretaionProjectTotal(year: $year) {
      filterAwarderQuoteCount
    }
  }
`;
export const FILTER_QUOTE_COUNTS = gql`
  query AllQuoteCounts($date: String) {
    translationQuoteOrdersCount(date: $date) {
      filterQuoteCount
      filterProjectCount
    }
    InterpretationQuoteOrdersCount(date: $date) {
      filterQuoteCount
      filterProjectCount
    }
  }
`;
// LINGUIST PORTAL

export const FETCH_EXPERTISE = gql`
  query GetTranslationExpertise {
    getTranslationExpertise {
      selectedFields
      communication {
        corporateCommunication {
          isActive
          experience
          estimate
        }
        journalismPublications {
          isActive
          experience
          estimate
        }
        pressRelease {
          isActive
          experience
          estimate
        }
        publishing {
          isActive
          experience
          estimate
        }
      }
      marketing {
        adCopy {
          isActive
          experience
          estimate
        }
        generalMarketing {
          isActive
          experience
          estimate
        }
        hotel {
          isActive
          experience
          estimate
        }
        leisure {
          isActive
          experience
          estimate
        }
        printAdvertising {
          isActive
          experience
          estimate
        }
        sportsAndFitness {
          isActive
          experience
          estimate
        }
        tourismTravel {
          isActive
          experience
          estimate
        }
        cruises {
          isActive
          experience
          estimate
        }
        transports {
          isActive
          experience
          estimate
        }
      }
      education {
        parent {
          isActive
          experience
          estimate
        }
        teacher {
          isActive
          experience
          estimate
        }
      }
      foodAndBeverage {
        generalFoodandBeverage {
          isActive
          experience
          estimate
        }
        menu {
          isActive
          experience
          estimate
        }
        workPercentage {
          experience
        }
      }
      retail {
        apparel {
          isActive
          experience
          estimate
        }
        beauty {
          isActive
          experience
          estimate
        }
        consumerProducts {
          isActive
          experience
          estimate
        }
        durables {
          isActive
          experience
          estimate
        }
        toysandCrafts {
          isActive
          experience
          estimate
        }
      }
      insurance {
        forms {
          isActive
          experience
          estimate
        }
        healthInsuranceForm {
          isActive
          experience
          estimate
        }
        policy {
          isActive
          experience
          estimate
        }
      }
      financial {
        accounting {
          isActive
          experience
          estimate
        }
        generalFinance {
          isActive
          experience
          estimate
        }
        lettertoEmployees {
          isActive
          experience
          estimate
        }
        annualReports {
          isActive
          experience
          estimate
        }
        assetManagement {
          isActive
          experience
          estimate
        }
        basicBanking {
          isActive
          experience
          estimate
        }
        benefitsInformation {
          isActive
          experience
          estimate
        }
        businessCards {
          isActive
          experience
          estimate
        }
        financialInstruments {
          isActive
          experience
          estimate
        }
        generalInvestment {
          isActive
          experience
          estimate
        }
        hedgingRiskManagement {
          isActive
          experience
          estimate
        }
        investmentAnalyses {
          isActive
          experience
          estimate
        }
        marketCommentary {
          isActive
          experience
          estimate
        }
        prospectus {
          isActive
          experience
          estimate
        }
        securitizations {
          isActive
          experience
          estimate
        }
      }
      humanResources {
        handbooksAndManuals {
          isActive
          experience
          estimate
        }
        newsletters {
          isActive
          experience
          estimate
        }
        policy {
          isActive
          experience
          estimate
        }
      }
      learningandDevelopment {
        businessandSoftSkills {
          isActive
          experience
          estimate
        }
        educationK12 {
          isActive
          experience
          estimate
        }
        ethicsandCompliance {
          isActive
          experience
          estimate
        }
        financialSAPOracle {
          isActive
          experience
          estimate
        }
        healthandSafety {
          isActive
          experience
          estimate
        }
        managementDevelopment {
          isActive
          experience
          estimate
        }
        salesTraining {
          isActive
          experience
          estimate
        }
        technical {
          isActive
          experience
          estimate
        }
      }
      legal {
        contracts {
          isActive
          experience
          estimate
        }
        depositionNotice {
          isActive
          experience
          estimate
        }
        employeeCorrespondence {
          isActive
          experience
          estimate
        }
        federalCourt {
          isActive
          experience
          estimate
        }
        financial {
          isActive
          experience
          estimate
        }
        governmentNGO {
          isActive
          experience
          estimate
        }
        insurance {
          isActive
          experience
          estimate
        }
        leaseAgreement {
          isActive
          experience
          estimate
        }
        mergersandAcquisitions {
          isActive
          experience
          estimate
        }
        personalDocuments {
          isActive
          experience
          estimate
        }
        stateCourt {
          isActive
          experience
          estimate
        }
        termsandConditions {
          isActive
          experience
          estimate
        }
        courtPapers {
          isActive
          experience
          estimate
        }
      }
      patents {
        automotivePatents {
          isActive
          experience
          estimate
        }
        chemicalPatents {
          isActive
          experience
          estimate
        }
        engineeringPatents {
          isActive
          experience
          estimate
        }
        generalPatents {
          isActive
          experience
          estimate
        }
        pharmaOrMedicalPatents {
          isActive
          experience
          estimate
        }
        semiconductorPatents {
          isActive
          experience
          estimate
        }
        technicalPatents {
          isActive
          experience
          estimate
        }
      }
      technical {
        aeronauticsAerosapace {
          isActive
          experience
          estimate
        }
        automation {
          isActive
          experience
          estimate
        }
        automotive {
          isActive
          experience
          estimate
        }
        construction {
          isActive
          experience
          estimate
        }
        electronics {
          isActive
          experience
          estimate
        }
        engineeringChemical {
          isActive
          experience
          estimate
        }
        engineeringCivil {
          isActive
          experience
          estimate
        }
        engineeringGeneral {
          isActive
          experience
          estimate
        }
        engineeringMechanical {
          isActive
          experience
          estimate
        }
        environmental {
          isActive
          experience
          estimate
        }
        iTDocandHelpUA {
          isActive
          experience
          estimate
        }
        iTERPOrCRM {
          isActive
          experience
          estimate
        }
        iTGames {
          isActive
          experience
          estimate
        }
        iTGeneral {
          isActive
          experience
          estimate
        }
        iTGraphicsSoftware {
          isActive
          experience
          estimate
        }
        iTHardware {
          isActive
          experience
          estimate
        }
        iTSoftwareUI {
          isActive
          experience
          estimate
        }
        iTMarketing {
          isActive
          experience
          estimate
        }
        iTSoftwareUIIVRS {
          isActive
          experience
          estimate
        }
        iTSoftwareUISoftwareMarketing {
          isActive
          experience
          estimate
        }
        iTSoftwareUISoftwareTraining {
          isActive
          experience
          estimate
        }
        iTTechincalMarketing {
          isActive
          experience
          estimate
        }
        machinery {
          isActive
          experience
          estimate
        }
      }
      lifeScience {
        batchRecords
        biochemistryDrugComposition
        justificationLetter
        changeforProtocolSummary
        clinicalStudyReport
        clinicalReportedOutcome
        clinicalReportedProtocol
        cRFCaseReviewForm
        cROClinicianReportedOutcome
        clinicalTrialAgreement
        cVCurriculumVitae
        dischargeSummary
        doctorPatientTranscript
        druglabel
        dLearning
        dthicsCommitteeLetter
        financialDisclosure
        generalLifeSciences
        dlobalCommunications
        handwrittenPatientNotes
        healthQuestionnaireNonClinical
        healthcareMarketingClinical
        healthcareMarketingNonClinical
        investigatorBrochure
        informedConsentForm
        impd
        indemnificationLetter
        investigatorMeeting
        investigatorSiteBinderDocs
        iVRSScripts
        labManualFlowchart
        localECSubmissionDocuments
        mAAeCTDNDA
        manufacturerAuthorization
        medicalLicenses
        neuropsychologicalAssessment
        normalLabRanges
        observerReportedOutcome
        packageInsert
        plainLanguageSummary
        patientMedicalReport
        patientBrochure
        patientCard
        patientDiary
        patientInformationLeaflet
        patientRecruitmentMaterial
        productMonograph
        powerofAttorney
        patientReportedOutcomes
        productCharacteristicsSummary
        publicHealthInformation
        qualifiedPersonCertificate
        rASubmissionLetter
        regulatorySubmissionLetter
        sap
        scientificJournalsArticles
        seriousAdverseEventsForm
        siteContract
        standardOperatingProcedures
        studyBudget
        training
      }
      medicalAreas {
        anesthetics
        animalHealth
        cardiology
        dental
        dermatology
        elderlyMedicine
        emergencyMedicine
        endocrinology
        formsProcedures
        gastroenterology
        generalMedicine
        generalPractice
        gynecology
        healthNutrition
        hematology
        hepatology
        hereditaryDisordersGenetics
        immunology
        infectiousDisease
        medicalMarketing
        neurology
        nurses
        obstetrics
        oncology
        ophthalmology
        otolaryngologyENT
        pediatrics
        pharmacists
        physicalMedicalRehabilitation
        psychiatry
        radiology
        resipirotaryPumonology
        rheumatology
        surgery
        thoracicMedicine
        urology
        vaccines
        allergy
      }
      medicalDevices {
        consumerDevices
        dental
        iFUDFU
        hospitalEquipment
        imagingRadiotherapy
        inVitroDiagnostics
        orthopedics
        shonin
        softwareManuals
        stentsGraftsCatheters
        surgicalInstruments
        vascularInterventions
        labelling
        marketing
      }
      medicalMaterials {
        medicalEducation
        medicalManuals
        medicalProcedures
        medicalReference
        medicalResearch
        medicalReviews
        medicalWeb
      }
      digitalMarketing {
        searchEngineOptimization
        searchEngineMarketing
        payPerClick
      }
      socialMedia {
        communityManagement
      }
      other {
        isActive
        experience
        estimate
      }
    }
  }
`;

export const FETCH_ACTIVITY = gql`
  query GetTranslationActivty {
    getTranslationActivty {
      translation {
        isActive
        values {
          title
          sourceLanguage
          targetLanguage
          experience
        }
      }
      notarisedTranslation {
        isActive
        values {
          title
          sourceLanguage
          targetLanguage
          experience
        }
      }
      swornTranslation {
        isActive
        values {
          title
          sourceLanguage
          targetLanguage
          experience
        }
      }
      backTranslation {
        isActive
        values {
          title
          sourceLanguage
          targetLanguage
          experience
        }
      }
      proofreadingEditing {
        isActive
        values {
          title
          sourceLanguage
          targetLanguage
          experience
        }
      }
      qualityCheck {
        isActive
        values {
          title
          sourceLanguage
          targetLanguage
          experience
        }
      }
      revision {
        isActive
        values {
          title
          sourceLanguage
          targetLanguage
          experience
        }
      }
      reconciliation {
        isActive
        values {
          title
          sourceLanguage
          targetLanguage
          experience
        }
      }
      backeEditing {
        isActive
        values {
          title
          sourceLanguage
          targetLanguage
          experience
        }
      }
      onSiteDocumentReview {
        isActive
        values {
          title
          sourceLanguage
          targetLanguage
          experience
        }
      }
      postDTPProofreading {
        isActive
        values {
          title
          sourceLanguage
          targetLanguage
          experience
        }
      }
      ligthMTPostEditing {
        isActive
        values {
          title
          sourceLanguage
          targetLanguage
          experience
        }
      }
      fullMTPostEditing {
        isActive
        values {
          title
          sourceLanguage
          targetLanguage
          experience
        }
      }
    }
  }
`;

export const FETCH_TECHNOLOGY_QUERY = gql`
  query GetTranslationTechnologyType {
    getTranslationTechnologyType {
      wordfast {
        wordfastPro3
        wordfastPro5
        wordfastClassic
        wordfastAnywhere
      }
      alchemyCetalyst {
        cetalyst7
        cetalyst8
        cetalyst9
        cetalyst12
      }
      alchemyPublisher {
        publisher2
        publisher3
      }
      trados {
        studio2015
        studio2017
        studio2019
        studio2021
      }
      otherComputerAssistedTranslationTools {
        transcend
        sdlx
        dejaVu
        passolo
        idiom
        msLocStudio
        memoQ
        omegaT
        across
      }
      software {
        adobePdf
        catCourtReporting
        eclipseCourtReporting
        visio
        msOffice
        tmsEtma
      }
      tradosEmail
    }
  }
`;

export const FETCH_RATE = gql`
  query GetTranslationRate {
    getTranslationRate {
      Rate {
        activity
        languageSource
        languageTarget
        rateType
      }
      mTPeERates {
        activity
        languageSource
        languageTarget
        rateType
      }
      editingRates {
        activity
        languageSource
        languageTarget
        rateType
      }
      onSiteDocumentReviewRates {
        activity
        languageSource
        languageTarget
        rateType
      }
      travelExpensesperday
      cancellationTermsdays
    }
  }
`;

export const FETCH_USER_QUERY = gql`
  query GetUserData($email: String!) {
    getUserData(email: $email) {
      companyName
      firstName
      email
      lastName
      gender
      image
      dob
      contactMethod
      about
      phone
      mainLanguage
      otherLanguage
      address1
      address2
      city
      country
      postal
      timezone
      college
      startDate
      endDate
      degree
      areaOfStudy
      website
      workingFor
      businessType
      sizeClassification
      numberEmployee
      resume
      mainService
      profileTitle
      iban
      bic
      bankname
      taxid
      profileCompletion
      imageForm
      personalForm
      contactForm
      educationForm
      workForm
      businessForm
      paymentForm
      availabilityStatus
      unavailabilityStartDate
      unavailabilityEndDate
      autoSetAvailable
      availabilityReason
    }
  }
`;

export const FETCH_INTERPRETER_SERVICES = gql`
  query GetServiceInterpreter {
    getServiceInterpreter {
      asylum {
        isChecked
        assignmentTime
      }
      attorney {
        isChecked
        assignmentTime
      }
      deposition {
        isChecked
        assignmentTime
      }
      fcpa {
        isChecked
        assignmentTime
      }
      insurance {
        isChecked
        assignmentTime
      }
      intellectual {
        isChecked
        assignmentTime
      }
      redundancy {
        isChecked
        assignmentTime
      }
      trial {
        isChecked
        assignmentTime
      }
      workerCompensation {
        isChecked
        assignmentTime
      }
      healthcareOffice {
        isChecked
        assignmentTime
      }
      hospitalExam {
        isChecked
        assignmentTime
      }
      medicalDevice {
        isChecked
        assignmentTime
      }
      medicalExam {
        isChecked
        assignmentTime
      }
      mentalHealth {
        isChecked
        assignmentTime
      }
      audit {
        isChecked
        assignmentTime
      }
      investigatorsMeeting {
        isChecked
        assignmentTime
      }
      computerHardware {
        isChecked
        assignmentTime
      }
      energy {
        isChecked
        assignmentTime
      }
      Patents {
        isChecked
        assignmentTime
      }
      engineering {
        isChecked
        assignmentTime
      }
      advisoryBoards {
        isChecked
        assignmentTime
      }
      agribusiness {
        isChecked
        assignmentTime
      }
      businessMeet {
        isChecked
        assignmentTime
      }
      finance {
        isChecked
        assignmentTime
      }
      humanResources {
        isChecked
        assignmentTime
      }
      shareholderMeet {
        isChecked
        assignmentTime
      }
      aviation {
        isChecked
        assignmentTime
      }
      automotive {
        isChecked
        assignmentTime
      }
      railroads {
        isChecked
        assignmentTime
      }
      maritime {
        isChecked
        assignmentTime
      }
      disciplinaryMeet {
        isChecked
        assignmentTime
      }
      iepMeet {
        isChecked
        assignmentTime
      }
      parentMeet {
        isChecked
        assignmentTime
      }
      specialEducation {
        isChecked
        assignmentTime
      }
      studentEvaluations {
        isChecked
        assignmentTime
      }
      diplomacy {
        isChecked
        assignmentTime
      }
      disasterRecovery {
        isChecked
        assignmentTime
      }
      euParliament {
        isChecked
        assignmentTime
      }
      internationalDevelopment {
        isChecked
        assignmentTime
      }
      publicHealth {
        isChecked
        assignmentTime
      }
      socialServices {
        isChecked
        assignmentTime
      }
      stateDepartment {
        isChecked
        assignmentTime
      }
      unitedNations {
        isChecked
        assignmentTime
      }
      culturalConsultant {
        isChecked
        assignmentTime
      }
      cultureArts {
        isChecked
        assignmentTime
      }
      mediaPress {
        isChecked
        assignmentTime
      }
      personalAssistant {
        isChecked
        assignmentTime
      }
      retail {
        isChecked
        assignmentTime
      }
      sports {
        isChecked
        assignmentTime
      }
      tourGuide {
        isChecked
        assignmentTime
      }
      foodBeverage {
        isChecked
        assignmentTime
      }
      marketing {
        isChecked
        assignmentTime
      }
      landLines
      camera
      speedConnection
      hardware {
        microphone
        headphones
        printer
      }
      machine
      preferredBrowser
      overPhoneAvailable
      freelancerType
      newRequestTime
      freelanceExperience
      listClient
      isRSIshow
      RSI {
        sourceLanguage
        targetLanguage
        experience
        minuteRate
        hourRate
        dayRate
        fullDayRate
      }
      isRCIshow
      RCI {
        sourceLanguage
        targetLanguage
        experience
        minuteRate
        hourRate
        dayRate
        fullDayRate
      }
      isOnsite_Consecutiveshow
      Onsite_Consecutive {
        sourceLanguage
        targetLanguage
        experience
        minuteRate
        hourRate
        dayRate
        fullDayRate
      }
      isSimultaneousshow
      Simultaneous {
        sourceLanguage
        targetLanguage
        experience
        minuteRate
        hourRate
        dayRate
        fullDayRate
      }
      currency
      travelExpense
      cancelationTerm
      isSwornShow
      isPhoneInterpretation
      isNotarizedshow
      isBackshow
      isRevisionsshow
    }
  }
`;

export const FETCH_AVAILABILITY_QUERY = gql`
  query GetTranslationTechnologyType {
    getTranslationAvailability {
      fulltimeorpartTime
      dailyTranslationOutput
      mostTranslationRequests
      workingProfessionalTranslator {
        years
        months
      }
      experienceOrProfessionalHistory
    }
  }
`;

export const GET_ONLY_USER_CALLS_STATS = gql`
  query GetUserCalls {
    getOnlyUserCalls {
      callerNum
      callStatus
      DateandTime
      duration
      errorCode
      failureReason
    }
  }
`;

// ==============> GET ALL USER CALLS RECORDS <================

export const GET_ALL_USER_CALLS_STATS = gql`
  query GetAllUsersCalls($date: [String]) {
    getAllUserCalls(date: $date) {
      _id
      name
      avatarUrl
      department
      calls {
        _id
        DateandTime
        callStatus
        callerNum
        duration
        endTime
        startTime
      }
    }
  }
`;

// Email history: the individual manual sends (detail table).
export const GET_EMAIL_HISTORY = gql`
  query GetEmailHistory($date: [String]) {
    getEmailHistory(date: $date) {
      id
      date
      senderName
      senderEmail
      sentByUserName
      department
      recipient
      recipients {
        email
        name
        type
      }
      recipientsCount
      subject
      category
      status
      bodyHtml
      isAutomatic
      failureReason
      attachments {
        filename
        url
      }
      timeline {
        status
        timestamp
      }
    }
  }
`;

// Email activity time series: daily manual-email counts by type and department.
export const GET_EMAIL_ACTIVITY = gql`
  query GetEmailActivity($date: [String]) {
    getEmailActivity(date: $date) {
      date
      type
      department
      status
      count
    }
  }
`;

// Activity report: calls + manual emails by type, per BD/AM member.
export const GET_TEAM_ACTIVITY = gql`
  query GetTeamActivity($date: [String]) {
    getTeamActivity(date: $date) {
      id
      name
      email
      avatarUrl
      department
      callsAnswered
      callsDurationSec
      emailsTotal
      emailsByType {
        type
        count
      }
      emailsDelivered
      emailsOpened
      emailsClicked
      emailsBounced
    }
  }
`;

// ==============> ONE MEMBER'S ACTIVITY (the member page's Activity tab) <================
// The team activity documents narrowed by `userId`. They are their own
// documents so the team report never sends an argument a server that has not
// been updated would refuse.

export const GET_MEMBER_ACTIVITY = gql`
  query GetMemberActivity($date: [String], $userId: ID!) {
    getTeamActivity(date: $date, userId: $userId) {
      id
      name
      email
      department
      callsAnswered
      callsDurationSec
      emailsTotal
      emailsByType {
        type
        count
      }
      emailsDelivered
      emailsOpened
      emailsClicked
      emailsBounced
    }
  }
`;

export const GET_MEMBER_CALLS = gql`
  query GetMemberCalls($date: [String], $userId: ID!) {
    getAllUserCalls(date: $date, userId: $userId) {
      _id
      name
      department
      calls {
        _id
        DateandTime
        callStatus
        duration
      }
    }
  }
`;

export const GET_MEMBER_EMAIL_ACTIVITY = gql`
  query GetMemberEmailActivity($date: [String], $userId: ID!) {
    getEmailActivity(date: $date, userId: $userId) {
      date
      type
      department
      status
      count
    }
  }
`;

export const GET_MEMBER_EMAIL_HISTORY = gql`
  query GetMemberEmailHistory($date: [String], $userId: ID!) {
    getEmailHistory(date: $date, userId: $userId) {
      id
      date
      senderName
      senderEmail
      sentByUserName
      department
      recipient
      recipients {
        email
        name
        type
      }
      recipientsCount
      subject
      category
      status
      bodyHtml
      isAutomatic
      failureReason
      attachments {
        filename
        url
      }
      timeline {
        status
        timestamp
      }
    }
  }
`;

// ==============> GET TWILIO TOKEN <================

export const GET_TOKEN = gql`
  query GetTwilioToken {
    getToken {
      token
    }
  }
`;

// ==============> GET CLIENT CALLS <================

export const GET_CLIENT_CALLS = gql`
  query GetClientCalls(
    $clientId: String!
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
    $filterStatus: [String]
    $filterDateRange: [String]
    $filterPhone: String
  ) {
    getClientCalls(
      clientId: $clientId
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
      filterStatus: $filterStatus
      filterDateRange: $filterDateRange
      filterPhone: $filterPhone
    ) {
      calls {
        _id
        callerNum
        DateandTime
        duration
        startTime
        endTime
        callStatus
        callSid
        isTranscribed
        callTranscription
        callSummary
        sourcePage
        transcriptionStatus
        transcriptionError
        recordingSid
      }
      callsCount {
        filterCount
        totalCount
      }
    }
  }
`;

export const GET_ORDER_CALLS = gql`
  query GetOrderCalls(
    $orderId: String!
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
    $filterStatus: [String]
    $filterDateRange: [String]
    $filterPhone: String
  ) {
    getOrderCalls(
      orderId: $orderId
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
      filterStatus: $filterStatus
      filterDateRange: $filterDateRange
      filterPhone: $filterPhone
    ) {
      calls {
        _id
        callerNum
        DateandTime
        duration
        startTime
        endTime
        callStatus
        callSid
        isTranscribed
        callTranscription
        callSummary
        sourcePage
        transcriptionStatus
        transcriptionError
        recordingSid
      }
      callsCount {
        filterCount
        totalCount
      }
    }
  }
`;

// ==============> GET ALL ITALIAN CITIES <================

export const GET_CITIES = gql`
  query AllItalionCities {
    allItalionCities {
      cityName
    }
  }
`;

// ==============> GET ALL ITALIAN REGIONS <================

export const GET_REGIONS = gql`
  query AllItalionRegions {
    allItalionRegions {
      regionName
    }
  }
`;

// ==============> GET SINLGE PROJECT FILES <================

export const GET_CLIENT_PROJECT_FILES = gql`
  query ProjectFiles($id: String!) {
    projectFiles(id: $id) {
      id
      projectId
      files {
        fileName
        size
      }
      folders {
        client_delivery {
          fileName
          size
          userId
          userType
          createdAt
        }
      }
    }
  }
`;
// ONE PROJECT'S VAULT: its folders, and what each of them holds.
//
// Project_Manager — capitalised — is a legacy folder on 55 old vaults, about
// 130 files. It had no field in the schema until 08/10/2026, so GraphQL
// dropped it and those files could not be reached from the portal at all.
// The four readings (fileCount, totalSize, folderCount, lastFileAt) are the
// server's, counted over every folder the record actually holds.
//
// The PUBLIC folder page reads PUBLIC_FOLDER_FILES below since 29/10/2026.
export const GET_SINGLE_PROJECT_FILES = gql`
  query ProjectFiles($id: String!) {
    projectFiles(id: $id) {
      id
      projectId
      orderNumber
      projectType
      files {
        fileName
        size
      }
      folders {
        original {
          fileName
          size
          userId
          userType
          createdAt
        }
        technician_Material {
          fileName
          size
          userId
          userType
          createdAt
        }
        translated {
          fileName
          size
          linguistId
          userType
          createdAt
          userId
          source
          atlasDocumentId
          atlasFileName
          linguistEmail
          acceptedByUserId
        }
        Support_Material {
          fileName
          size
          userId
          userType
          createdAt
        }
        project_manager {
          fileName
          size
          userId
          userType
          createdAt
          linguistId
          source
          approvedAt
          promotedFileName
          formatterExpenseId
        }
        formatted {
          fileName
          size
          userId
          userType
          createdAt
          linguistId
          source
          layoutJobId
          formatterExpenseId
          originalFileName
          outputName
          approvedAt
          approvedBy {
            id
            name
          }
          promotedFileName
          formatterExpenseId
        }
        client_delivery {
          fileName
          size
          userId
          userType
          createdAt
        }
        Proofreaded {
          fileName
          size
          linguistId
          createdAt
          userType
        }
      }
    }
  }
`;

// THE PUBLIC FOLDER PAGE (/files/:id/:fileType, a link a client receives):
// the one folder the link names and what a client sees of each file. Each
// folder sits behind its own @include, so the answer carries that folder
// alone instead of every folder of the vault with its internal fields.
export const PUBLIC_FOLDER_FILES = gql`
  query PublicFolderFiles(
    $id: String!
    $original: Boolean = false
    $translated: Boolean = false
    $supportMaterial: Boolean = false
    $projectManager: Boolean = false
    $legacyProjectManager: Boolean = false
    $formatted: Boolean = false
    $clientDelivery: Boolean = false
    $technicianMaterial: Boolean = false
    $proofreaded: Boolean = false
  ) {
    projectFiles(id: $id) {
      id
      orderNumber
      folders {
        original @include(if: $original) {
          fileName
          size
          createdAt
        }
        translated @include(if: $translated) {
          fileName
          size
          createdAt
        }
        Support_Material @include(if: $supportMaterial) {
          fileName
          size
          createdAt
        }
        project_manager @include(if: $projectManager) {
          fileName
          size
          createdAt
        }
        Project_Manager @include(if: $legacyProjectManager) {
          fileName
          size
          createdAt
        }
        formatted @include(if: $formatted) {
          fileName
          size
          createdAt
        }
        client_delivery @include(if: $clientDelivery) {
          fileName
          size
          createdAt
        }
        technician_Material @include(if: $technicianMaterial) {
          fileName
          size
          createdAt
        }
        Proofreaded @include(if: $proofreaded) {
          fileName
          size
          createdAt
        }
      }
    }
  }
`;

export const GET_SINGLE_PROJECT_FILES_BY_PROJECTID = gql`
  query projectFilesbyId($projectId: String!) {
    projectFilesbyId(projectId: $projectId) {
      id
      projectId
      orderNumber
      projectType
      files {
        fileName
        size
      }
      folders {
        original {
          fileName
          size
          createdAt
          userType
          source
          outputName
          patentStage
          prep {
            selectable
            pages
            route
            autoRoutedAt
            manualReason
            templateId
            layoutJobId
            layoutStatus
            layoutMessage
            layoutIssues
            outputFileName
            outputSize
            decision
            decidedAt
            decidedBy {
              id
              name
            }
            formatterExpenseId
        deliveredFileName
            checkedAt
            checkReason
          }
        }
        translated {
          fileName
          size
          linguistId
          createdAt
          atlasDocumentId
          atlasFileName
          source
          userType
          atlasProjectId
          atlasMtDocumentId
          translationVersion
          atlasTargetLocale
        }
        project_manager {
          fileName
          size
          createdAt
          linguistId
          userType
          source
          layoutJobId
          formatterExpenseId
          originalFileName
          outputName
          patentStage
          approvedAt
          promotedFileName
          formatterExpenseId
        }
        formatted {
          fileName
          size
          createdAt
          userId
          userType
          linguistId
          source
          layoutJobId
          formatterExpenseId
          originalFileName
          outputName
          approvedAt
          approvedBy {
            id
            name
          }
          promotedFileName
          formatterExpenseId
        }
        technician_Material {
          fileName
          size
          createdAt
        }
        Support_Material {
          fileName
          size
          createdAt
        }
        client_delivery {
          fileName
          size
          createdAt
        }
        Proofreaded {
          fileName
          size
          linguistId
          createdAt
        }
      }
    }
  }
`;

// ==============> GET ALL PROJECT FILES <================
//
// THE VAULT LIST. What the vault holds — how many files, how big, which
// folders, when the last one arrived — is COUNTED ON THE SERVER (fileCount,
// totalSize, folderCount, folderNames, lastFileAt, 08/10/2026), so the list
// no longer ships five folder arrays per row to add them up in the browser.
// It used to ask for five of the seven folders and sum four of them, which
// undercounted every Translation vault with a Proofreaded folder (1 380 of
// them), every Interpretation vault with technician material (284) and every
// Mediation vault (13, counted as 0 B). A page of 50 rows was ~2 MB of file
// names nothing drew; it is now a few hundred bytes.
//
// counts is the page's readings: the whole archive, this answer's own size,
// how many vaults are empty, and the count per kind — which dodges the kind
// filter, so each of its options stays a switch.

export const GET_ALL_PROJECT_FILES = gql`
  query allProjectsFiles(
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
    $orderNumber: String
  ) {
    allProjectsFiles(
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
      orderNumber: $orderNumber
    ) {
      count
      projects {
        id
        orderNumber
        projectId
        projectType
        createdAt
        files {
          fileName
          size
        }
        folders {
          original {
            fileName
            size
          }
          translated {
            fileName
            size
          }
          project_manager {
            fileName
            size
          }
          Support_Material {
            fileName
            size
          }
          client_delivery {
            fileName
            size
          }
        }
      }
    }
  }
`;
export const GET_POSTS = gql`
  query getPosts {
    getPosts {
      _id
      title
      createdAt
      cover
      description
    }
  }
`;
// The articles page. `content` is left out on purpose: the list shows the
// summary, and an article body is HTML the rows never render.
export const GET_ARTICLES = gql`
  query getArticles(
    $search: String
    $audiences: [String]
    $limit: Int
    $offset: Int
  ) {
    getArticles(
      search: $search
      audiences: $audiences
      limit: $limit
      offset: $offset
    ) {
      total
      counts {
        audience
        count
      }
      rows {
        _id
        title
        description
        cover
        createdAt
        updatedAt
        userType
        author {
          id
          name
        }
      }
    }
  }
`;
export const GET_ARTICLE = gql`
  query getArticle($id: ID!) {
    getArticle(id: $id) {
      _id
      title
      description
      content
      cover
      createdAt
      updatedAt
      userType
      author {
        id
        name
      }
    }
  }
`;
export const GET_LOGS = gql`
  query Logs($uid: ID, $limit: Int, $skip: Int) {
    logsByUID(uid: $uid, limit: $limit, skip: $skip) {
      action
      DateAndTime
      _id
      uid
      type
      description
      user {
        id
        name
      }
    }
  }
`;
export const GET_LOGS_COUNT = gql`
  query LogsCount($uid: ID) {
    logsCountByUID(uid: $uid)
  }
`;
export const GET_QUOTES_AND_PROJECTS = gql`
  query allProjectsAndQuotes(
    $stage: String
    $offset: Int
    $limit: Int
    $clientId: String
  ) {
    allQuoteAndProjects(
      stage: $stage
      offset: $offset
      limit: $limit
      clientID: $clientId
    ) {
      allOrderCount {
        totalCount
      }
      allOrders {
        id
        orderNumber

        projectManager {
          name
        }
        accountManager {
          name
        }
        subtotal
        bookedBy {
          firstName
          lastName
        }
        status
        createdAtDate
        stage
        grandTotal
        netTotal
        type
        quoteNumber
        industry {
          name
        }
        translationItem
        interpretationItem
      }
    }
  }
`;

export const GET_TRANSLATION_BARZANO_ORDERS = gql`
  query TranslationQuoteOrdersCount($date: String) {
    translationBarzanoQuoteOrders(date: $date) {
      translationBarzanoProjects {
        id
        bookedBy {
          firstName
          lastName
        }
        translationItem
        barzanoItem
        bugnionItem
        academyItem
        softwaredevItem
        type
        companyNameAndId {
          accountType
          name
        }
        orderNumber
        stage
        status
        netTotal
      }
      translationQuotes {
        id
        orderNumber
        stage
        translationItem
        academyItem
        softwaredevItem
        type
        companyNameAndId {
          accountType
          name
        }
        bookedBy {
          firstName
          lastName
        }
        status
        netTotal
        quoteNumber
      }
    }
  }
`;
export const GET_INTERPRETATION_ORDER_QUOTES = gql`
  query InterpretationQuoteOrders($date: String) {
    InterpretationQuoteOrders(date: $date) {
      interpretationProjects {
        id
        bookedBy {
          firstName
          lastName
        }
        companyNameAndId {
          accountType
          name
        }
        interpretationItem
        orderNumber
        stage
        status
        netTotal
        isMediation
      }
      interpretationQuotes {
        id
        bookedBy {
          firstName
          lastName
        }
        companyNameAndId {
          accountType
          name
        }
        interpretationItem
        orderNumber
        stage
        status
        netTotal
        isMediation
      }
    }
  }
`;
export const GET_TRANSLATION_INTERPRETATION_BARZANO_ORDERS = gql`
  query GetProjectsList(
    $orderNumber: String
    $orderType: String
    $offset: Int
    $limit: Int
  ) {
    getProjects(
      orderNumber: $orderNumber
      orderType: $orderType
      offset: $offset
      limit: $limit
    ) {
      ProjectCount {
        totalCount
      }
      Projects {
        id
        orderNumber
        accountManager {
          name
          email
        }
        companyNameAndId {
          id
          name
        }
        projectManager {
          email
          name
        }
        bookedBy
        status
        translationItem
        interpretationItem
        barzanoItem
        bugnionItem
      }
    }
  }
`;

export const LINGUIST_ALLOCATIONS = gql`
  query Linguists($projectId: ID, $clientId: String) {
    linguistAllocation(projectId: $projectId, clientId: $clientId) {
      id
      lastName
      firstName
      status
      sourceLanguage
      targetLanguage
      total
      totalProjectsLinguistCount
      projectsForThisClientCount
      linguistFeedback
      pmFeedback
      feedbackCI
      feedbackBZ
      linguistId
    }
  }
`;
export const GET_ISSUES_BY_PROJECTID = gql`
  query GetIssuesByProjectIds($projectIds: [String]!) {
    getIssuesByProjectIds(projectIds: $projectIds) {
      id
      issueType
      projectID
      orderNumber
    }
  }
`;
export const GET_ALL_ISSUES = gql`
  query GetIssues(
    $offset: Int
    $limit: Int
    $orderBy: String
    $order: String
    $filterIssueNo: String
    $filterProjectNo: String
    $filterCompanyName: String
    $filterIssueStatus: String
    $filterIssueCategory: String
    $filterIssueDepartment: String
    $filterEmployee: String
    $filterCreationDate: [String]
  ) {
    getIssues(
      offset: $offset
      limit: $limit
      orderBy: $orderBy
      order: $order
      filterIssueNo: $filterIssueNo
      filterProjectNo: $filterProjectNo
      filterCompanyName: $filterCompanyName
      filterIssueStatus: $filterIssueStatus
      filterIssueCategory: $filterIssueCategory
      filterIssueDepartment: $filterIssueDepartment
      filterEmployee: $filterEmployee
      filterCreationDate: $filterCreationDate
    ) {
      Issues {
        id
        accountManager {
          email
          name
        }

        issueType
        projectID
        projectManager {
          email
          name
        }
        projectType
        createdAt
        issueNumber
        orderNumber
        responsibleEmployee
        responsibleDepartment
        companyNameAndId {
          name

          id
        }
        reportedBy
        issueCategory
        status
        solution
      }
      IssueCount {
        totalCount
        all
      }
    }
  }
`;
export const GET_GET_ISSUE_BY_ID = gql`
  query GetIssueByID($getIssueByIdId: ID!) {
    getIssueByID(id: $getIssueByIdId) {
      id
      issueDeadline
      issuePriority
      issueSummery
      issueType
      projectID
      isProjectRequired
      projectManager {
        id
        name
      }
      companyNameAndId {
        id
        name
      }
      createdAt
      clientCommunication
      accountManager {
        id
        name
      }
      orderNumber
      projectType
      status
      issueCategory
      issueNumber
      reportedBy
      responsibleDepartment
      responsibleEmployee
      solution
      resolution
      responsibleLinguist
    }
  }
`;

export const GET_ISSUES_BY_COMPANY = gql`
  query getIssuesByCompany(
    $offset: Int
    $limit: Int
    $orderBy: String
    $order: String
    $filterIssueNo: String
    $filterProjectNo: String
    $filterCompanyID: String
    $filterIssueStatus: String
    $filterIssueCategory: String
  ) {
    getIssuesByCompany(
      offset: $offset
      limit: $limit
      orderBy: $orderBy
      order: $order
      filterIssueNo: $filterIssueNo
      filterProjectNo: $filterProjectNo
      filterCompanyID: $filterCompanyID
      filterIssueStatus: $filterIssueStatus
      filterIssueCategory: $filterIssueCategory
    ) {
      Issues {
        id
        accountManager {
          email
          name
        }

        issueType
        projectID
        projectManager {
          email
          name
        }
        projectType
        status
        createdAt
        issueNumber
        orderNumber
        companyNameAndId {
          name

          id
        }
        reportedBy
      }
      IssueCount {
        totalCount
      }
    }
  }
`;

export const GET_TECHNICIANS = gql`
  query allTechnicians($nearCity: String, $nearCountry: String) {
    allTechnicians(nearCity: $nearCity, nearCountry: $nearCountry) {
      id
      firstName
      lastName
      email
      phone
      city
      country
      status
      distanceKm
    }
  }
`;

export const GET_FORMATTERS = gql`
  query allFormatters {
    allFormatters {
      id
      firstName
      lastName
      email
    }
  }
`;
export const TECHNICIAN_EXPENSE_ALLOCATIONS = gql`
  query TechnicianExpenseAllocations(
    $technicianId: String
    $offset: Int
    $limit: Int
    $orderBy: String
    $order: String
    $orderNo: String
    $status: [String]
    $projectManager: String
    $startDate: String
    $endDate: String
  ) {
    technicianExpenseAllocations(
      technicianID: $technicianId
      offset: $offset
      limit: $limit
      orderBy: $orderBy
      order: $order
      orderNo: $orderNo
      status: $status
      projectManager: $projectManager
      startDate: $startDate
      endDate: $endDate
    ) {
      ExpenseAllocationsDetails {
        id
        projectId
        status
        technician {
          firstName
          lastName
          id
          email
        }
        technicianNotes
        title
        total
        type
        orderNo
        projectManager
        bookedBy
        address1
        address2
        city
        country
        startDateTime

        endDateTime
        createdAt
        companyNameAndId
      }
      Count {
        filterCount
      }
      # What the filtered period is worth in full, counted by the server over
      # every row it matches and not just the page being read.
      periodTotal
    }
  }
`;
export const FORMATTER_EXPENSE_ALLOCATIONS = gql`
  query FormatterExpenseAllocations(
    $formatterId: String
    $offset: Int
    $limit: Int
    $orderBy: String
    $order: String
    $orderNo: String
    $status: [String]
    $projectManager: String
    $startDate: String
    $endDate: String
  ) {
    formatterExpenseAllocations(
      formatterID: $formatterId
      offset: $offset
      limit: $limit
      orderBy: $orderBy
      order: $order
      orderNo: $orderNo
      status: $status
      projectManager: $projectManager
      startDate: $startDate
      endDate: $endDate
    ) {
      ExpenseAllocationsDetails {
        id
        projectId
        status
        formatter {
          firstName
          lastName
          id
          email
        }
        title
        totalWords
        type
        orderNo
        projectManager
        endDateTime
        order_details
        createdAt
      }
      Count {
        filterCount
        totalCount
      }
    }
  }
`;
export const AM_CLIENTS = gql`
  query getAMClients($id: String, $date: [String]) {
    getAMClients(id: $id, date: $date) {
      id
      name
      accountType
      accountCount
      members
      createdAtDate
      accountManager {
        name
        email
      }
      segment
      totalSales
      orders
      monthlySales
    }
  }
`;
export const BD_CLIENTS = gql`
  query getBDClients($id: String, $date: [String]) {
    getBDClients(id: $id, date: $date) {
      id
      name
      accountType
      accountCount
      members
      createdAtDate
      accountManager {
        name
        email
      }
      segment
      totalSales
      monthlySales
    }
  }
`;
// A business developer's acquired clients and their sales over a period, as
// JSON (lingoserver schema/reports/bdClientsReport.js).
export const BD_CLIENTS_REPORT = gql`
  query BdClientsReport($id: String!, $from: String!, $to: String!) {
    getBDClientsReport(id: $id, from: $from, to: $to)
  }
`;
export const AM_NEW_BUSINESS_REPORT = gql`
  query AMNewBusinessReport($amId: ID, $year: String) {
    getAMNewBusinessReports(AMId: $amId, year: $year) {
      interpretationOrder {
        id
        companyId
        netTotal
        orderNumber
        status
        createdAtDate
        companyName
        companyAccountType
        accountManagerName
        type
        marketingChannel
        companyNameAndId
        businessDeveloperName
      }
      translationOrder {
        id
        companyId
        netTotal
        status
        createdAtDate
        orderNumber
        companyName
        companyAccountType
        accountManagerName
        businessDeveloperName

        type
        marketingChannel
      }
      companies {
        id
        createdAtDate
        firstSaleDate
        stage
      }
      accountManagers {
        name
        avatarUrl
      }
    }
  }
`;
export const BD_NEW_BUSINESS_REPORT = gql`
  query BDNewBusinessReport($bdId: ID, $year: String) {
    getBDNewBusinessReports(BDId: $bdId, year: $year) {
      interpretationOrder {
        id
        companyId
        netTotal
        orderNumber
        status
        createdAtDate
        companyName
        companyAccountType
        accountManagerName
        type
        marketingChannel
        businessDeveloperName
        companyNameAndId
      }
      translationOrder {
        id
        companyId
        netTotal
        status
        createdAtDate
        orderNumber
        companyName
        companyAccountType
        accountManagerName
        businessDeveloperName
        type
        marketingChannel
      }
      companies {
        id
        createdAtDate
        firstSaleDate
        stage
      }
      accountManagers {
        name
        avatarUrl
      }
    }
  }
`;
export const NEW_BUSINESS_REPORTS = gql`
  query NewBusinessReports($year: String, $type: String) {
    getNewBusinessReports(year: $year, type: $type)
  }
`;
export const AM_CONVERSION_REPORTS = gql`
  query AMConversionReports($amId: ID, $year: String) {
    getAMConversionReports(AMId: $amId, year: $year) {
      orderNumber
      netTotal
      status
      createdAtDate
      orderType
      type
      id
      marketingChannel
      accountManagerName
      status
      reasonForClosure
      companyNameAndId
      businessDeveloperName
    }
  }
`;
export const BD_CONVERSION_REPORTS = gql`
  query BDConversionReports($bdId: ID, $year: String) {
    getBDConversionReports(BDId: $bdId, year: $year) {
      orderNumber
      netTotal
      status
      createdAtDate
      orderType
      id
      type
      marketingChannel
      accountManagerName
      status
      reasonForClosure
      companyNameAndId
      businessDeveloperName
      id
    }
  }
`;
export const CONVERSION_REPORTS = gql`
  query ConversionReports($year: String, $type: String) {
    getConversionReports(year: $year, type: $type)
  }
`;
export const GET_PM_REPORTS = gql`
  query PMSalesReport($pmId: String, $year: String) {
    getPMSalesReports(PMId: $pmId, year: $year)
  }
`;
export const GET_PM_MONTHLY_PROJECTS = gql`
  query GetPMMonthlyProjects($pmId: String, $monthYear: String) {
    getPMMonthyProjects(PMId: $pmId, monthYear: $monthYear)
  }
`;
export const GET_USER_BY_ID = gql`
  query UserById($userByIdId: String) {
    userById(id: $userByIdId) {
      id
      avatarUrl
      department
      jobTitle
      name
      role
      type
      email
      phoneNumber
      description
      language {
        code
        name
        nativename
      }
      personalEmail
      address1
      address2
      city
      country {
        code
        label
        phone
      }
      postcode
      dob
      isHRRegister
      status
    }
  }
`;
export const GET_ALL_QUALITY_CASES = gql`
  query GetQualityCasesReport($creationDate: [String], $issueCategory: String) {
    getQualityCasesReport(
      creationDate: $creationDate
      issueCategory: $issueCategory
    ) {
      id
      issueCategory
      issueDeparment
      issueType
      projectType
      responsibleDepartment
      responsibleEmployee
      status
      createdAt
    }
  }
`;
// THE QUALITY CASES REPORT (/dashboard/reports/issue, DESIGN.md §21): one row
// per case, asked for two years at once, and since 11/10/2026 whether a
// solution is on file. The LEGACY document is the same question without that
// field, for an API that has not been deployed with it yet.
export const GET_QUALITY_REPORT = gql`
  query QualityReport($creationDate: [String], $issueCategory: String) {
    getQualityCasesReport(
      creationDate: $creationDate
      issueCategory: $issueCategory
    ) {
      id
      issueCategory
      issueType
      projectType
      responsibleDepartment
      responsibleEmployee
      createdAt
      hasSolution
    }
  }
`;
export const GET_QUALITY_REPORT_LEGACY = gql`
  query QualityReportLegacy($creationDate: [String], $issueCategory: String) {
    getQualityCasesReport(
      creationDate: $creationDate
      issueCategory: $issueCategory
    ) {
      id
      issueCategory
      issueType
      projectType
      responsibleDepartment
      responsibleEmployee
      createdAt
    }
  }
`;
// Who still works here, for the same report: the staff (`allUsers` already
// leaves the deleted out) and the technicians a case can name.
export const GET_QUALITY_REPORT_PEOPLE = gql`
  query QualityReportPeople {
    allUsers {
      id
      name
      department
      status
    }
    allTechnicians {
      id
      firstName
      lastName
      status
    }
  }
`;
// THE GOLDEN PINS REPORT (/dashboard/reports/goldenPinReports): every pin on
// file through the golden pin list's own resolver — a programme of a few pins
// a year is read whole, once, and cut into periods on the page
// (`reports/pin/pinReportTokens.js`) — and who still works here.
export const GET_GOLDEN_PIN_REPORT = gql`
  query GoldenPinReport($rowsPerPage: Int) {
    goldenPinsList(
      filterStatus: ["Pending", "Approved", "Rejected"]
      filterCreatedDate: ["", ""]
      orderBy: "createdAt"
      order: "desc"
      page: 0
      rowsPerPage: $rowsPerPage
    )
  }
`;
// CREDIT CONTROL (/dashboard/reports/credit-control): the book of client money
// owed, read whole in one document — every Overdue invoice, and every Unpaid
// one already split by the server into one item per unpaid instalment — and
// cut into the late rows and the window on the page
// (`reports/credit/creditTokens.js`). Asked whole on purpose: the window is
// cut here, and a server older than 11/10/2026 never read the page of
// `getUpcomingDueInvoices` it was given.
const CREDIT_INVOICE_FIELDS = `
  _id
  invoiceID
  numeration
  orderType
  orderNo
  subject
  visible_subject
  createdAt
  invoiceDueDate
  invoiceTotal
  invoiceTaxes
  grandTotal
  invoiceStatus
  invoiceTo {
    name
    email
  }
  externalNotes
  pecDate
  followUpDate
  paymentDeadlines {
    amount
    expiration
    state
    balanceDate
    overdueClassification
    contabile
    expiryNotificationSentAt
  }
`;
export const GET_CREDIT_CONTROL_BOOK = gql`
  query CreditControlBook {
    getOverdueInvoices {
      ${CREDIT_INVOICE_FIELDS}
    }
    getUpcomingDueInvoices(limit: 5000, offset: 0) {
      invoices {
        ${CREDIT_INVOICE_FIELDS}
      }
      totalCount
    }
  }
`;
// What has been sent about the invoices on the book, and who was rung about
// them: the chase log, light. Asked by invoice, so no row limit can cut an
// invoice's history off.
export const GET_CREDIT_CONTROL_REMINDERS = gql`
  query CreditControlReminders(
    $types: [String!]!
    $uuids: [String!]!
    $limit: Int
  ) {
    getCommunicationsByTypes(
      types: $types
      uuids: $uuids
      offset: 0
      limit: $limit
    ) {
      communications {
        id
        uuid
        type
        subject
        status
        isAutomatic
        sentAt
        createdAt
        recipients {
          email
          type
        }
      }
    }
    getInvoiceCalls(invoiceIds: $uuids) {
      id
      invoiceId
      at
      status
      answered
      seconds
      number
      by
      failureReason
    }
  }
`;
// The chasing of a period, for the Reminders view. `from` and `to` are
// 'yyyy-MM-dd' on the Rome calendar, both included.
export const GET_CREDIT_CHASE_ACTIVITY = gql`
  query CreditChaseActivity($from: String!, $to: String!) {
    getCreditChaseActivity(from: $from, to: $to)
  }
`;
// Who to ring about an invoice, the client's finance people first.
export const GET_INVOICE_CALL_CONTACTS = gql`
  query InvoiceCallContacts($invoiceId: ID!) {
    getInvoiceCallContacts(invoiceId: $invoiceId) {
      companyId
      companyName
      brand
      contacts {
        name
        role
        jobTitle
        phone
        countryCode
        dialCode
        reason
      }
    }
  }
`;
// Money in and out by month, for the cash view of the same page.
export const GET_CREDIT_CONTROL_CASH = gql`
  query CreditControlCash($year: String) {
    getCashFlowReports(year: $year)
  }
`;
// THE ACCOUNT MANAGERS (/dashboard/reports/am-reports): the desk's year and
// every person's in one answer — the buckets by month, person and segment,
// the calls, the portfolio, the key clients, the roster and the targets
// (`reports/am/amReportTokens.js`). Asked once per year.
export const GET_AM_REPORT = gql`
  query AMReport($year: String!) {
    getAMReport(year: $year)
  }
`;

export const GET_AM_REPORT_DETAILS = gql`
  query AMReportDetails($year: String!) {
    getAMReport(year: $year, details: true)
  }
`;
// THE PROJECT MANAGERS (/dashboard/reports/pm-reports): the desk side by side
// over a period, in one answer — the delivered projects by person and
// service with their value and cost, the quality cases, the golden pins and
// the people (`reports/pm/pmReportTokens.js`). `from` and `to` are
// 'yyyy-MM-dd', both included.
export const GET_PM_REPORT = gql`
  query PMReport($from: String!, $to: String!) {
    getPMReport(from: $from, to: $to)
  }
`;
export const GET_GOLDEN_PIN_REPORT_PEOPLE = gql`
  query GoldenPinReportPeople {
    allUsers {
      id
      name
      email
      department
      status
    }
  }
`;
export const GET_OVERALL_SALES_REPORT = gql`
  query GetAllSalesReport($year: String!) {
    getAllSalesReports(year: $year)
    getKPIByYear(year: $year) {
      company {
        lingoCongressKPI
        lingoTranslateKPI
      }
    }
  }
`;

export const GET_OVERALL_SALES_KPI_REPORT = gql`
  query GetAllSalesReport($year: String!) {
    getAllSalesKPIReports(year: $year)
    getKPIByYear(year: $year) {
      company {
        lingoCongressKPI
        lingoTranslateKPI
      }
    }
  }
`;
export const GET_TRANSLATION_SALES_REPORT = gql`
  query GetTranslationSaleReport($year: String!) {
    getTranslationSalesReports(year: $year)
    getKPIByYear(year: $year) {
      company {
        lingoCongressKPI
        lingoTranslateKPI
      }
    }
  }
`;
export const GET_BARZANO_MONTLY_SALES_REPORT = gql`
  query BarzanoMonthlySalesReport($year: String) {
    barzanoMonthlySalesReport(year: $year)
  }
`;
export const GET_BARZANO_MONHTLY_YTD_SALES_REPORT = gql`
  query BarzanoMonthlyYTDSalesReport {
    barzanoMonthlyYTDSalesReport
  }
`;
export const GET_INTERPRETATION_SALES_REPORT = gql`
  query GetInterpretSaleReport($year: String!) {
    getInterpretationSalesReports(year: $year)
    getKPIByYear(year: $year) {
      company {
        lingoCongressKPI
        lingoTranslateKPI
      }
    }
  }
`;
export const GET_PROJECT_BY_DELIVERY_DATE = gql`
  query AllOrderCount(
    $days: String!
    $offset: Int!
    $limit: Int!
    $order: String!
    $orderBy: String!
  ) {
    allTypeProjects(
      days: $days
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
    ) {
      allOrdersCount {
        totalCount
      }
      allOrders {
        id
        type
        orderNumber
        companyNameAndId {
          id
          name
        }
        deliveryDate
        projectManager {
          name
        }
        status
      }
    }
  }
`;
export const GET_DELIVERED_PROJECTS = gql`
  query getDeliveredProjects($days: String!, $offset: Int!, $limit: Int!) {
    getDeliveredProjects(days: $days, offset: $offset, limit: $limit) {
      allOrdersCount {
        totalCount
      }
      allOrders {
        id
        type
        orderNumber
        companyNameAndId {
          id
          name
        }
        deliveryDate
        projectManager {
          name
        }
        status
      }
    }
  }
`;
export const GET_LATEST_ALLOCATIONS = gql`
  query GetLatestLinguistAllocations {
    getLatestLinguistAllocations {
      id
      firstName
      lastName
      status
      sourceLanguage
      targetLanguage
      deliveryDateTime
      startDateTime
      projectType
      creationDate
      orderNumber
      projectId
    }
  }
`;

export const GET_ALLOCATION_BY_LINGUIST_ID = gql`
  query GetAllocationById($allocationByLinguistId: [String!], $type: String!) {
    allocationByLinguistId(id: $allocationByLinguistId, type: $type)
  }
`;
export const GET_PR_ALLOCATION_BY_LINGUIST_ID = gql`
  query PRAllocationByLinguistId(
    $prallocationByLinguistId: [String!]
    $type: String!
  ) {
    prallocationByLinguistId(id: $prallocationByLinguistId, type: $type)
  }
`;
export const GET_PR_ALLOCATION_BY_ID = gql`
  query PRAllocations($projectId: ID) {
    PRAllocations(projectId: $projectId) {
      id
      firstName
      lastName
      email
      city
      mainLanguage
      otherLanguage
      country
      orderNumber
      sourceLanguage
      targetLanguage
      notes
      total
      ratePerWord
      ratePerHour
      ratePerAdditionalHour
      newWords
      creationDate
      startDateTime
      endDateTime
      deliveryDateTime
      status
      linguistId
      clientId
      projectsCompleted
      projectManager
      projectId
      projectType
      negotiatedRatePerWord
      negotiatedTotal
      negotiatedRatePerHour
      negotiatedDeliveryDateTime
      reviewReasons
      negotiatedRatePerAdditionalHour
      prDeliveryDate
      linguistallocations
    }
  }
`;
export const DELETE_PR_ALLOCATION = gql`
  query DeletePRAllocation(
    $deletePrAllocationId: ID!
    $allocationEmail: allocationEmail
  ) {
    deletePRAllocation(
      id: $deletePrAllocationId
      allocationEmail: $allocationEmail
    )
  }
`;
export const CLIENT_EMAIL_QUERY = gql`
  query getUserEmail($forgotCode: String!) {
    getUserEmail(forgotCode: $forgotCode) {
      email
    }
  }
`;

export const FETCH_CLIENT_QUERY = gql`
  query getUserData($id: String!) {
    getClientData(id: $id)
  }
`;
export const GET_BOOK_INERPRETER_FORM_ONE = gql`
  query GetBookedFirstForm($getBookedFirstFormId: String!) {
    getBookedFirstForm(id: $getBookedFirstFormId) {
      yourLanguage
      targetLanguage
      eventDate1
      eventDate2
      hours
      serviceType
      experience
      genderInterpreter
      stepOneForm
      activeStatus
      numberInterpreter
    }
  }
`;
export const GET_BOOK_INERPRETER_FORM_TWO = gql`
  query GetBookedSecondForm($getBookedSecondFormId: String!) {
    getBookedSecondForm(id: $getBookedSecondFormId) {
      price
      planName
      activeStatus
    }
  }
`;
export const GET_BOOK_INERPRETER_FORM_THREE = gql`
  query GetBookedThirdForm($getBookedThirdFormId: ID!) {
    getBookedThirdForm(id: $getBookedThirdFormId) {
      interpreterNote
      interpreterFile
      price
      bookInterprer_id
      quoteNo
      planName
      price
      priceEconomy
      priceProfessional
      pricePremium
      numberInterpreter
      yourLanguage
      targetLanguage
      eventDate1
      eventDate2
      hours
      serviceType
      experience
      calculatorHours
      calculatorPresenters
      calculatorLanguages
      WebPrice
      genderInterpreter
      stepTwoForm
      stepThreeForm
      activeStatus
      industry {
        name
        code
      }
    }
  }
`;
export const GET_WEB_CONFERENCE_DATA = gql`
  query GetWebConferencingData($getWebConferencingDataId: ID!) {
    getWebConferencingData(id: $getWebConferencingDataId) {
      id
      webconference_id
      email
      createdAt
      numberHour
      numberParticipant
      numberViewers
      numberLanguages
      totalAmount
      serviceDate
      requireInterpreter
      message
      progress
      numberInterpreter
      yourLanguage
      targetLanguage
      targetWebLanguage {
        code
        name
        nativename
      }
      eventDate1
      eventDate2
      hours
      serviceType
      additionalAmount
      experience
      genderInterpreter
      planName
      price
      priceEconomy
      priceProfessional
      pricePremium
      videoConferenceNote
      videoConferenceFile
      activeStatus
      stepOneForm
      stepTwoForm
      isConfirmed
      isPaid
      additionalServices {
        videoEditing
        recordVideoAndAudio
        postProduction
        pollingSystem
        logoIntegration
      }
      marketingPackage {
        completeBranding
        personalizedEmailEvent
        personalizedEmailInvitation
        platformLinked
        socialMedia
      }
    }
  }
`;

export const FETCH_WEBCONFERENCE_QUERY = gql`
  query ($id: ID!) {
    getWebConferencingData(id: $id) {
      id
      email
      createdAt
      webconference_id
      numberHour
      numberParticipant
      numberViewers
      numberLanguages
      totalAmount
      serviceDate
      additionalServices {
        recordVideoAndAudio
        videoEditing
        postProduction
        logoIntegration
        pollingSystem
      }
      marketingPackage {
        completeBranding
        socialMedia
        platformLinked
        personalizedEmailInvitation
        personalizedEmailEvent
      }
      requireInterpreter
      message
      progress
      numberInterpreter
      yourLanguage
      targetLanguage
      eventDate1
      eventDate2
      hours
      serviceType
      experience
      genderInterpreter
      planName
      price
      priceEconomy
      priceProfessional
      pricePremium
      videoConferenceNote
      videoConferenceFile
      activeStatus
      additionalAmount
      stepOneForm
      stepTwoForm
      stepThreeForm
      stepFourForm
      stepFiveForm
      stepSixForm
    }
  }
`;

export const GET_TRANSLATION_DATA = gql`
  query getTransaltionProjectData($id: ID!) {
    getTransaltionProjectData(id: $id) {
      id
      userEmail
      workEmail
      addressOne
      addressTwo
      city
      postcode
      country
      vat
      confirmPassword
      password
      telephone
      timeZone
      firstName
      rate {
        translateFrom
        language
        rate
      }
      lastName
      companyName
      note
      translationTone
      price
      project_id
      guaranteedDate
      guaranteedTime
      timeZone
      translateTo
      translateFrom
      priceEconomy
      priceProfessional
      pricePremium
      planName
      translationNote
      translationFile {
        fileName
        words
        language
      }
      progress
    }
  }
`;

export const FETCH_PROJECTS_QUERY = gql`
  query ($email: String!) {
    getBookedInterpreters(email: $email) {
      id
      bookInterprer_id
      quoteNo
      price
      priceEconomy
      priceProfessional
      pricePremium
      email
      createdAt
      progress
      numberInterpreter
      yourLanguage
      targetLanguage
      eventDate1
      eventDate2
      hours
      serviceType
      experience
      genderInterpreter
      planName
      videoConferenceNote
      videoConferenceFile
      activeStatus
      stepOneForm
      tokenStripe
      stepTwoForm
      stepThreeForm
      calculatorHours
      calculatorPresenters
      calculatorLanguages
      WebPrice
      status
    }
  }
`;

export const GET_CLIENT_TOTALS = gql`
  query getTotalSpendings($email: String) {
    getTotalSpendings(email: $email)
  }
`;
export const GET_ALL_TRANSLATION_DATA = gql`
  query getTransaltionProjects($email: String!) {
    getTransaltionProjects(email: $email) {
      createdAt
      activeStatus
      price
      isConfirmed
      isPaid
    }
  }
`;
export const FETCH_CONFERENCE_QUERY = gql`
  query ($email: String!) {
    getWebConferencing(email: $email) {
      createdAt
      totalAmount
      planName
      activeStatus
      isConfirmed
      isPaid
    }
  }
`;

export const GET_ALL_CLIENT_ORDERS = gql`
  query GetAllOrders(
    $filterStage: [String]
    $filterBrand: [String]
    $filterStatus: [String]
    $filterCreationDate: [String]
    $filterOrderNo: String
    $limit: Int
    $order: String
    $orderBy: String
    $email: String
    $offset: Int
  ) {
    getAllClientOrders(
      filterStage: $filterStage
      filterBrand: $filterBrand
      email: $email
      filterStatus: $filterStatus
      filterCreationDate: $filterCreationDate
      filterOrderNo: $filterOrderNo
      limit: $limit
      order: $order
      orderBy: $orderBy
      offset: $offset
    ) {
      filterCount
      orders
    }
  }
`;
export const GET_CLEINT_ORDER_BY_ID = gql`
  query OrderById($getOrderByIdId: String!, $type: String!) {
    getOrderByID(id: $getOrderByIdId, type: $type)
  }
`;
export const LINGUIST_PERSONAL_DETAILS = gql`
  query GetVendorDataById($id: ID!) {
    getVendorDataById(id: $id) {
      id
      firstName
      createdAt
      registeredAt
      lastName
      personalInfo {
        gender
        about
        dob
        phone
        address {
          address1
          address2
          city
          country
        }
      }
      email
      image
      resume
      mainService
      languages {
        mainLanguage
        otherLanguage
      }
      pmNotes
      status
      statusReason
      isBlacklisted
      blacklistTranslation
      blacklistInterpretation
      blacklistMediation
      blacklistReason
      blacklistUpdatedAt
      blacklistedBy {
        id
        name
      }
    }
  }
`;
export const VENDOR_LANGUAGE_AND_SERVICES_DETAILS = gql`
  query GetVendorLanguageAndServicesById($id: ID!) {
    getVendorDataById(id: $id) {
      id
      firstName
      lastName
      createdAt
      registeredAt
      languages {
        mainLanguage
        otherLanguage
      }
      translationServices {
        serviceType
        desc
        langCombinations {
          sourceLanguage
          targetLanguage
          ratePerWord
          experienceYears
        }
      }

      translationExpertise {
        sector
        subSectors
      }
      interpretationServices {
        serviceType
        desc
        langCombinations {
          sourceLanguage
          targetLanguage
          minuteRate
          hourRate
          dayRate
          experienceYears
        }
        availability
        opi
        technicalRequirements
      }
      interpretationExpertise {
        sector
        subSectors
      }
    }
  }
`;
export const GET_LINGUIST_COMPLETED_ORDER = gql`
  query AllocationsByLinguist($linguistId: ID) {
    allocationsByLinguist(linguistId: $linguistId) {
      orderNumber
      projectType
      total
      prFeedback {
        accuracyTranslation
        grammerSpelling
        technicalTerminology
      }
      pmFeedback {
        communicationAndAvailability
        deliveryCompliance
        layoutAndFormating
      }
      feedbackBZ {
        deliveryCompliance
        communicationAndAvailability
        layoutAndFormating
        translationAccuracy
        tmManagement
      }
      feedbackCI {
        quality
        ethicalStandards
        costEffective
        communication
        timeliness
      }
      status
    }
  }
`;
export const GET_RATING_BY_LINGUIST = gql`
  query RatingByLinguist($linguistId: ID) {
    ratingByLinguist(linguistId: $linguistId)
  }
`;
export const GET_ISSUE_BY_LINGUIST_ID = gql`
  query IssueCount(
    $linguistId: ID!
    $offset: Int
    $limit: Int
    $orderBy: String
    $order: String
  ) {
    getIssuesByLinguist(
      linguistId: $linguistId
      offset: $offset
      limit: $limit
      orderBy: $orderBy
      order: $order
    ) {
      IssueCount {
        totalCount
      }
      Issues {
        id
        accountManager {
          name
        }
        issueNumber
        issueCategory
        issueType
        orderNumber
        projectID
        projectManager {
          name
        }
        projectType
        responsibleDepartment
        responsibleEmployee
        solution
        status
      }
    }
  }
`;
export const GET_TECHNICIAN = gql`
  query getTechnicians(
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
    $name: String
    $filterStatus: String
    $technicianId: String
  ) {
    getTechnicians(
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
      name: $name
      filterStatus: $filterStatus
      technicianId: $technicianId
    ) {
      technicians {
        _id
        firstName
        lastName
        email
        phone
        city
        country
        resume
        image
        status
        isBlacklisted
        canSignIn
        jobsAhead
        jobsDone
        lifetimeValue
        lastJobAt
        nextJobAt
        diary {
          id
          orderNo
          startDateTime
          endDateTime
          status
          city
          title
          total
          company
        }
      }
      filterCount
      totalCount
    }
  }
`;
export const GET_FORMATTER = gql`
  query getFormatters(
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
    $name: String
    $access: [String]
  ) {
    getFormatters(
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
      name: $name
      access: $access
    ) {
      formatters {
        _id
        firstName
        lastName
        email
        phone
        resume
        createdAt
        status
        isBlacklisted
        canSignIn
        access
      }
      accessCounts {
        key
        count
      }
      filterCount
      totalCount
    }
  }
`;
// THE UNFINISHED SIGN-UPS (/dashboard/vendor/incomplete). The funnel is the
// server's: signUpStage on every row, stageCounts over the whole cohort for
// the pipeline strip, filterStage to narrow the query to one stage. The page
// used to work the stage out from the 25 rows in hand, so its tiles counted
// the page and its stage filter never left it.
export const GET_INCOMPLETE_LINGUIST = gql`
  query GetIncompleteLinguist(
    $filterName: String
    $city: String
    $filterMainLanguage: String
    $filterOtherLanguage: String
    $filterStage: [String]
    $signedUpFrom: String
    $signedUpTo: String
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
    $bidirectionalSearch: Boolean
  ) {
    getIncompleteLinguist(
      filterName: $filterName
      City: $city
      filterMainLanguage: $filterMainLanguage
      filterOtherLanguage: $filterOtherLanguage
      filterStage: $filterStage
      signedUpFrom: $signedUpFrom
      signedUpTo: $signedUpTo
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
      bidirectionalSearch: $bidirectionalSearch
    ) {
      linguists {
        _id
        id
        firstName
        lastName
        mainLanguage
        otherLanguage
        phone
        gender
        city
        country
        email
        dob
        mainService
        areaOfStudy
        resume
        isOnBoardingStepOneCompleted
        isOnBoardingStepTwoCompleted
        isOnBoardingStepThreeCompleted
        signUpStage
        registeredAt
        canSignIn
      }
      linguistsCount {
        filterCount
        totalCount
        chaseCount
        recentDays
        stageCounts {
          stage
          count
          recent
        }
      }
    }
  }
`;

export const GET_LINGUIST_LIST_BY_ID = gql`
  query GetUsersDataById($getUsersDataByIdId: [ID!]) {
    getUsersDataById(id: $getUsersDataByIdId) {
      firstName
      lastName
      email
    }
  }
`;

export const GET_VENDOR_DATA = gql`
  query GetUserData($email: String!) {
    getUserData(email: $email) {
      firstName
      lastName
      email
      address1
      address2
      city
      country
      postal
      postalCode
      phone
      iban
      bic
      bankname
      taxid
      availabilityStatus
      unavailabilityStartDate
      unavailabilityEndDate
      autoSetAvailable
      availabilityReason
      billingAddress
    }
  }
`;
export const GET_ALLOCATION_BY_LINGUIST = gql`
  query GetLinguistAllocations($linguistId: String!, $month: String!) {
    getLinguistAllocations(linguistID: $linguistId, month: $month) {
      lastName
      firstName
      deliveryDateTime
      creationDate
      orderNumber
      projectType
      total
      sourceLanguage
      targetLanguage
      type
      issueNo
      issueID
    }
  }
`;

export const GET_INVOICES_BY_VENDORS = gql`
  query GetInvoicesByVendorID(
    $vendorId: String
    $order: String
    $orderBy: String
  ) {
    getInvoicesByVendorID(
      vendorID: $vendorId
      order: $order
      orderBy: $orderBy
    ) {
      Invoices {
        _id
        createdAt

        grandTotal

        month
        items {
          title
          description
          total
        }
        invoiceTotal
        invoiceStatus
        invoiceDueDate
        invoiceID
        invoiceTo {
          address1
          address2
          city
          postalCode
          country
          name
          phone
        }
        invoiceFrom {
          address1
          address2
          city
          postalCode
          country
          name
          phone
          bankName
          IBAN
          BIC
          TAXID
        }
      }
      InvoiceCount {
        Paid
        Unpaid
        totalCount
        paidAmount
        totalAmount
        unpaidAmount
        Overdue
        overDueAmount
      }
    }
  }
`;
export const GET_INVOICE_BY_ID = gql`
  query GetInvoiceByInvoiceID($invoiceId: String) {
    getInvoiceByInvoiceID(invoiceID: $invoiceId) {
      _id
      createdAt
      invoiceDueDate
      invoiceNotes
      legalTerms
      vendorLogo
      attachment
      discount
      orderNo
      grandTotal
      fattureInvoice
      discountValue
      orderType
      barzanoCaseNo
      orderID
      link
      numeration
      subject
      vat_kind
      visible_subject
      payment_account
      invoicePaidDate
      invoiceFrom {
        name
        address1
        address2
        city
        postalCode
        country
        phone
        bankName
        IBAN
        BIC
        TAXID
        email
        province
        VAT
      }
      invoiceID
      invoiceStatus
      invoiceTo {
        name
        address1
        address2
        city
        postalCode
        country
        country_code
        phone
        province
        ei_code
        VAT
        TAXID
        email
        payment_terms
      }
      invoiceTotal
      legalTerms
      invoiceTaxes
      invoiceSubTotal
      type
      barzanoCaseType
      externalNotes
      pecDate
      followUpDate
      items {
        code
        discount
        title
        description
        total
        issueNo
        issueID
        ppw
        tax
        quantity
        netTotal
      }
      paymentDeadlines {
        amount
        paymentTerms
        expiration
        state
        balanceAccount
        balanceDate
        overdueClassification
      }
      month

      vendorID
      origin
      originRef
      originSources
      financeReceivedAt
      financeNotifiedAt
    }
  }
`;
export const GET_MONTH_WITHOUT_INVOICE = gql`
  query GetUnpaidMonths($vendorId: String!) {
    getUnpaidMonths(vendorID: $vendorId) {
      month
      totalItems
      isCreated
      items
    }
  }
`;
export const GET_TECHNICIAN_MONTH_WITHOUT_INVOICE = gql`
  query getUnpaidTechnicianMonths($vendorId: String!) {
    getUnpaidTechnicianMonths(vendorID: $vendorId) {
      month
      totalItems
      isCreated
    }
  }
`;
export const GET_ALL_INVOICES = gql`
  query GetAllInvoices(
    $order: String
    $orderBy: String
    $limit: Int
    $offset: Int
    $invoiceMonth: String
    $invoiceStatus: [String]
    $invoiceId: String
    $type: String
    $year: String
    $filterCreationDate: [String]
    # "FALLS DUE" NEVER FILTERED ANYTHING, from 25/09/2026 to 08/10/2026.
    # The list sent filterDueDate in its variables and this document never
    # declared it, so Apollo dropped it and the resolver — which has read
    # args.filterDueDate and built a dueDate clause all along — was never
    # told. A range typed into that field narrowed nothing and the table did
    # not move, which reads as "no invoice falls due then".
    $filterDueDate: [String]
    $onlyLate: Boolean
    $origin: [String]
  ) {
    getAllInvoices(
      filterCreationDate: $filterCreationDate
      filterDueDate: $filterDueDate
      onlyLate: $onlyLate
      origin: $origin
      order: $order
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      invoiceMonth: $invoiceMonth
      invoiceStatus: $invoiceStatus
      invoiceID: $invoiceId
      type: $type
      year: $year
    ) {
      InvoiceCount {
        Paid
        Unpaid
        filterCount
        paidAmount
        totalAmount
        totalCount
        unpaidAmount
        Overdue
        overDueAmount
        owedCount
        owedAmount
        lateCount
        lateAmount
        dueSoonCount
        dueSoonAmount
        ageing {
          band
          count
          amount
        }
      }
      Invoices {
        _id
        createdAt
        invoiceDueDate
        invoiceNotes
        legalTerms
        vendorLogo
        discount
        orderNo
        grandTotal
        fattureInvoice
        discountValue
        orderType
        barzanoCaseNo
        orderID
        numeration
        link
        subject
        visible_subject
        invoiceFrom {
          name
          address1
          address2
          city
          postalCode
          country
          phone
          bankName
          IBAN
          BIC
          TAXID
          email
          province
          VAT
        }
        invoiceID
        invoiceStatus
        invoiceTo {
          name
          address1
          address2
          city
          postalCode
          country
          country_code
          phone
          province
          ei_code
          VAT
          TAXID
          email
        }
        invoiceTotal
        legalTerms
        invoiceTaxes
        invoiceSubTotal
        type
        barzanoCaseType
        month
        orderType
        barzanoCaseNo
        vendorID
        attachment
        origin
        originSources
        financeReceivedAt
        paymentDeadlines {
          amount
          paymentTerms
          expiration
          state
          overdueClassification
          balanceDate
        }
      }
    }
  }
`;
// THE PIPELINE STRIP OF THE TWO LEDGERS: one row per stored status over
// every filter BUT the status one, so a lit cell does not leave the others
// reading zero. Asked APART from the list on purpose — a field an older
// server does not know fails the whole document it is asked in, and the
// ledger must not go down with its strip while a deploy is halfway through.
// One row back, because only the counts are wanted.
export const GET_INVOICE_STATUS_COUNTS = gql`
  query GetInvoiceStatusCounts(
    $order: String
    $orderBy: String
    $limit: Int
    $offset: Int
    $invoiceStatus: [String]
    $invoiceId: String
    $type: String
    $year: String
    $filterCreationDate: [String]
    $filterDueDate: [String]
    $onlyLate: Boolean
    $origin: [String]
  ) {
    getAllInvoices(
      filterCreationDate: $filterCreationDate
      filterDueDate: $filterDueDate
      onlyLate: $onlyLate
      origin: $origin
      order: $order
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      invoiceStatus: $invoiceStatus
      invoiceID: $invoiceId
      type: $type
      year: $year
    ) {
      InvoiceCount {
        statusCounts {
          status
          count
          value
        }
      }
    }
  }
`;
export const GET_TECHNICIAN_ALLOCATIONS = gql`
  query GetTechnicianAllocations($technicianId: String!, $month: String!) {
    getTechnicianAllocations(technicianID: $technicianId, month: $month) {
      orderNo
      type
      title
      total
      status
      service
      createdAt
    }
  }
`;
export const GET_CALLS_BY_DATE_BY_USER = gql`
  query UserCallByMonth($userId: String, $month: String) {
    getCallsByMonth(userID: $userId, month: $month)
  }
`;
export const GET__TOKEN = gql`
  query GetToken {
    getCreditSafeToken {
      token
    }
  }
`;
// The business register, searched one criterion at a time — the register
// refuses a combination ("Specified criteria combination is not allowed").
export const GET_COMPANY_LIST = gql`
  query GetCompanyList(
    $token: String
    $name: String
    $vatNo: String
    $regNo: String
    $phoneNo: String
  ) {
    getCompaniesData(
      token: $token
      name: $name
      vatNo: $vatNo
      regNo: $regNo
      phoneNo: $phoneNo
    )
  }
`;
export const GET_COMPANY_BY_ID = gql`
  query GetCompanyById($id: String, $token: String) {
    getCompanyByID(id: $id, token: $token)
  }
`;
export const GET_HISTORICAL_DATA = gql`
  query GetHistoricalData($filterSource: String) {
    allQuotesData(filterSource: $filterSource)
  }
`;
export const GET_BARZANO_SALES_REPORT = gql`
  query GetBarzanoSalesReport($year: String) {
    getBarzanoSalesReports(year: $year)
  }
`;
export const GET_BARZANO_WORDS_COUNT = gql`
  query GetBarzanoWordsCountReport($year: String) {
    getBarzanoWordsCount(year: $year)
  }
`;
export const GET_BARZANO_WEEKLY_WORDS_COUNT = gql`
  query GetBarzanoWeeklyWordsCountReport($creationDate: [String]) {
    getBarzanoWeeklyWordsCount(creationDate: $creationDate)
  }
`;

export const GET_BARZANO_ORDERS_ISSUES_COUNT = gql`
  query BarzanoProjectsAndIssues($year: String) {
    getBarzanoQualityCasesProject(year: $year)
  }
`;
export const GET_BARZANO_SUMMERY = gql`
  query GetBarzanoSummery($month: String, $year: String, $caseType: String) {
    getBarzanoSummery(month: $month, year: $year, caseType: $caseType)
  }
`;

// ========= BUGNION REPORT QUERIES =========
export const GET_BUGNION_SALES_REPORT = gql`
  query GetBugnionSalesReport($year: String) {
    getBugnionSalesReports(year: $year)
  }
`;
export const GET_BUGNION_WORDS_COUNT = gql`
  query GetBugnionWordsCountReport($year: String) {
    getBugnionWordsCount(year: $year)
  }
`;
export const GET_BUGNION_WEEKLY_WORDS_COUNT = gql`
  query GetBugnionWeeklyWordsCountReport($creationDate: [String]) {
    getBugnionWeeklyWordsCount(creationDate: $creationDate)
  }
`;
export const GET_BUGNION_ORDERS_ISSUES_COUNT = gql`
  query BugnionProjectsAndIssues($year: String) {
    getBugnionQualityCasesProject(year: $year)
  }
`;
export const GET_BUGNION_SUMMERY = gql`
  query GetBugnionSummery($month: String, $year: String) {
    getBugnionSummery(month: $month, year: $year)
  }
`;
export const GET_BUGNION_MONTLY_SALES_REPORT = gql`
  query BugnionMonthlySalesReport($year: String) {
    bugnionMonthlySalesReport(year: $year)
  }
`;
export const GET_BUGNION_MONHTLY_YTD_SALES_REPORT = gql`
  query BugnionMonthlyYTDSalesReport {
    bugnionMonthlyYTDSalesReport
  }
`;
export const BUGNION_YEARLY_SALES_REPORT = gql`
  query BugnionYearlySalesReport($year: String) {
    getBugnionYearlySales(year: $year)
  }
`;

export const GET_COMPANIES_ADDRESS_LIST = gql`
  query getCompaniesAddress($name: String, $brand: String) {
    getCompaniesList(name: $name, brand: $brand)
  }
`;
export const GET_CLIENT_INVOICE_STATUS = gql`
  query ClientInvoiceStatus(
    $month: String!
    $caseType: String
    $orderType: String
  ) {
    clientInvoiceStatus(
      month: $month
      caseType: $caseType
      orderType: $orderType
    )
  }
`;
export const GET_COMPANY_INFO = gql`
  query getCompanyInfo($id: String!) {
    getCompaniesInfo(ID: $id)
  }
`;
export const GET_INVOICES_BY_PROJECTS = gql`
  query getInvoiceByProjectID($orderId: ID!) {
    getInvoicesByProject(orderID: $orderId)
  }
`;
export const GET_CONTACT_BY_EMAIL = gql`
  query CompanyContactByEmail($email: String!) {
    companyContactByEmail(email: $email) {
      id
      firstName
      taxCode
      lastName
      email
      gender
      phone
      role
      jobTitle
      address1
      address2
      city
      state {
        code
        province
        region
      }
      country {
        code
        label
        phone
      }
      postCode
      status
      companyId
      createdAtDate
    }
  }
`;
export const DELETE_TASKS_LIST = gql`
  query DeleteTaskList($ids: [ID!]) {
    deleteTaskList(ids: $ids)
  }
`;
export const GET_LOST_QUOTE_BY_REASON = gql`
  query getLostQuotebyReason(
    $offset: Int!
    $limit: Int!
    $orderBy: String!
    $order: String!
    $reasonForClosure: [String]
    $year: String!
    $type: String
  ) {
    getLostQuote(
      offset: $offset
      limit: $limit
      orderBy: $orderBy
      order: $order
      reasonForClosure: $reasonForClosure
      year: $year
      type: $type
    )
  }
`;
export const GET_INSTANT_QUOTE_PRICE = gql`
  query GetInstantQuotePrice(
    $sourceLanguage: languageDetails
    $targetLanguage: [languageDetails]
    $subject: industryDetails
    $totalWords: Int
    $deliveryDate: String
    $deliveryDateOption: String
  ) {
    getInstantQuotePrice(
      sourceLanguage: $sourceLanguage
      targetLanguage: $targetLanguage
      Subject: $subject
      totalWords: $totalWords
      deliveryDate: $deliveryDate
      deliveryDateOption: $deliveryDateOption
    )
  }
`;
export const UPLOAD_INSTANT_QUOTE_FILE = gql`
  query uploadInstantQuoteFile($docs: Upload) {
    uploadInstantQuoteFile(docs: $docs)
  }
`;
export const GET_CLIENT_DELIVERED_LY_CI_PROJECTS = gql`
  query GetClientDeliveryProjects(
    $month: String
    $clientId: String!
    $year: String!
  ) {
    getClientDeliveredProjects(month: $month, clientID: $clientId, year: $year)
  }
`;
export const GET_TOTAL_VALUE_MONTHLY_BASED = gql`
  query TotalOrdersValues($year: String) {
    totalOrdersValues(year: $year)
  }
`;
export const TOP_CITIES_WITH_CLIENT_SALES = gql`
  query TopCiteisWithClientSales($year: String) {
    getTopCitiesWithSales(year: $year)
  }
`;
export const TOP_CLIENTS_BY_SALES = gql`
  query TopClientBySales($year: String) {
    getTopClientsBySales(year: $year)
  }
`;
export const BARZANO_YEARLY_SALES_REPORT = gql`
  query TopClientBySales($year: String) {
    getBarzanoYearlySales(year: $year)
  }
`;
export const NEW_BUSINESS_SALES_STATS = gql`
  query NewBusinessReports($year: String) {
    newBusinessReports(year: $year)
  }
`;
export const TOP_PERFORMERS = gql`
  query TopPerformers($dataType: String!, $dateRange: [String]) {
    topPerformers(dataType: $dataType, dateRange: $dateRange)
  }
`;

export const GET_SUPPLIER_LIST = gql`
  query SupplierList($name: String) {
    getSupplierList(name: $name)
  }
`;
export const GET_EXPENSE_CATEGORIES_LIST = gql`
  query ExpenseCategoryList {
    getExpenseCategoryList
  }
`;
export const GET_PAYMENT_ACCOUNTS = gql`
  query ExpenseCategoryList {
    getPaymentAccountList
  }
`;
export const GET_EXPENSES_LIST = gql`
  query ExpenseList(
    $supplier: String
    $macroCategory: String
    $category: String
    $expenseDate: [String]
    $paymentStatus: [String]
    $expiryDate: [String]
    $createdAt: [String]
    $supplierName: String
    $balanceAccount: String
    $onFatture: Boolean
    $hasInvoice: Boolean
    $hasJob: Boolean
    $jobBrand: String
    $amountMin: Float
    $amountMax: Float
    $type: String
    $cost: String
    # paid | overdue | topay | reversed — the four stages of the strip, which
    # partition the books. NEEDS THE SERVER DEPLOYED FIRST: an argument the
    # running server does not declare fails GraphQL validation, and with it
    # the whole query.
    $stage: String
    $limit: Int
    $offset: Int
    $orderBy: String
    $order: String
  ) {
    getExpenseList(
      supplier: $supplier
      type: $type
      macroCategory: $macroCategory
      category: $category
      expenseDate: $expenseDate
      paymentStatus: $paymentStatus
      expiryDate: $expiryDate
      createdAt: $createdAt
      supplierName: $supplierName
      balanceAccount: $balanceAccount
      onFatture: $onFatture
      hasInvoice: $hasInvoice
      hasJob: $hasJob
      jobBrand: $jobBrand
      amountMin: $amountMin
      amountMax: $amountMax
      cost: $cost
      stage: $stage
      limit: $limit
      offset: $offset
      orderBy: $orderBy
      order: $order
    )
  }
`;
// The accounts our own books use, most-used first — instant, unlike the
// Fatture in Cloud round trip, which is what the settle flow needs.
export const GET_EXPENSE_BALANCE_ACCOUNTS = gql`
  query ExpenseBalanceAccounts {
    expenseBalanceAccounts
  }
`;
// The suppliers we have actually booked a cost against, ranked by use.
// Loaded when the filter's supplier picker is opened, not on page view:
// there are 2 327 of them.
export const GET_EXPENSE_SUPPLIERS = gql`
  query ExpenseSuppliers {
    expenseSuppliers
  }
`;
export const GET_EXPENSE_BY_ID = gql`
  query GetExpenseByID($id: String!) {
    getExpenseByID(id: $id)
  }
`;
export const GET_S3_BUCKET_DATA = gql`
  query GetS3ObjectData($s3Url: String!) {
    getS3ObjectData(s3Url: $s3Url) {
      content
      contentType
    }
  }
`;
export const GET_EXPENSES_AND_REVENUE = gql`
  query GetExpensesAndRevenue($type: String!, $year: String!) {
    getAllExpenseAndRevenue(type: $type, year: $year)
  }
`;
export const GET_EXPENSES_BY_CATEGORY = gql`
  query GetAllExpenseByCategories($type: String!, $year: String!) {
    getAllExpenseByCategories(type: $type, year: $year)
  }
`;
export const GET_EXPENSES_BY_TYPE = gql`
  query GetAllExpenseByType($type: String!, $year: String!) {
    getAllExpenseByType(type: $type, year: $year)
  }
`;
export const GET_RECENT_EXPENSES = gql`
  query GetRecentExpenses($type: String!, $year: String!) {
    getRecentExpenses(type: $type, year: $year)
  }
`;
// THE EXPENSES REPORT (11/10/2026): the year and the year before, by the date
// on the document, rolled up by month, side, macro category and category —
// whole and to date — and the year's latest documents, in one JSON answer.
// It replaces the seven queries the old report page read; a server that does
// not know it yet is answered by the old page (DESIGN.md §21).
export const GET_EXPENSE_REPORT = gql`
  query ExpenseReport($year: String!) {
    getExpenseReport(year: $year)
  }
`;
export const GET_PROJECTS_LIST = gql`
  query GetProjectList {
    getProjectsList
  }
`;
export const GET_EXPENESES_BY_MACRO_CATEGORIES = gql`
  query GetExpenseByMacroCategory($type: String!, $year: String!) {
    getAllExpenseByMacroCategories(type: $type, year: $year)
  }
`;

export const GET_EXPENESES_BY_COST_TYPE = gql`
  query GetAllExpenseByCost($type: String!, $year: String!) {
    getAllExpenseByCost(type: $type, year: $year)
  }
`;
export const GET_MONTHLY_EXPENSES_BY_CATEGORY = gql`
  query GetMonthlyExpenseByCategory(
    $macroCategory: String!
    $costType: String!
    $year: String!
  ) {
    getMonthlyExpenseByCategory(
      macroCategory: $macroCategory
      costType: $costType
      year: $year
    )
  }
`;
export const GET_CLIENTS_LIST = gql`
  query GetClientList($type: [String]) {
    getClientsList(type: $type)
  }
`;
export const GET_PROJECT_LIST = gql`
  query GetFilterProjectList($year: String!, $clientId: String!) {
    getFilterdProjectList(year: $year, clientID: $clientId)
  }
`;
export const GET_PROJECT_INFO = gql`
  query getProjectInfo($type: String!, $id: String!) {
    getFilterdProjectInfo(type: $type, id: $id)
  }
`;
export const GET_TM_REPORT = gql`
  query TMReport($id: ID!) {
    TMReport(id: $id) {
      id
      client
      project
      files
      createdAt
      tmNumber
      projectManager
    }
  }
`;
export const GET_TM_REPORT_LIST = gql`
  query AllTMReports(
    $orderBy: String
    $order: String
    $offset: Int
    $limit: Int
    $clientName: String
  ) {
    allTMReports(
      orderBy: $orderBy
      order: $order
      offset: $offset
      limit: $limit
      clientName: $clientName
    ) {
      id
      client
      project
      files
      createdAt
      tmNumber
      projectManager
    }
  }
`;
export const GET_INVENTORY_ITEMS = gql`
  query GetAllInventoryItem(
    $search: String
    $status: String
    $condition: String
    $category: String
    $location: [String]
    $limit: Int
    $offset: Int
    $orderBy: String
    $order: String
  ) {
    getAllInventories(
      search: $search
      status: $status
      condition: $condition
      category: $category
      location: $location
      limit: $limit
      offset: $offset
      orderBy: $orderBy
      order: $order
    ) {
      total
      filterCount
      inventoryItems {
        id
        createdAt
        name
        brand
        model
        quantity
        location
        status
        stockCode
        purchaseDate
        condition
        category
        description
        images
        notes
      }
    }
  }
`;
export const GET_INVENTORY_BY_ID = gql`
  query GetInventoryByID($id: ID!) {
    getInventory(id: $id) {
      id
      createdAt
      name
      category
      brand
      model
      quantity
      location
      status
      stockCode
      purchaseDate
      condition
      description
      images
      notes
    }
  }
`;
export const GET_REQUEST_FORMS = gql`
  query getRequests(
    $search: String
    $brand: String
    $status: String
    $location: String
    $accountManagerId: String
    $accountManagerEmail: String
    $limit: Int
    $offset: Int
    $orderBy: String
    $order: String
  ) {
    getRequests(
      search: $search
      brand: $brand
      status: $status
      location: $location
      accountManagerId: $accountManagerId
      accountManagerEmail: $accountManagerEmail
      limit: $limit
      offset: $offset
      orderBy: $orderBy
      order: $order
    ) {
      total
      filterCount
      requests {
        id
        requestNo
        createdAt
        name
        email
        message
        phone
        sourceLanguage
        targetLanguage
        brand
        location
        fileUrl
        ppc
        clientCreated
        quoteCreated
        accountManager
        status
      }
    }
  }
`;
export const GET_REQUEST_FORM_BY_ID = gql`
  query GetContactFormById($id: ID!) {
    getRequest(id: $id) {
      id
      requestNo
      createdAt
      updatedAt
      name
      email
      message
      phone
      sourceLanguage
      targetLanguage
      brand
      location

      fileUrl
      policyConsent
      clientCreated
      clientCreatedAt
      quoteCreated
      quoteCreatedAt
      status
      ppc
      accountManager
      company
      contact
      companyId
      contactId
      quoteId
    }
  }
`;
export const GET_PRE_BOOKING_REQUESTS = gql`
  query AllLinguistPreBookings(
    $item_id: String!
    $projectId: String!
    $name: String
  ) {
    allLinguistPreBookings(
      item_id: $item_id
      projectId: $projectId
      name: $name
    )
  }
`;
export const GET_BOOKING_REQUESTS = gql`
  query AllLinguistPreBookings(
    $item_id: String!
    $projectId: String!
    $offset: Int!
    $limit: Int!
    $orderBy: String!
    $order: String!
    $name: String
  ) {
    allLinguistBookings(
      item_id: $item_id
      projectId: $projectId
      offset: $offset
      limit: $limit
      orderBy: $orderBy
      order: $order
      name: $name
    )
  }
`;
export const GET_PRE_BOOKING_BY_ID = gql`
  query GetPreBookingById($getPreBookingByIdId: String) {
    getPreBookingByID(id: $getPreBookingByIdId)
  }
`;
export const GET_BOOKING_BY_ID = gql`
  query GetBookingByID($getPreBookingByIdId: String) {
    getBookingByID(id: $getPreBookingByIdId)
  }
`;
export const GET_FIC_PAYMENT_ACCOUNTS = gql`
  query GetPaymentAccounts {
    getPaymentAccounts
  }
`;

export const GET_LINGUIST_ALLOCATION_BY_IDS = gql`
  query LinguistAllocationsByAllocationID($IDs: [String]) {
    linguistAllocationsByAllocationID(IDs: $IDs)
  }
`;
// Whether a project's financials are sealed, and by whom: the quality case's
// solution dialog asks before it offers a linguist's fee for change, because
// the server refuses a fee write on a sealed project. Only these three order
// types seal.
export const GET_TRANSLATION_ORDER_SEAL = gql`
  query TranslationOrderSeal($id: ID!) {
    translationOrder(translationOrderId: $id) {
      id
      financialsSealedAt
      financialsSealedBy {
        id
        name
      }
    }
  }
`;
export const GET_INTERPRETATION_ORDER_SEAL = gql`
  query InterpretationOrderSeal($id: ID!) {
    interpretationOrder(interpretationOrderId: $id) {
      id
      financialsSealedAt
      financialsSealedBy {
        name
      }
    }
  }
`;
export const GET_MEDIATION_ORDER_SEAL = gql`
  query MediationOrderSeal($id: ID!) {
    mediationOrder(mediationOrderId: $id) {
      id
      financialsSealedAt
      financialsSealedBy {
        name
      }
    }
  }
`;
// THE PROFIT REPORT (/dashboard/management). `details: false` leaves out the
// project and expense ROWS behind the figures — 2,14 MB of a 2,15 MB payload
// that nobody reads until a month is opened, which is what
// GET_MANAGEMENT_REPORT_DETAIL is for.
export const GET_MANAGEMENT_REPORT = gql`
  query getManagementReport($year: String, $details: Boolean) {
    getManagementReport(year: $year, details: $details)
  }
`;
export const GET_MANAGEMENT_REPORT_DETAIL = gql`
  query GetManagementReportDetail(
    $year: String
    $month: String
    $line: String
  ) {
    getManagementReportDetail(year: $year, month: $month, line: $line)
  }
`;
// SERVER FIRST (DESIGN.md §21): the shape the profit report asks for before
// the resolver above is deployed. A server that has never heard of `details`
// rejects the whole document — "Unknown argument" — so the page falls back to
// this one and reads the drill-down rows out of the answer, as it used to.
export const GET_MANAGEMENT_REPORT_WHOLE = gql`
  query GetManagementReportWhole($year: String) {
    getManagementReport(year: $year)
  }
`;
export const GET_MANAGEMENT_BRAND_REVENUE_REPORT = gql`
  query GetManagementBrandRevenueReport($year: String) {
    getManagementBrandRevenueReport(year: $year)
  }
`;
export const GET_EXPENSES_BY_COST_REPORT = gql`
  query GetMonthlyExpenseByCost($year: String) {
    getMonthlyExpenseByCost(year: $year)
  }
`;
export const GET_TICKET_BY_ID = gql`
  query TicketByID($ticketByIdId: ID) {
    ticketByID(id: $ticketByIdId) {
      id
      ticket_id
      title
      description
      priority
      category
      createdBy
      location
      assignee
      createdAt
      updatedAt
      completed_date
      due_date
      impact
      status
      attachment

      comments {
        createdAt
        text
        user
      }
    }
  }
`;
export const GET_TICKET_LIST = gql`
  query TicketList(
    $category: String
    $title: String
    $filterStatus: [String]
    $createdDate: [String]
    $dueDate: [String]
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
    $createdBy: ID
    $assignedTo: ID
  ) {
    allTickets(
      category: $category
      filterStatus: $filterStatus
      title: $title
      createdDate: $createdDate
      dueDate: $dueDate
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
      createdBy: $createdBy
      assignedTo: $assignedTo
    ) {
      tickets {
        id
        ticket_id
        title
        description
        priority
        category
        createdBy
        assignee
        createdAt
        updatedAt
        completed_date
        due_date
        impact
        status
        attachment
        location
      }
      ticketsCount {
        filterCount
        totalCount
        completedCount
        inTestingCount
        inProgressCount
        notStartedCount
      }
    }
  }
`;
// The ticket list's pipeline strip: one count per stage under the list's own
// scope — the search, the people, the dates, every filter but the stage — in
// ONE request. allTickets counts only three stages, and over every ticket
// rather than the scope, so each stage is asked for as itself and the strip
// reads its filterCount, one row each.
export const GET_TICKET_STAGE_COUNTS = gql`
  query TicketStageCounts(
    $title: String
    $createdBy: ID
    $assignedTo: ID
    $createdDate: [String]
    $dueDate: [String]
  ) {
    notStarted: allTickets(
      filterStatus: ["Not Started"]
      title: $title
      createdBy: $createdBy
      assignedTo: $assignedTo
      createdDate: $createdDate
      dueDate: $dueDate
      offset: 0
      limit: 1
    ) {
      ticketsCount {
        filterCount
      }
    }
    inProgress: allTickets(
      filterStatus: ["In Progress"]
      title: $title
      createdBy: $createdBy
      assignedTo: $assignedTo
      createdDate: $createdDate
      dueDate: $dueDate
      offset: 0
      limit: 1
    ) {
      ticketsCount {
        filterCount
      }
    }
    testing: allTickets(
      filterStatus: ["Testing"]
      title: $title
      createdBy: $createdBy
      assignedTo: $assignedTo
      createdDate: $createdDate
      dueDate: $dueDate
      offset: 0
      limit: 1
    ) {
      ticketsCount {
        filterCount
      }
    }
    resolved: allTickets(
      filterStatus: ["Resolved"]
      title: $title
      createdBy: $createdBy
      assignedTo: $assignedTo
      createdDate: $createdDate
      dueDate: $dueDate
      offset: 0
      limit: 1
    ) {
      ticketsCount {
        filterCount
      }
    }
    closed: allTickets(
      filterStatus: ["Closed"]
      title: $title
      createdBy: $createdBy
      assignedTo: $assignedTo
      createdDate: $createdDate
      dueDate: $dueDate
      offset: 0
      limit: 1
    ) {
      ticketsCount {
        filterCount
      }
    }
    archived: allTickets(
      filterStatus: ["Archived"]
      title: $title
      createdBy: $createdBy
      assignedTo: $assignedTo
      createdDate: $createdDate
      dueDate: $dueDate
      offset: 0
      limit: 1
    ) {
      ticketsCount {
        filterCount
      }
    }
  }
`;
export const GET_ALL_TICKETS_LIST = gql`
  query AllTicketList(
    $type: String
    $filterStatus: [String]
    $filterCreationDate: [String]
    $filterDueDate: [String]
    $filterName: String
    $offset: Int
    $limit: Int
    $order: String
    $orderBy: String
    $createdBy: ID
    $assignedTo: ID
  ) {
    allTicketList(
      type: $type
      filterStatus: $filterStatus
      filterCreationDate: $filterCreationDate
      filterDueDate: $filterDueDate
      filterName: $filterName
      offset: $offset
      limit: $limit
      order: $order
      orderBy: $orderBy
      createdBy: $createdBy
      assignedTo: $assignedTo
    ) {
      tickets {
        id
        ticket_id
        title
        description
        priority
        category
        createdBy
        assignee
        createdAt
        updatedAt
        completed_date
        due_date
        impact
        location
        status
        attachment
      }
      ticketsCount {
        filterCount
        totalCount
        completedCount
        inTestingCount
        inProgressCount
        notStartedCount
      }
    }
  }
`;
export const GET_DEVELOPERS_LIST = gql`
  query ListDeveloper {
    listSoftwareDevelopers {
      id
      name
      address1
      avatarUrl
    }
  }
`;
export const GET_FIXED_COSTS_BUDGET_VS_ACTUAL = gql`
  query GetFixedCostsBudgetVsActual($year: String!, $costType: String!) {
    getFixedCostsBudgetVsActual(year: $year, costType: $costType) {
      summary {
        plannedCost
        actualCost
        remainingCost
        prevYearActual
        yearOverYearChange
        actualCostTillToday
      }
      monthlyData {
        months
        budget
        actual
        previousYearActual
      }
      macroCategoriesData {
        name
        budget
        actual
        previousYearActual
        delta
        utilizationRate
      }
      costTypeBreakdown {
        name
        value
        percentage
      }
    }
  }
`;

export const GET_MONTHLY_MACRO_CATEGORY_BREAKDOWN = gql`
  query GetMonthlyMacroCategoryBreakdown(
    $year: String!
    $month: Int!
    $costType: String!
  ) {
    getMonthlyMacroCategoryBreakdown(
      year: $year
      month: $month
      costType: $costType
    ) {
      summary {
        budget
        actual
        previousYearActual
        delta
        utilizationRate
      }
      macroCategoriesData {
        name
        budget
        actual
        previousYearActual
        delta
        utilizationRate
        yearOverYearChange
      }
      monthName
      year
      costType
    }
  }
`;

export const GET_QUOTE_LOST_ANALYSIS_REPORT = gql`
  query GetLostQuoteAnalysis(
    $year: String!
    $type: String!
    $reasonForClosure: String!
  ) {
    getLostQuoteAnalysis(
      year: $year
      type: $type
      reasonForClosure: $reasonForClosure
    )
  }
`;

export const GET_TOP_VENDORS = gql`
  query getTopVendors($year: String!, $type: String!) {
    getTopVendors(year: $year, type: $type)
  }
`;

export const GET_TOP_TRANSLATED_LANGUAGES = gql`
  query getTopTranslatedLanguages($year: String!, $type: String!) {
    getTopTranslatedLanguages(year: $year, type: $type)
  }
`;
export const GET_PRE_BOOKING_INFO_BY_ITEM_ID = gql`
  query GetBookingByItemID($item_id: String) {
    getBookingByItemID(item_id: $item_id)
  }
`;
export const GET_FIXED_MONTHLY_COST_LIST = gql`
  query GetMonthlyFixedCosts($year: String!) {
    getMonthlyCosts(year: $year)
  }
`;
export const GET_MONTHLY_QUOTE_MARKETING_REPORT = gql`
  query getMonthlyMarketingCosts($year: String!) {
    getMonthlyMarketingCosts(year: $year)
  }
`;
export const GET_MARKETING_REPORT_BY_CATEGORY = gql`
  query GetMonthlyMarketingCostsByCategory($year: String!) {
    getMonthlyMarketingCostsByCategory(year: $year)
  }
`;
// THE MARKETING ROI REPORT asks its two questions in ONE document (10/10/2026):
// one round trip, one loading state, and the server reads the quotes once
// for both (`lingoserver schema/expense/marketingRoi.js`).
export const GET_MARKETING_ROI_REPORT = gql`
  query GetMarketingRoiReport($year: String!) {
    getMonthlyMarketingCosts(year: $year)
    getMonthlyMarketingCostsByCategory(year: $year)
  }
`;
export const GET_EMAIL_TEMPLATES = gql`
  query EmailTemplates(
    $offset: Int
    $limit: Int
    $orderBy: String
    $order: String
    $type: String
    $category: String
    $locale: String
    $search: String
    $tags: [String!]
    $status: String
  ) {
    emailTemplates(
      offset: $offset
      limit: $limit
      orderBy: $orderBy
      order: $order
      type: $type
      category: $category
      locale: $locale
      search: $search
      tags: $tags
      status: $status
    ) {
      emailTemplatesCount
      emailTemplates {
        id

        name
        type
        category
        tags
        isLockedContent
        status
        isDefault
        contents {
          locale
          subjectTpl
          bodyTextTpl
        }
        createdAt
        updatedAt
      }
    }
  }
`;
// THE SPINE OF THE WHOLE LIBRARY, for the counts the email template list
// leads with (DESIGN.md §15: a header sentence must not move as the page is
// filtered, and "Italian only" is a statement about what a record does NOT
// hold, which no resolver argument can express). 81 templates × five scalar
// fields is a few kilobytes read once; when the shelf passes a few hundred
// these counts move to the server.
export const GET_EMAIL_TEMPLATE_LIBRARY = gql`
  query EmailTemplateLibrary($limit: Int) {
    emailTemplates(limit: $limit, offset: 0, orderBy: "name", order: "ASC") {
      emailTemplatesCount
      emailTemplates {
        id
        type
        category
        status
        contents {
          locale
        }
      }
    }
  }
`;
export const GET_EMAIL_TEMPLATE = gql`
  query EmailTemplate($id: ID!) {
    emailTemplate(id: $id) {
      id

      name
      type
      category
      tags
      isLockedContent
      subjectVariablesSchema
      bodyVariablesSchema
      status
      isDefault
      contents {
        bodyHtmlTpl
        bodyTextTpl
        locale
        subjectTpl
      }
      createdAt
      updatedAt
    }
  }
`;
export const GET_ITEM_SENT_EMAILS = gql`
  query GetItemSentEmails($itemId: ID!) {
    getItemSentEmails(itemId: $itemId) {
      id
      itemId
      templateId
      subject
      bodyHtml
      bodyText
      recipients {
        email
        name
        type
      }
      senderEmail
      senderName
      messageId
      status
      sentAt
      deliveredAt
      failureReason
      category
      tags
      variables
      sentByUserId
      sentByUserName
      priority
      locale
      trackingEnabled
      openedAt
      clickedAt
      primaryRecipient {
        email
        name
        type
      }
      wasOpened
      hadClicks
      createdAt
      updatedAt
    }
  }
`;

export const GET_SENT_EMAIL = gql`
  query GetItemSentEmails($id: ID!) {
    getSentEmail(id: $id) {
      id
      itemId
      templateId
      subject
      bodyHtml
      bodyText
      recipients {
        email
        name
        type
      }
      senderEmail
      senderName
      messageId
      status
      sentAt
      deliveredAt
      failureReason
      category
      tags
      variables
      sentByUserId
      sentByUserName
      priority
      locale
      trackingEnabled
      openedAt
      clickedAt
      primaryRecipient {
        email
        name
        type
      }
      wasOpened
      hadClicks
      createdAt
      updatedAt
    }
  }
`;

export const FILTERED_EMAIL_TEMPLATE = gql`
  query FilteredEmailTemplate(
    $type: String
    $category: String
    $search: String
    $status: String
  ) {
    filteredEmailTemplate(
      type: $type
      category: $category
      search: $search
      status: $status
    ) {
      id

      name
      type
      category
      tags
      isLockedContent
      subjectVariablesSchema
      bodyVariablesSchema
      status
      isDefault
      contents {
        bodyTextTpl
        bodyHtmlTpl
        locale
        subjectTpl
      }
      createdAt
      updatedAt
    }
  }
`;

// ==============> BUDGET QUERIES <================
export const GET_BUDGET_LIST = gql`
  query GetBudgetList($offset: Int, $limit: Int) {
    getBudgetList(offset: $offset, limit: $limit)
  }
`;

// What was actually spent in each of these years, per macro category per
// month — the half of a budget that is not the plan.
export const GET_BUDGET_ACTUALS = gql`
  query BudgetActuals($years: [String!]!) {
    budgetActuals(years: $years)
  }
`;

export const GET_BUDGET_BY_YEAR = gql`
  query GetBudgetByYear($year: String!) {
    getBudgetByYear(year: $year)
  }
`;

export const GET_BUDGET_BY_ID = gql`
  query GetBudgetById($id: String!) {
    getBudgetById(id: $id)
  }
`;

// ==============> KPI QUERIES <================

export const GET_KPI_BY_TYPE_AND_YEAR = gql`
  query GetKPIByTypeAndYear(
    $kpiType: String!
    $year: String!
    $entityId: String
  ) {
    getKPIByTypeAndYear(kpiType: $kpiType, year: $year, entityId: $entityId) {
      _id
      year
      kpiType
      entityId
      entityName
      lingoTranslateKPI
      lingoCongressKPI
      monthlySalesKPI {
        january
        february
        march
        april
        may
        june
        july
        august
        september
        october
        november
        december
      }
      totalKPI
      notes
      status
      createdAt
      updatedAt
    }
  }
`;

// Get all KPIs with pagination
export const GET_KPI_LIST = gql`
  query GetKPIList($offset: Int, $limit: Int) {
    getKPIList(offset: $offset, limit: $limit) {
      kpis {
        _id
        year
        company {
          lingoTranslateKPI
          lingoCongressKPI
          total
        }
        notes
        status
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

// Get KPI by year
export const GET_KPI_BY_YEAR = gql`
  query GetKPIByYear($year: String!) {
    getKPIByYear(year: $year) {
      _id
      year
      company {
        lingoTranslateKPI
        lingoCongressKPI
        total
      }
      notes
      status
      createdAt
      updatedAt
    }
  }
`;

// Get KPI by ID
export const GET_KPI_BY_ID = gql`
  query GetKPIById($id: String!) {
    getKPIById(id: $id) {
      _id
      year
      company {
        lingoTranslateKPI
        lingoCongressKPI
        total
      }
      notes
      status
      createdAt
      updatedAt
    }
  }
`;

export const GET_INVOICES_BY_CLIENT = gql`
  query GetInvoiceByClient($offset: Int, $limit: Int, $email: String!, $companyId: ID) {
    getInvoiceByClient(offset: $offset, limit: $limit, email: $email, companyId: $companyId) {
      Invoices {
        _id
        invoiceTo {
          address1
          name
        }
        invoiceFrom {
          name
          address1
        }
        grandTotal
        paymentDeadlines {
          amount
          expiration
          state
        }
        invoiceTotal
        invoiceSubTotal
        invoiceTaxes
        invoiceID
        numeration
        followUpDate
        createdAt
        invoiceDueDate
        invoiceStatus
      }
      InvoiceCount {
        filterCount
        totalCount
      }
    }
  }
`;
export const GET_CLIENT_QUALITY_REPORT = gql`
  query getQualityMonthlyReportByClient(
    $issueCategory: String
    $companyId: String
  ) {
    getQualityMonthlyReportByClient(
      issueCategory: $issueCategory
      companyId: $companyId
    )
  }
`;
export const GET_COMPANY_LIST_BY_NAME_STAGE = gql`
  query CompaniesList($name: String, $stage: String, $accountType: String) {
    companiesList(name: $name, stage: $stage, accountType: $accountType) {
      id
      name
      accountType
      paymentTerms
      address1
      address2
      city
      postcode
      VAT
    }
  }
`;
export const GET_ACCOUNT_MANAGEMENT_CLIENT_REPORT = gql`
  query GetAccountManagementClientReport(
    $startDate: String
    $endDate: String
    $segment: String
    $accountManager: String
  ) {
    getAccountManagementClientReport(
      startDate: $startDate
      endDate: $endDate
      segment: $segment
      accountManager: $accountManager
    )
  }
`;
export const GET_ACCOUNT_MANAGEMENT_ACTIVITY_REPORT = gql`
  query GetAccountManagementActivityReport(
    $startDate: String
    $endDate: String
    $accountManager: String
  ) {
    getAccountManagementActivityReport(
      startDate: $startDate
      endDate: $endDate
      accountManager: $accountManager
    )
  }
`;

export const GET_ACCOUNT_MANAGEMENT_QUOTE_REPORT = gql`
  query GetAccountManagementQuoteReport(
    $startDate: String
    $endDate: String
    $segment: String
    $accountManager: String
  ) {
    getAccountManagementQuoteReport(
      startDate: $startDate
      endDate: $endDate
      segment: $segment
      accountManager: $accountManager
    )
  }
`;

export const GET_ACCOUNT_MANAGER_REPORT = gql`
  query GetAccountManagerReport(
    $startDate: String
    $endDate: String
    $accountManager: String
  ) {
    getAccountManagerReport(
      startDate: $startDate
      endDate: $endDate
      accountManager: $accountManager
    )
  }
`;
export const GET_AM_CALLS_QUOTE_REPORT = gql`
  query GetAMCallsQuoteReport(
    $startDate: String
    $endDate: String
    $accountManager: String
    $segment: String
  ) {
    getAMCallsQuoteReport(
      startDate: $startDate
      endDate: $endDate
      accountManager: $accountManager
      segment: $segment
    )
  }
`;

export const GET_AM_NEW_BUSINESS_REPORT = gql`
  query GetAMBusinessReports(
    $startDate: String
    $endDate: String
    $accountManager: String
    $segment: String
  ) {
    getAMBusinessReports(
      startDate: $startDate
      endDate: $endDate
      accountManager: $accountManager
      segment: $segment
    )
  }
`;

export const GET_AM_DETAIL_REPORTS = gql`
  query GetAMDetailReports(
    $startDate: String
    $endDate: String
    $accountManager: String
    $segment: String
  ) {
    getAMDetailReports(
      startDate: $startDate
      endDate: $endDate
      accountManager: $accountManager
      segment: $segment
    )
  }
`;
export const GET_AM_SUMMARY_REPORT = gql`
  query GetAMSummaryReport(
    $startDate: String
    $endDate: String
    $accountManagerId: String!
  ) {
    getAMSummaryReport(
      startDate: $startDate
      endDate: $endDate
      accountManagerId: $accountManagerId
    )
  }
`;
export const GET_SEGMENT_SALES_REPORT = gql`
  query GetSegmentSalesReport(
    $startDate: String
    $endDate: String
    $accountManagerId: String
  ) {
    getSegmentSalesReport(
      startDate: $startDate
      endDate: $endDate
      accountManagerId: $accountManagerId
    )
  }
`;

export const GET_MANAGERS_LIST = gql`
  query GetManagersList($department: String) {
    managersList(department: $department) {
      id
      name
      email
      avatarUrl
      jobTitle
    }
  }
`;
export const AM_KEY_Strategic_CLIENTS = gql`
  query GetAMKeyStrategicClients(
    $startDate: String
    $endDate: String
    $segment: String
    $accountManager: String
  ) {
    getAMKeyStrategicClients(
      startDate: $startDate
      endDate: $endDate
      segment: $segment
      accountManager: $accountManager
    ) {
      clientId
      clientName
      segment
      kpiValue
      totalSales
      achievementRate
    }
  }
`;

export const GET_AM_KPI_REPORT = gql`
  query GetAMKPIReport(
    $startDate: String
    $endDate: String
    $accountManager: String
    $segment: String
  ) {
    getAMKPIReport(
      startDate: $startDate
      endDate: $endDate
      accountManager: $accountManager
      segment: $segment
    )
  }
`;

export const GET_GOLDEN_PIN_DETAILS = gql`
  query GoldenPinDetails($goldenPinDetailsId: String) {
    goldenPinDetails(id: $goldenPinDetailsId) {
      id
      pinNumber
      createdAt
      reviewDate
      employee {
        name
        email
      }
      reviewedBy {
        name
        email
      }
      status
      department
      comments
      action_description
    }
  }
`;

export const GET_LINGUIST_INFO_BY_ID = gql`
  query GetLinguistInfoById($id: String) {
    linguistById(id: $id)
  }
`;

/**
 * TECHNICIAN_AVAILABILITY
 *
 * Checks which technicians have overlapping Confirmed allocations in the
 * given [startDateTime, endDateTime] window.
 *
 * Only technicians that have at least one conflict are returned; technicians
 * absent from the result are fully available.
 *
 * Variables
 *   $startDateTime  String!        – ISO start of the new expense
 *   $endDateTime    String!        – ISO end of the new expense
 *   $technicianIds  [ID]           – optional subset to check
 */
export const TECHNICIAN_AVAILABILITY = gql`
  query TechnicianAvailability(
    $startDateTime: String
    $endDateTime: String
    $technicianIds: [ID]
  ) {
    technicianAvailability(
      startDateTime: $startDateTime
      endDateTime: $endDateTime
      technicianIds: $technicianIds
    ) {
      technicianId
      isAvailable
      conflicts {
        allocationId
        orderNo
        projectId
        title
        service
        startDateTime
        endDateTime
        companyNameAndId
        status
      }
    }
  }
`;

// ==============> BITS & BOBS <================
export const ALL_BITS_AND_BOBS = gql`
  query allBitsAndBobs(
    $filterStatus: [String]
    $order: String
    $orderBy: String
  ) {
    allBitsAndBobs(
      filterStatus: $filterStatus
      order: $order
      orderBy: $orderBy
    ) {
      id
      bitNumber
      note
      priority
      status
      createdAtDate
      completedAtDate
      assigneeType
      creator {
        name
        email
        avatarUrl
      }
      assignee {
        name
        email
        avatarUrl
      }
      volleys {
        message
        createdAt
        author {
          name
          email
          avatarUrl
        }
      }
    }
  }
`;

export const BITS_AND_BOBS_LEADERBOARD = gql`
  query bitAndBobLeaderboard {
    bitAndBobLeaderboard {
      players {
        name
        email
        served
        smashed
        score
        avatarUrl
      }
      departments {
        name
        email
        served
        smashed
        score
        avatarUrl
      }
    }
  }
`;

// `group` splits the log in two: PRIORITY (the individual, high-value mail) and
// PRE_BOOKING (the bulk opportunity batches), each paginated on its own so a
// batch of a hundred can't push the priority mail off the first page. `search`
// filters by address — recipient or sender.
export const GET_COMMUNICATIONS_BY_UUID = gql`
  query GetCommunicationsByUuid(
    $uuid: String!
    $search: String
    $group: CommunicationGroup
    $offset: Int
    $limit: Int
  ) {
    getCommunicationsByUuid(
      uuid: $uuid
      search: $search
      group: $group
      offset: $offset
      limit: $limit
    ) {
      communications {
        id
        uuid
        projectType
        type
        subject
        bodyHtml
        bodyText
        senderName
        senderEmail
        recipients {
          email
          name
          type
        }
        attachments {
          filename
          url
          size
          mimeType
          downloadUrl
        }
        sendgridMessageId
        status
        timeline {
          status
          timestamp
        }
        sentAt
        deliveredAt
        openedAt
        clickedAt
        failureReason
        isAutomatic
        sentByUserId
        sentByUserName
        createdAt
        updatedAt
        source
        direction
        mailboxEmail
        outlookWebLink
        conversationId
        emailMessageId
        threadCount
      }
      communicationsCount {
        filterCount
        totalCount
      }
      preBooking {
        totalCount
        openedCount
        issueCount
        recipientCount
      }
    }
  }
`;

// Scope the communication log by email TYPE rather than by a single record —
// what a global report (e.g. Credit Control) needs. `invoiceNumber` is resolved
// server-side for Invoice-scoped records.
// Who to actually write to about an invoice. The address printed on the
// document is frequently a PEC (certified mail) that nobody reads.
export const GET_INVOICE_BILLING_CONTACTS = gql`
  query GetInvoiceBillingContacts($invoiceId: ID!) {
    getInvoiceBillingContacts(invoiceId: $invoiceId) {
      invoiceEmail
      invoiceEmailIsPec
      companyName
      contacts {
        email
        name
        role
        jobTitle
        reason
      }
    }
  }
`;

export const GET_COMMUNICATIONS_BY_TYPES = gql`
  query GetCommunicationsByTypes(
    $types: [String!]!
    $search: String
    $group: CommunicationGroup
    $offset: Int
    $limit: Int
    $from: String
    $to: String
  ) {
    getCommunicationsByTypes(
      types: $types
      search: $search
      group: $group
      offset: $offset
      limit: $limit
      from: $from
      to: $to
    ) {
      communications {
        id
        uuid
        invoiceNumber
        projectType
        type
        subject
        bodyHtml
        bodyText
        senderName
        senderEmail
        recipients {
          email
          name
          type
        }
        attachments {
          filename
          url
        }
        sendgridMessageId
        status
        timeline {
          status
          timestamp
        }
        sentAt
        deliveredAt
        openedAt
        clickedAt
        failureReason
        isAutomatic
        sentByUserId
        sentByUserName
        createdAt
        updatedAt
      }
      communicationsCount {
        filterCount
        totalCount
      }
      preBooking {
        totalCount
        openedCount
        issueCount
        recipientCount
      }
    }
  }
`;

export const GET_COMMUNICATIONS_BY_COMPANY = gql`
  query GetCommunicationsByCompany(
    $companyId: String!
    $search: String
    $group: CommunicationGroup
    $offset: Int
    $limit: Int
  ) {
    getCommunicationsByCompany(
      companyId: $companyId
      search: $search
      group: $group
      offset: $offset
      limit: $limit
    ) {
      communications {
        id
        uuid
        projectType
        type
        subject
        bodyHtml
        bodyText
        senderName
        senderEmail
        recipients {
          email
          name
          type
        }
        attachments {
          filename
          url
          size
          mimeType
          downloadUrl
        }
        sendgridMessageId
        status
        timeline {
          status
          timestamp
        }
        sentAt
        deliveredAt
        openedAt
        clickedAt
        failureReason
        isAutomatic
        sentByUserId
        sentByUserName
        createdAt
        updatedAt
        source
        direction
        mailboxEmail
        outlookWebLink
        conversationId
        emailMessageId
        threadCount
      }
      communicationsCount {
        filterCount
        totalCount
      }
      preBooking {
        totalCount
        openedCount
        issueCount
        recipientCount
      }
    }
  }
`;

export const GET_COMMUNICATIONS_BY_TYPE = gql`
  query GetCommunicationsByType($type: String!) {
    getCommunicationsByType(type: $type) {
      id
      uuid
      projectType
      type
      subject
      senderName
      senderEmail
      recipients {
        email
        name
        type
      }
      status
      timeline {
        status
        timestamp
      }
      sentAt
      failureReason
      isAutomatic
      sentByUserName
      createdAt
    }
  }
`;

// ==============> ACADEMY QUERIES <================
export const ALL_ACADEMY_PROJECT_DETAILS = gql`
  query AllAcademyProjects(
    $filterProjectManager: String
    $filterStatus: [String]
    $filterNumber: String
    $filterCreationDate: [String]
    $filterDeliveryDate: [String]
    $limit: Int
    $offset: Int
    $order: String
    $orderBy: String
  ) {
    allAcademyOrders(
      filterProjectManager: $filterProjectManager
      filterStatus: $filterStatus
      filterNumber: $filterNumber
      filterCreationDate: $filterCreationDate
      filterDeliveryDateTime: $filterDeliveryDate
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
    ) {
      academyOrders {
        id
        orderNumber
        subtotal
        margin
        netTotal
        companyNameAndId {
          accountType
          id
          name
        }
        projectManager {
          name
          email
        }
        accountManager {
          name
        }
        bookedBy {
          firstName
          lastName
          email
        }
        academyItem {
          name
          title
          quantity
          price
          discount
        }
        status
        createdAtDate
        deliveryDateTime
      }
      academyOrderCount {
        filterCount
        totalCount
        deliveredCount
        allocatedCount
        claimedCount
        statusCounts {
          status
          count
          value
        }
      }
    }
  }
`;

export const ACADEMY_PROJECT_DETAILS = gql`
  query AcademyProject($academyOrderId: ID!) {
    academyOrder(academyOrderId: $academyOrderId) {
      id
      orderNumber
      industry {
        name
      }
      companyNameAndId {
          accountType
        id
        name
        paymentTerms
      }
      projectManager {
        name
        email
      }
      accountManager {
        name
        email
      }

      deliveryDateTime

      academyItem {
        name
        description
        title
        quantity
        price
        total
        discount
        item_id
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
      }
      academyItem2 {
        title
        quantity
        price
        total
        discount
        item_id
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
      }

      subtotal

      bookedBy {
        firstName
        lastName
        email
      }
      status

      createdAtDate
      notes

      pmNotes
      serviceSubtotal
      taxes
      totalDiscount
      grandTotal
      margin
      netTotal
      quoteNumber
      quoteId

      subject
      address1
      address2
      city
      postCode
      country {
        label
        code
      }
      supportMaterialLink
      is_urgent

      invoiceNo
      isBillingCompleted
      isPaid
      projectTitle
      deliveryEmail
      billingNotes
      brand {
        academy
      }
      deliveryAddress

      businessDeveloper
    }
  }
`;

export const ALL_ACADEMY_QUOTE_DETAILS = gql`
  query AllAcademyQuotes(
    $filterAccountManager: String
    $serviceType: String
    $filterStatus: [String]
    $filterNumber: String
    $filterCreationDate: [String]
    $filterDeliveryDate: [String]
    $needsAttention: Boolean
    $followUpDue: Boolean
    $highValueQuote: Boolean
    $limit: Int
    $offset: Int
    $order: String
    $orderBy: String
    $businessDeveloper: String
  ) {
    allAcademyQuoteOrders(
      filterAccountManager: $filterAccountManager
      serviceType: $serviceType
      filterStatus: $filterStatus
      filterNumber: $filterNumber
      filterCreationDate: $filterCreationDate
      filterDeliveryDateTime: $filterDeliveryDate
      needsAttention: $needsAttention
      followUpDue: $followUpDue
      highValueQuote: $highValueQuote
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
      businessDeveloper: $businessDeveloper
    ) {
      academyOrders {
        id
        orderNumber
        subtotal
        utm
        reasonForClosure
        campaignGclid
        source
        netTotal
        followUpDate
        quoteDeadline
        companyNameAndId {
          accountType
          id
          name
        }
        accountManager {
          name
        }
        bookedBy {
          firstName
          lastName
          email
        }
        academyItem {
          name
          title
          quantity
          price
        }
        status
        createdAtDate
        deliveryDateTime
        pmNotes
      }
      academyOrderCount {
        filterCount
        totalCount
        closedCount
        openCount
        TBSCount
        awardedCount
        wonCount
        sentToPMCount
        filteredValue
        attentionCount
        statusCounts {
          status
          count
          value
        }
      }
    }
  }
`;

export const ACADEMY_SERVICE = gql`
  query AcademyService {
    serviceAcademy {
      serviceItems {
        Code
        Item {
          italian
          english
        }
        Description {
          italian
          english
        }
        InvCode
      }
      addService {
        Code
        Item {
          italian
          english
        }
        Description {
          italian
          english
        }
        InvCode
      }
    }
  }
`;

export const ACADEMY_QUOTE_EMAIL = gql`
  mutation QuoteAcademyEmail(
    $language: String
    $subject: String
    $email: String
    $body: String
    $id: ID
    $managerName: String
    $jobTitle: String
    $phoneNumber: String
    $description: String
  ) {
    quoteAcademyEmail(
      language: $language
      subject: $subject
      email: $email
      body: $body
      id: $id
      managerName: $managerName
      jobTitle: $jobTitle
      phoneNumber: $phoneNumber
      description: $description
    ) {
      id
    }
  }
`;

export const ACADEMY_QUOTE_DETAILS = gql`
  query AcademyOrder($academyOrderId: ID!) {
    academyOrder(academyOrderId: $academyOrderId) {
      id
      orderNumber
      notesOptions
      deliveryAddress
      businessDeveloper
      optionSelected
      utm
      campaignGclid
      source
      marketingChannel {
        type
        details {
          source
          sourceDetails {
            utm
            campaignGclid
            ppcSource
            cpn
            gad_source
            kwid
            adgroup
            keywords
          }
        }
      }
      language
      companyLogo
      taxes
      paymentLink {
        receipt_url
        url
        isPaid
        amount
      }
      quoteSignature
      totalDiscount
      grandTotal
      netTotal
      taxesOptions
      totalDiscountOptions
      netTotalOptions
      grandTotalOptions
      subtotalOptions
      reasonForClosure
      industry {
        code
        name
      }
      companyNameAndId {
          accountType
        id
        name
        address1
        address2
        city
        postcode
        paymentTerms
        VAT
      }
      accountManager {
        name
        email
        avatarUrl
        jobTitle
        phoneNumber
        language {
          code
          name
          nativename
        }
      }
      stage
      deliveryDateTime
      quoteDeadline
      followUpDate
      subtotal
      bookedBy {
        firstName
        lastName
        email
      }
      status
      createdAtDate
      notes
      pmNotes
      addOns {
        seo
        cover
        website
        quoteInfo
        companyInfo
        privateHighlights
        packages
        urgency
        friendly
        sector
        services
        contents
      }
      brand {
        academy
      }
      clients {
        name
        logo
      }
      businessDeveloper
      optionsTitles
      discountCode {
        code
        value
        expiryDate
      }
      discountCodeOptions {
        code
        value
        expiryDate
      }
      pkgsPriceVar {
        economyDiscount
        professionalDiscount
        premiumDiscount
      }
      pkgsDueDates
      academyItem {
        name
        description
        quantity
        price
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
        total
        discount
      }
      academyItem2 {
        name
        description
        quantity
        price
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
        total
        discount
      }
      itemTitles {
        title
        before_item_id
        after_item_id
        position
        type
      }
      itemTitles2 {
        title
        before_item_id
        after_item_id
        position
        type
      }
    }
  }
`;

// Quote-page query kept separate from the legacy Academy quote/list queries.
// Only fields currently exposed by AcademyOrders are selected here.
export const ACADEMY_QUOTE_PAGE_DETAILS = gql`
  query AcademyQuotePageDetails($academyOrderId: ID!) {
    academyOrder(academyOrderId: $academyOrderId) {
      id
      orderNumber
      optionSelected
      industry {
        code
        name
      }
      companyNameAndId {
          accountType
        id
        name
        paymentTerms
        address1
        address2
        city
        postcode
        VAT
        taxCode
        generalPhone
        country {
          code
          label
          phone
        }
      }
      projectManager {
        name
        email
        jobTitle
        phoneNumber
      }
      accountManager {
        name
        email
        jobTitle
        phoneNumber
      }
      stage
      deliveryDateTime
      quoteDeadline
      followUpDate
      academyItem {
        name
        description
        title
        quantity
        price
        total
        discount
        item_id
        isPreBookingSent
        isBookingSent
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
      }
      academyItem2 {
        name
        description
        title
        quantity
        price
        total
        discount
        item_id
        isPreBookingSent
        isBookingSent
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
      }
      itemTitles {
        title
        before_item_id
        after_item_id
        position
        type
      }
      itemTitles2 {
        title
        before_item_id
        after_item_id
        position
        type
      }
      subtotal
      subtotalOptions
      bookedBy {
        firstName
        lastName
        email
      }
      status
      reasonForClosure
      createdAtDate
      notes
      notesOptions
      pmNotes
      serviceSubtotal
      addOns {
        seo
        cover
        website
        quoteInfo
        companyInfo
        privateHighlights
        packages
        urgency
        friendly
        sector
        sworn
      }
      taxes
      totalDiscount
      grandTotal
      netTotal
      taxesOptions
      totalDiscountOptions
      grandTotalOptions
      netTotalOptions
      quoteNumber
      quoteId
      quoteSignature
      language
      companyLogo
      paymentLink {
        receipt_url
        isPaid
        url
        amount
      }
      marketingChannel {
        type
        details {
          source
          sourceDetails {
            utm
            cpn
            adgroup
            kwid
            gad_source
            ppcSource
            campaignGclid
            keywords
          }
        }
      }
      clients {
        name
        logo
      }
      brand {
        academy
      }
      businessDeveloper
      optionsTitles
      discountCode {
        code
        expiryDate
        value
      }
      discountCodeOptions {
        code
        expiryDate
        value
      }
      pkgsPriceVar {
        economyDiscount
        professionalDiscount
        premiumDiscount
      }
      pkgsDueDates
      subject
      address1
      address2
      city
      postCode
      country {
        code
        label
        phone
      }
      deliveryAddress
      supportMaterialLink
      is_urgent
    }
  }
`;

// ==============> SOFTWAREDEV QUERIES <================
export const ALL_SOFTWAREDEV_PROJECT_DETAILS = gql`
  query AllSoftwareDevProjects(
    $filterProjectManager: String
    $filterStatus: [String]
    $filterNumber: String
    $filterCreationDate: [String]
    $filterDeliveryDate: [String]
    $limit: Int
    $offset: Int
    $order: String
    $orderBy: String
  ) {
    allSoftwareDevOrders(
      filterProjectManager: $filterProjectManager
      filterStatus: $filterStatus
      filterNumber: $filterNumber
      filterCreationDate: $filterCreationDate
      filterDeliveryDateTime: $filterDeliveryDate
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
    ) {
      softwareDevOrders {
        id
        orderNumber
        subtotal
        margin
        netTotal
        companyNameAndId {
          accountType
          id
          name
        }
        projectManager {
          name
          email
        }
        accountManager {
          name
        }
        bookedBy {
          firstName
          lastName
          email
        }
        softwaredevItem {
          title
          name
          quantity
          price
          discount
        }
        status
        createdAtDate
        deliveryDateTime
      }
      softwareDevOrderCount {
        filterCount
        totalCount
        deliveredCount
        allocatedCount
        claimedCount
        statusCounts {
          status
          count
          value
        }
      }
    }
  }
`;

export const SOFTWAREDEV_PROJECT_DETAILS = gql`
  query SoftwareDevProject($softwareDevOrderId: ID!) {
    softwareDevOrder(softwareDevOrderId: $softwareDevOrderId) {
      id
      orderNumber
      industry {
        name
      }
      companyNameAndId {
          accountType
        id
        name
        paymentTerms
      }
      projectManager {
        name
        email
        jobTitle
        phoneNumber
      }
      accountManager {
        name
        email
        jobTitle
        phoneNumber
      }
      stage
      deliveryDateTime
      quoteDeadline
      softwaredevItem {
        name
        description
        title
        quantity
        price
        total
        discount
        item_id
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
      }
      softwaredevItem2 {
        title
        quantity
        price
        total
        discount
        item_id
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
      }
      itemTitles {
        title
        before_item_id
        after_item_id
        position
        type
      }
      itemTitles2 {
        title
        before_item_id
        after_item_id
        position
        type
      }
      subtotal
      subtotalOptions
      bookedBy {
        firstName
        lastName
        email
      }
      status
      reasonForClosure
      createdAtDate
      notes
      notesOptions
      pmNotes
      serviceSubtotal
      addOns {
        seo
        cover
        website
        quoteInfo
        companyInfo
        privateHighlights
        packages
        urgency
        friendly
        sector
        upSellingServices
      }
      taxes
      totalDiscount
      grandTotal
      margin
      netTotal
      followUpDate
      totalDiscountOptions
      grandTotalOptions
      netTotalOptions
      taxesOptions
      subject
      address1
      address2
      city
      postCode
      country {
        label
        code
      }
      supportMaterialLink
      is_urgent
      invoiceNo
      clients {
        name
        logo
      }
      isBillingCompleted
      isPaid
      projectTitle
      deliveryEmail
      billingNotes
      brand {
        softwaredev
      }
      deliveryAddress
      businessDeveloper
      optionsTitles
    }
  }
`;

export const ALL_SOFTWAREDEV_QUOTE_DETAILS = gql`
  query AllSoftwareDevQuotes(
    $filterAccountManager: String
    $serviceType: String
    $filterStatus: [String]
    $filterNumber: String
    $filterCreationDate: [String]
    $filterStartDate: [String]
    $needsAttention: Boolean
    $followUpDue: Boolean
    $highValueQuote: Boolean
    $limit: Int
    $offset: Int
    $order: String
    $orderBy: String
    $businessDeveloper: String
  ) {
    allSoftwareDevQuoteOrders(
      filterAccountManager: $filterAccountManager
      serviceType: $serviceType
      filterStatus: $filterStatus
      filterNumber: $filterNumber
      filterCreationDate: $filterCreationDate
      filterDeliveryDateTime: $filterStartDate
      needsAttention: $needsAttention
      followUpDue: $followUpDue
      highValueQuote: $highValueQuote
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
      businessDeveloper: $businessDeveloper
    ) {
      softwareDevOrders {
        id
        orderNumber
        subtotal
        utm
        reasonForClosure
        campaignGclid
        source
        netTotal
        followUpDate
        companyNameAndId {
          accountType
          id
          name
        }
        accountManager {
          name
        }
        bookedBy {
          firstName
          lastName
          email
        }
        softwaredevItem {
          title
          name
          quantity
          price
        }
        status
        createdAtDate
        deliveryDateTime
        pmNotes
      }
      softwareDevOrderCount {
        filterCount
        totalCount
        closedCount
        openCount
        TBSCount
        awardedCount
        wonCount
        sentToPMCount
        filteredValue
        attentionCount
        statusCounts {
          status
          count
          value
        }
      }
    }
  }
`;

export const SOFTWAREDEV_QUOTE_DETAILS = gql`
  query SoftwareDevOrder($softwareDevOrderId: ID!) {
    softwareDevOrder(softwareDevOrderId: $softwareDevOrderId) {
      id
      quoteId
      orderNumber
      notesOptions
      deliveryAddress
      businessDeveloper
      optionSelected
      utm
      campaignGclid
      source
      marketingChannel {
        type
        details {
          source
          sourceDetails {
            utm
            campaignGclid
            ppcSource
            cpn
            gad_source
            kwid
            adgroup
            keywords
          }
        }
      }
      language
      companyLogo
      taxes
      paymentLink {
        receipt_url
        url
        isPaid
        amount
      }
      quoteSignature
      totalDiscount
      grandTotal
      netTotal
      taxesOptions
      totalDiscountOptions
      netTotalOptions
      grandTotalOptions
      subtotalOptions
      reasonForClosure
      industry {
        code
        name
      }
      companyNameAndId {
          accountType
        id
        name
        address1
        address2
        city
        postcode
        paymentTerms
        VAT
      }
      accountManager {
        name
        email
        avatarUrl
        jobTitle
        phoneNumber
        language {
          code
          name
          nativename
        }
      }
      stage
      deliveryDateTime
      quoteDeadline
      followUpDate
      subtotal
      bookedBy {
        firstName
        lastName
        email
      }
      status
      createdAtDate
      notes
      pmNotes
      addOns {
        seo
        cover
        website
        quoteInfo
        companyInfo
        privateHighlights
        packages
        urgency
        friendly
        sector
        services
        contents
      }
      brand {
        softwaredev
      }
      clients {
        name
        logo
      }
      businessDeveloper
      optionsTitles
      subject
      address1
      address2
      city
      postCode
      country {
        label
        code
      }
      supportMaterialLink
      is_urgent
      discountCode {
        code
        value
        expiryDate
      }
      discountCodeOptions {
        code
        value
        expiryDate
      }
      pkgsPriceVar {
        economyDiscount
        professionalDiscount
        premiumDiscount
      }
      pkgsDueDates
      softwaredevItem {
        title
        quantity
        price
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
        total
        discount
      }
      softwaredevItem2 {
        title
        quantity
        price
        service {
          Code
          InvCode
          Item {
            italian
            english
          }
          Description {
            italian
            english
          }
        }
        total
        discount
      }
      itemTitles {
        title
        before_item_id
        after_item_id
        position
        type
      }
      itemTitles2 {
        title
        before_item_id
        after_item_id
        position
        type
      }
    }
  }
`;

export const SOFTWAREDEV_SERVICE = gql`
  query SoftwareDevService {
    serviceSoftwareDev {
      serviceItems {
        Code
        Item {
          italian
          english
        }
        Description {
          italian
          english
        }
        InvCode
      }
      addService {
        Code
        Item {
          italian
          english
        }
        Description {
          italian
          english
        }
        InvCode
      }
    }
  }
`;

export const SOFTWAREDEV_QUOTE_EMAIL = gql`
  mutation QuoteSoftwareDevEmail(
    $language: String
    $subject: String
    $email: String
    $body: String
    $id: ID
    $managerName: String
    $jobTitle: String
    $phoneNumber: String
    $description: String
  ) {
    quoteSoftwareDevEmail(
      language: $language
      subject: $subject
      email: $email
      body: $body
      id: $id
      managerName: $managerName
      jobTitle: $jobTitle
      phoneNumber: $phoneNumber
      description: $description
    ) {
      id
    }
  }
`;
export const GET_ATLAS_PROFILE = gql`
  query GetAtlasProfile($id: String) {
    getAtlasProfile(id: $id)
  }
`;

// ---- Mediation projects (CI-MC): 1:1 clones of the interpretation project operations ----
export const ALL_MEDIATION_PROJECT_DETAILS = gql`
  query AllMediationOrders(
    $filterStatus: [String]
    $filterNumber: String
    $filterCreationDate: [String]
    $filterStartDate: [String]
    $filterProjectManager: String
    $openSlots: Boolean
    $limit: Int
    $offset: Int
    $order: String
    $orderBy: String
  ) {
    allMediationOrders(
      filterStatus: $filterStatus
      filterNumber: $filterNumber
      filterCreationDate: $filterCreationDate
      filterStartDate: $filterStartDate
      filterProjectManager: $filterProjectManager
      openSlots: $openSlots
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
    ) {
      mediationOrders {
        id
        netTotal
        orderNumber
        margin
        companyNameAndId {
          accountType
          id
          name
        }
        projectManager {
          name
          email
        }
        bookedBy {
          firstName
          lastName
        }
        interpretationItem {
          sourceLanguage {
            code
            name
            nativename
          }
          quantity
          targetLanguage {
            code
            name
            nativename
          }
        }
        status
        createdAtDate
        startDate
        address1
        address2
        subtotal
        postCode
        country {
          code
          label
          phone
        }
        additionalService {
          price
          title
          quantity
          discount
        }
        stage
        is_urgent
        isTwiliogenerated
      }
      mediationOrderCount {
        totalCount
        filterCount
        deliveredCount
        allocatedCount
        claimedCount
      }
    }
  }
`;

export const MEDIATION_PROJECT_DETAILS = gql`
  query MediationOrder($mediationOrderId: ID!) {
    mediationOrder(mediationOrderId: $mediationOrderId) {
      id
      orderNumber
      taxes
      totalDiscount
      grandTotal
      netTotal
      quoteNumber
      isBillingCompleted
      businessDeveloper
      quoteId
      industry {
        code
        name
      }
      companyNameAndId {
          accountType
        id
        name
        id
        name
        paymentTerms
        address1
        address2
        city
        postcode
        VAT
      }
      projectManager {
        name
        email
        avatarUrl
      }
      accountManager {
        name
        email
        avatarUrl
      }
      address1
      interpretationItem {
        discount
        item_id
        isPreBookingSent
        isBookingSent
        remainingBookingSlots
        # How many interpreters the booth needs when that is not the figure
        # sold (report 05/10/2026, §7); null means "the sold quantity".
        interpretersWanted
        # The consuntivo of the row, written from the validated allocations
        # (specifica PM AG-02): what was actually served, beside the request
        # above, which stays the client's and is never written from it.
        validatedPersonHours
        validatedCount
        validatedExpected
        validatedState
        validatedWindowsDiffer
        validatedStart
        validatedEnd
        sourceLanguage {
          code
          name
          nativename
        }
        targetLanguage {
          code
          name
          nativename
        }
        service {
          Code
          InvCode
          Description {
            italian
            english
          }
          Service {
            italian
            english
          }
        }
        title
        quantity
        price
        total
        timezone
        type
        startDateTime
        endDateTime
      }
      subtotal
      subject
      address2
      postCode
      city
      country {
        code
        label
        phone
      }
      bookedBy {
        firstName
        lastName
        email
      }
      status
      stage
      completionDate
      margin
      addOns {
        remoteEventAddress
      }
      counterpart {
        id
        stage
        orderNumber
        status
      }
      financialsSealedAt
      financialsSealedBy {
        name
      }
      sealedMargin
      sealedSnapshot
      briefingSentAt
      briefingSentBy {
        id
        name
      }
      clientFeedbackSentAt
      clientFeedbackSentBy {
        id
        name
      }
      sealHistory
      is_urgent
      isTwiliogenerated
      supportMaterialLink
      createdAtDate
      startDate
      endDate
      notes
      pmNotes
      serviceSubtotal
      additionalService {
        title
        startDateTime
        endDateTime
        price
        discount

        quantity
        service {
          Code
          InvCode
          Description {
            italian
            english
          }
          Service {
            italian
            english
          }
        }
        serviceTotal
      }
    }
  }
`;

export const DEL_MEDIATION_PROJECT_DETAILS = gql`
  query DelInterpretProject($deleteMediationOrdersId: ID!) {
    deleteMediationOrders(id: $deleteMediationOrdersId)
  }
`;

// The event list's own documents (Phase 8 of the interpretation plan): the
// rows with what the list reads — the event's dates, the staffing the server
// counts, the seal — one row per status for the pipeline cards, and the
// project managers' breakdown. Same shape on the mediation clone.
const EVENT_LIST_ROW = `
        id
        orderNumber
        status
        stage
        subject
        netTotal
        subtotal
        margin
        is_urgent
        createdAtDate
        createdAtDateTime
        startDate
        endDate
        completionDate
        isBillingCompleted
        quoteNumber
        financialsSealedAt
        sealedMargin
        staffingWanted
        staffingFilled
        # Readable from the list without opening the project (report §3):
        # equipment on the order, and an AI interpreting session on an item.
        hasEquipment
        hasAiSession
        staffingItems {
          item_id
          filled
          offered
        }
        technicianSummary {
          toSend
          pending
          confirmed
          completed
          refused
        }
        briefingSentAt
        city
        address1
        addOns {
          remoteEventAddress
        }
        companyNameAndId {
          accountType
          id
          name
        }
        projectManager {
          name
          email
        }
        accountManager {
          name
          email
        }
        bookedBy {
          firstName
          lastName
          email
        }
        interpretationItem {
          item_id
          title
          type
          quantity
          startDateTime
          endDateTime
          timezone
          service {
            Code
          }
          sourceLanguage {
            name
          }
          targetLanguage {
            name
          }
        }
`;
const EVENT_LIST_COUNTS = `
        totalCount
        filterCount
        deliveredCount
        allocatedCount
        claimedCount
        statusCounts {
          status
          count
          value
        }
`;
const EVENT_LIST_BREAKDOWN = `
      projectManagerBreakdown {
        name
        count
        value
        avgMargin
        urgentCount
      }
`;

export const INTERPRETATION_PROJECT_LIST = gql`
  query InterpretationProjectList(
    $filterAccountType: String
    $filterStatus: [String]
    $filterNumber: String
    $filterCreationDate: [String]
    $filterStartDate: [String]
    $filterProjectManager: String
    $filterEquipment: String
    $filterAi: String
    $filterCity: String
    $openSlots: Boolean
    $limit: Int
    $offset: Int
    $order: String
    $orderBy: String
  ) {
    allInterpretationOrders(
      filterAccountType: $filterAccountType
      filterStatus: $filterStatus
      filterNumber: $filterNumber
      filterCreationDate: $filterCreationDate
      filterStartDate: $filterStartDate
      filterProjectManager: $filterProjectManager
      filterEquipment: $filterEquipment
      filterAi: $filterAi
      filterCity: $filterCity
      openSlots: $openSlots
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
    ) {
      interpretationOrders {
        ${EVENT_LIST_ROW}
        counterpart {
          id
          stage
          orderNumber
          status
        }
      }
      interpretationOrderCount {
        ${EVENT_LIST_COUNTS}
      }
      ${EVENT_LIST_BREAKDOWN}
    }
  }
`;

export const MEDIATION_PROJECT_LIST = gql`
  query MediationProjectList(
    $filterAccountType: String
    $filterStatus: [String]
    $filterNumber: String
    $filterCreationDate: [String]
    $filterStartDate: [String]
    $filterProjectManager: String
    $filterEquipment: String
    $filterAi: String
    $filterCity: String
    $openSlots: Boolean
    $limit: Int
    $offset: Int
    $order: String
    $orderBy: String
  ) {
    allMediationOrders(
      filterAccountType: $filterAccountType
      filterStatus: $filterStatus
      filterNumber: $filterNumber
      filterCreationDate: $filterCreationDate
      filterStartDate: $filterStartDate
      filterProjectManager: $filterProjectManager
      filterEquipment: $filterEquipment
      filterAi: $filterAi
      filterCity: $filterCity
      openSlots: $openSlots
      limit: $limit
      offset: $offset
      order: $order
      orderBy: $orderBy
    ) {
      mediationOrders {
        ${EVENT_LIST_ROW}
      }
      mediationOrderCount {
        ${EVENT_LIST_COUNTS}
      }
      ${EVENT_LIST_BREAKDOWN}
    }
  }
`;

// The City filter of the two event lists: one option per city however the
// projects type it, with how many name it, and one Remote for every remote
// spelling (lingoserver util/eventCity.js).
export const INTERPRETATION_PROJECT_CITIES = gql`
  query InterpretationProjectCities {
    interpretationProjectCities {
      city
      count
      remote
    }
  }
`;

export const MEDIATION_PROJECT_CITIES = gql`
  query MediationProjectCities {
    mediationProjectCities {
      city
      count
      remote
    }
  }
`;

// Indirizzo del Portale Mediatori, dalla configurazione del server. Query
// PUBBLICA: la pagina di rimando deve funzionare anche per un mediatore non
// autenticato in Universe — è l'unico link che ha ricevuto.
export const GET_MEDIATOR_PORTAL_URL = gql`
  query MediatorPortalUrl {
    mediatorPortalUrl
  }
`;

// Un'allocazione è di mediazione? In caso affermativo torna il link al Portale
// Mediatori, altrimenti null. PUBBLICA: serve prima della login, al mediatore
// che apre un link email vecchio (non ha credenziali Universe).
export const GET_MEDIATOR_ASSIGNMENT_REDIRECT = gql`
  query MediatorAssignmentRedirect($allocationId: ID!) {
    mediatorAssignmentRedirect(allocationId: $allocationId)
  }
`;

// Link "apri proposta" che il vendor ha ricevuto via email per un'allocazione:
// il PM lo copia dal dettaglio progetto e lo condivide su altri canali quando
// il vendor non apre l'email. kind: "pr" per le allocazioni di revisione.
export const ALLOCATION_VENDOR_LINK = gql`
  query AllocationVendorLink($allocationId: ID!, $kind: String) {
    allocationVendorLink(allocationId: $allocationId, kind: $kind)
  }
`;

// ==============> ACCOUNT ACCESS <================
// Audit trail of every activate / deactivate / delete / blacklist run against
// one employee or vendor, newest first, with the outcome of each system
// (AUTH_UNIFICATION.md §2.4). Shown by AccessAuditTable on the Team cards and
// on the vendor profile.
export const ACCESS_AUDIT_BY_TARGET = gql`
  query AccessAuditByTarget(
    $targetType: AccessTargetType!
    $targetId: ID!
    $limit: Int
  ) {
    accessAuditByTarget(
      targetType: $targetType
      targetId: $targetId
      limit: $limit
    ) {
      id
      action
      outcome
      reason
      attempts
      startedAt
      finishedAt
      actor {
        name
        portal
      }
      steps {
        system
        ok
        skipped
        note
        error
        at
      }
    }
  }
`;

// What a vendor did that must be kept: any of it and Delete cannot erase,
// only Pause applies (decision 29/10/2026, schema/access).
export const VENDOR_HISTORY = gql`
  query VendorHistory($id: ID!) {
    vendorHistory(id: $id) {
      allocations
      prAllocations
      bookings
      invoices
      issues
    }
  }
`;

// Every vendor erased for good, with who did it, when and why: the audit row
// outlives the record (Vendors → Deleted).
export const ERASED_VENDORS = gql`
  query ErasedVendors($search: String, $limit: Int) {
    erasedVendors(search: $search, limit: $limit) {
      id
      targetId
      targetName
      targetEmail
      reason
      outcome
      startedAt
      actor {
        name
        portal
      }
    }
  }
`;

// The financial seal page (30/10/2026, lingoserver util/financialSealControl.js):
// the projects whose seal and status disagree, and every opening and closing
// of the seal in [from, to). An admin or a Senior Manager.
export const FINANCIAL_SEAL_CONTROL = gql`
  query FinancialSealControl($from: String, $to: String) {
    financialSealControl(from: $from, to: $to) {
      from
      to
      cyclesTruncated
      issues {
        key
        kind
        orderId
        orderNumber
        client
        projectManager
        status
        issue
        since
        by
        reason
        margin
        delivered
      }
      cycles {
        key
        kind
        orderId
        orderNumber
        client
        projectManager
        status
        openedAt
        openedBy
        reason
        closedAt
        closedBy
        open
        known
        before {
          price
          cost
          margin
        }
        after {
          price
          cost
          margin
        }
        lines {
          kind
          label
          before
          after
        }
      }
    }
  }
`;

// What a project's history recorded while one reopening of its seal was open
// (from its opening to its closing, or to now), read when the row unfolds.
export const FINANCIAL_SEAL_CHANGES = gql`
  query FinancialSealChanges($orderId: ID!, $from: String!, $to: String) {
    financialSealChanges(orderId: $orderId, from: $from, to: $to) {
      truncated
      rows {
        _id
        uid
        action
        type
        DateAndTime
        description
        user {
          id
          name
        }
      }
    }
  }
`;

// Gli incarichi che il mese di una fattura fornitore copre, letti dalle
// allocazioni di Universe: la fattura del mediatore arriva dal portale con una
// riga sola e non dice su quali CI-MC si è lavorato.
export const VENDOR_MONTH_JOBS = gql`
  query VendorMonthJobs($vendorID: String!, $month: String!) {
    vendorMonthJobs(vendorID: $vendorID, month: $month)
  }
`;

// AG Mediators — la convalida mensile del PM (report 16/10/2026): un rigo per
// mediatore nel mese, con i numeri del riepilogo che il portale mostra e lo
// stato della convalida; e il riepilogo intero di un mediatore.
export const AG_BILLING_OVERVIEW = gql`
  query AgBillingOverview($period: String!) {
    agBillingOverview(period: $period) {
      billingPeriod
      periodWords
      window {
        state
        exception
        opensAt
        closesAt
        lastDay
        message
      }
      counts
      rows {
        vendor {
          id
          name
          email
        }
        billingPeriod
        channel
        stage
        expectedCount
        eligibleCount
        billedCount
        pendingCount
        validatedTotal
        estimatedTotal
        eligibleTotal
        approval {
          state
          approvedBy
          approvedAt
          note
          statementVersion
          revokedAt
          revokeReason
        }
        submission {
          invoiceId
          invoiceNumber
          receivedAt
          status
          origin
          total
          documentStatus
          documentReason
          own
        }
        canSubmit
        canApprove
        blockingReasons
      }
    }
  }
`;

export const AG_BILLING_STATEMENT = gql`
  query AgBillingStatement($vendorId: ID!, $period: String!) {
    agBillingStatement(vendorId: $vendorId, period: $period) {
      billingPeriod
      periodWords
      channel
      flow
      draft {
        id
        status
        draftedAt
        submittedAt
        documentId
        linesCount
        eligibleTotal
        financeInvoiceId
      }
      draftState
      vendor {
        id
        name
        email
      }
      canSubmit
      canApprove
      approvalState
      window {
        state
        exception
        opensAt
        closesAt
        lastDay
        message
      }
      blockingReasons
      blockingTexts
      expectedCount
      eligibleCount
      billedCount
      pendingCount
      validatedTotal
      validatedService
      validatedExpense
      eligibleTotal
      billedTotal
      estimatedTotal
      statementVersion
      approval {
        state
        approvedBy
        approvedAt
        note
        statementVersion
        revokedAt
        revokeReason
      }
      submission {
        invoiceId
        invoiceNumber
        receivedAt
        status
        origin
        total
        documentStatus
        documentReason
        own
      }
      pending {
        allocationId
        projectCode
        serviceDate
        status
        estimatedAmount
        reason
        reasonText
      }
      lines {
        id
        projectCode
        serviceDate
        billableHours
        hoursBasis
        approvedMinutes
        hourlyRate
        serviceAmount
        expenseAmount
        totalAmount
        status
      }
      documents {
        id
        fileName
        url
        status
        uploadedAt
        scan
        reviewNote
      }
    }
  }
`;
// The roster row as the list and the finder read it.
const HOSTESS_ROW_FIELDS = `
        id
        firstName
        lastName
        email
        phone
        image
        gender
        dob
        city
        province
        region
        country
        nationalities
        heightCm
        source
        state
        pausedUntil
        closingRequestedAt
        registeredAt
        resume
        photoCount
        services {
          serviceType
          family
          hourRate
          dayRate
          experienceYears
          languages {
            language
            level
          }
        }
        languages {
          language
          level
        }
        hourRate
        dayRate
        isBlacklisted
        blacklistHostess
        blacklistReason
        blacklistUpdatedAt
        jobsDone
        lastJobAt
`;
// Vendors → Hostess: every hostess and steward, apart from the interpreters.
// `offset` is a PAGE NUMBER, as on the other rosters.
export const HOSTESS_ROSTER = gql`
  query HostessRoster(
    $search: String
    $services: [String]
    $languages: [String]
    $place: String
    $states: [String]
    $sources: [String]
    $orderBy: String
    $order: String
    $offset: Int
    $limit: Int
  ) {
    hostessRoster(
      search: $search
      services: $services
      languages: $languages
      place: $place
      states: $states
      sources: $sources
      orderBy: $orderBy
      order: $order
      offset: $offset
      limit: $limit
    ) {
      filterCount
      totalCount
      stateCounts {
        key
        count
      }
      sourceCounts {
        key
        count
      }
      rows {
${HOSTESS_ROW_FIELDS}
      }
    }
  }
`;
// The finder of an event: the same roster, with what each hostess's calendar
// says about the event's days. Asked apart, so a server without it loses the
// finder only, never the Vendors → Hostess list.
export const HOSTESS_FINDER_ROSTER = gql`
  query HostessFinderRoster(
    $search: String
    $services: [String]
    $languages: [String]
    $place: String
    $states: [String]
    $sources: [String]
    $orderBy: String
    $order: String
    $offset: Int
    $limit: Int
    $eventFrom: String
    $eventTo: String
    $projectType: String
    $clientId: String
    $nearCity: String
    $nearCountry: String
  ) {
    hostessRoster(
      search: $search
      services: $services
      languages: $languages
      place: $place
      states: $states
      sources: $sources
      orderBy: $orderBy
      order: $order
      offset: $offset
      limit: $limit
      eventFrom: $eventFrom
      eventTo: $eventTo
      projectType: $projectType
      clientId: $clientId
      nearCity: $nearCity
      nearCountry: $nearCountry
    ) {
      filterCount
      totalCount
      stateCounts {
        key
        count
      }
      sourceCounts {
        key
        count
      }
      rows {
${HOSTESS_ROW_FIELDS}
        eventsDone
        clientEvents
        distanceKm
        eventAvailability {
          verdict
          periods {
            from
            to
            available
            note
          }
        }
      }
    }
  }
`;
// The hostess side of one vendor record, asked apart from the record itself:
// against a server without it only this sheet goes, never the whole page.
export const VENDOR_HOSTESS_PROFILE = gql`
  query VendorHostessProfile($id: ID!) {
    getVendorDataById(id: $id) {
      id
      blacklistHostess
      imageOriginal
      hostess {
        source
        state
        registeredAt
        linkedAt
        closingRequestedAt
        deleteAfter
        pausedUntil
        publicProfile
        promotionalImages
        opportunityEmails
        newsletterEmails
        termsAcceptedAt
        province
        nationalities
        heightCm
        hairColor
        eyeColor
        sizes {
          top
          shirt
          blazer
          bottom
          shoes
        }
        portfolio
        services {
          serviceType
          family
          hourRate
          dayRate
          experienceYears
          languages {
            language
            level
          }
        }
        languages {
          language
          level
        }
        availability {
          from
          to
          available
          note
        }
        availabilityUpdatedAt
      }
    }
  }
`;

// Everything else the vendor was asked for at sign-up and on their portal
// (23/10/2026), read apart from LINGUIST_PERSONAL_DETAILS so a server older
// than this query loses these sheets only, as VENDOR_HOSTESS_PROFILE does.
export const VENDOR_RECORD_DETAILS = gql`
  query VendorRecordDetails($id: ID!) {
    getVendorDataById(id: $id) {
      id
      profileStatus
      registrationSource
      isOnBoardingCompleted
      isOnBoardingStepOneCompleted
      isOnBoardingStepTwoCompleted
      isOnBoardingStepThreeCompleted
      completedSubSteps
      onboardingProgress {
        stepOne
        stepTwo
        stepThree
      }
      availabilityStatus
      availabilityReason
      unavailabilityStartDate
      unavailabilityEndDate
      autoSetAvailable
      tradosEmail
      personalInfo {
        address {
          state
          postalCode
          province
        }
      }
      businessInfo {
        website
        businessType
        annualTurnover
        employeesCount
      }
      education {
        degree
        college
        areaOfStudy
        startDate
        endDate
      }
      experience {
        jobTitle
        company
        startDate
        endDate
        description
      }
      paymentInfo {
        iban
        bic
        bankname
        taxid
      }
      billingAddress {
        address
        address2
        city
        postalCode
        country
      }
      preferences {
        contactMethod
        timezone
        privacy
        termsAndConditions
        termsAcceptedAt
        termsVersion
      }
      availability {
        jobType
        availabilityTime
        experience
        professionalExp
        translationOutputPerDay
      }
      catTools {
        tools
        softwares
        tradosEmail
      }
      mediationServices {
        serviceType
        desc
        langCombinations {
          sourceLanguage
          targetLanguage
          experienceYears
          minuteRate
          hourRate
          dayRate
          isNative
          level
          direction
          certifications
        }
      }
      mediationExpertise {
        sector
        subSectors
        notes
      }
    }
  }
`;

// A vendor's whole log (23/10/2026): the mail written to them from their page
// and every project email they were a recipient of, with the order each row
// was about (`projectNumber`). Intranet staff only. Same selection as the
// uuid query, so the shared log component draws both alike.
export const GET_COMMUNICATIONS_BY_VENDOR = gql`
  query GetCommunicationsByVendor(
    $vendorId: String!
    $search: String
    $group: CommunicationGroup
    $offset: Int
    $limit: Int
  ) {
    getCommunicationsByVendor(
      vendorId: $vendorId
      search: $search
      group: $group
      offset: $offset
      limit: $limit
    ) {
      communications {
        id
        uuid
        projectType
        projectNumber
        type
        subject
        bodyHtml
        bodyText
        senderName
        senderEmail
        recipients {
          email
          name
          type
        }
        attachments {
          filename
          url
          size
          mimeType
          downloadUrl
        }
        sendgridMessageId
        status
        timeline {
          status
          timestamp
        }
        sentAt
        deliveredAt
        openedAt
        clickedAt
        failureReason
        isAutomatic
        sentByUserId
        sentByUserName
        createdAt
        updatedAt
        source
        direction
        mailboxEmail
        outlookWebLink
        conversationId
        emailMessageId
        threadCount
      }
      communicationsCount {
        filterCount
        totalCount
      }
      preBooking {
        totalCount
        openedCount
        issueCount
        recipientCount
      }
    }
  }
`;

export const PRIVATE_CLIENTS_REPORT = gql`
  query PrivateClientsReport($from: String!, $to: String!) {
    getPrivateClientsReport(from: $from, to: $to)
  }
`;
